'use strict';

// ============================================================
// ASSETS 3D
// URL du modele, de l'environnement lumineux et de la texture de bruit.
// Le modele est celui livre par le freelance, en test.
// ============================================================
const SC_ASSETS = window.SwitchConfiguratorAssets || {
  glb:         'https://cdn.shopify.com/3d/models/5179753153d33832/switchconfigurator7.glb',
  hdr:         'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/metal_01_632f69d3-18e8-4313-9c79-0a5f9f7ec425.hdr?v=1787527578',
  noiseNormal: 'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/noisenormal_195e5b51-00d8-41cb-b9cf-d6f5dc37558a.png?v=1787527580',
  basicFont:   '',
};

// ============================================================
// CAPTURE DE LA CONFIGURATION
// Adresse du Worker Cloudflare qui range la capture dans les Fichiers Shopify
// et renvoie son lien cdn.shopify.com (voir configurateur_capture/worker.js).
// Vide = pas de capture, le panier garde la photo de base.
// ============================================================
const SC_PREVIEW_ENDPOINT = 'https://studio-timeless-preview.pblastov.workers.dev';
function A(key, fallback) {
  return (SC_ASSETS && SC_ASSETS[key]) ? SC_ASSETS[key] : (fallback || key);
}
function TEX(key) {
  return (SC_ASSETS.textures && SC_ASSETS.textures[key]) ? SC_ASSETS.textures[key] : `textures/${key}.png`;
}

// ─────────────────────────────────────────────
// FONT LOADING
// ─────────────────────────────────────────────
let basicFontReady = true;
let basicFontFace  = null;
// (function loadBasicFont() {
//   const ff = new FontFace('BasicCanvas', 'url(https://cdn.shopify.com/s/files/1/0984/1075/8528/files/basic.ttf?v=1780921054)');
//   ff.load().then(loaded => {
//     document.fonts.add(loaded);
//     basicFontFace = loaded;
//     basicFontReady = true;
//   }).catch(() => { basicFontReady = true; });
// })();

// ─────────────────────────────────────────────
// TW — all tunable values in one object
// ─────────────────────────────────────────────
const TW = {
  // Lights
  shadowOn:false, lightOn:true,
  ambient:0, keyLight:0, fillLight:0, backLight:1.35,
  lightX:6.7, lightY:0.6, lightZ:1.5,
  exposure:0.48, hdrRot:1.14, hdrIntensity:.82,

  // ── PLATE FINISH PROPERTIES ───────────────────────────────
  plateMetal:0.74, plateRough:0.72, plateNormal:0.42,
  plateEnv:1.4,    uvPlate:2.0,

  satinbrass_metal:1,     satinbrass_rough:0.65,  satinbrass_normal:0.18, satinbrass_uvX:0.5, satinbrass_uvY:0.5, satinbrass_rot:0,
  antiquebrass_metal:0.68,antiquebrass_rough:0.47, antiquebrass_normal:0.14,antiquebrass_uvX:0.35,antiquebrass_uvY:0.55,antiquebrass_rot:6.28,
  unlacquered_metal:0.66, unlacquered_rough:0.36, unlacquered_normal:0.1,unlacquered_uvX:1.4,unlacquered_uvY:1.65,unlacquered_rot:3.38,
  hammered_metal:0.6,     hammered_rough:0.39,    hammered_normal:0.27,    hammered_uvX:0.6,  hammered_uvY:1.2,   hammered_rot:0,
  agedbronze_metal:0.61,  agedbronze_rough:0.45,  agedbronze_normal:0.91, agedbronze_uvX:1.0, agedbronze_uvY:1.0, agedbronze_rot:6.28,
  stainless_metal:0.78,   stainless_rough:0.53,   stainless_normal:0.18,  stainless_uvX:0.5,  stainless_uvY:1.0,  stainless_rot:0,
  matte_black_metal:0.68, matte_black_rough:0.42, matte_black_normal:0.1, matte_black_uvX:1.0,matte_black_uvY:1.0,matte_black_rot:0,
 
matte_white_metal:0.0, matte_white_rough:0.92, matte_white_normal:0.0, matte_white_uvX:1.0, matte_white_uvY:1.0, matte_white_rot:0, matte_white_env:2.4,
  // Blancheur de la plaque Matte White.
  // matte_white_color : teinte de base, #ffffff = blanc pur.
  // matte_white_env   : captation de lumiere, monte pour eclaircir.
  // matte_white_glow  : emission propre, releve les zones d'ombre et aplatit
  //                     le rendu. 0 = aucune, 0.35 = tres blanc et plat.
  matte_white_color:'#ffffff', matte_white_glow:0.22,
  // ── CONTROLS FINISH PROPERTIES ────────────────────────────
  ctrlMetal:0.82, ctrlRough:0.28, ctrlNormal:3.28, ctrlEnv:0.9,

  ctrl_brass_metal:0.95,      ctrl_brass_rough:0.63,      ctrl_brass_normal:0.53,      ctrl_brass_uvX:1.05,     ctrl_brass_uvY:1.0,     ctrl_brass_rot:0.16,
  ctrl_white_metal:0.0,       ctrl_white_rough:0.15,      ctrl_white_normal:0.0,       ctrl_white_uvX:1.0,      ctrl_white_uvY:1.0,      ctrl_white_rot:0,
  ctrl_fullblack_metal:0.86,  ctrl_fullblack_rough:0.08,  ctrl_fullblack_normal:0.42,  ctrl_fullblack_uvX:1.0,  ctrl_fullblack_uvY:1.0,  ctrl_fullblack_rot:0,
  ctrl_stainless_metal:0.73,  ctrl_stainless_rough:0.56,  ctrl_stainless_normal:0.57,  ctrl_stainless_uvX:1.05, ctrl_stainless_uvY:1.0,  ctrl_stainless_rot:0,
  ctrl_agedbronze_metal:0.85, ctrl_agedbronze_rough:0.1,  ctrl_agedbronze_normal:0.66, ctrl_agedbronze_uvX:1.0, ctrl_agedbronze_uvY:1.0, ctrl_agedbronze_rot:0,

  // UV scales (GLB controls only — plate UVs handled per-finish above)
  uvDimmer:0.9, uvToggle:1.75, uvDoubleToggle:0.4, uvBlank:0.3, uvRocker:2.7,
  uvScrew:0.95, uvKnob:1.05, uvGround:0.03,

  // Normal/rotation
  uvSideNormal:0.1,
  rotAntique:5.6, rotUnlacquered:0.95,
  rotSide:2.35, rotSideAntique:4.0, rotSideUnlacquered:0.95,

  // Shadow decal
  shadowBlur:0, shadowOpacity:0, shadowSize:0.005,
  shadowDecalOffY:0.1, shadowDecalOffY2:0.9,

  // Engrave
  decalOffX:0, decalOffY:0, decalOffZ:0, decalScale:1.1,
  // La gravure courbee etait posee a 0.55, soit exactement sur la vis du haut
  // (elle est a 0.54). On l'aligne sur la hauteur de la version droite, qui
  // tombe juste entre la commande et la vis. Monte pour la remonter.
  posYSingleStraight: 0.34, posYSingleCurve:    0.34,
  posYDoubleStraight: 0.88, posYDoubleCurve:    0.90,
  // Appareils a DEUX commandes (Double Retro Toggle, Toggle + Dimmer) : une
  // gravure par commande. Reperes de la plaque, utiles pour regler sans tatonner :
  //   trou du haut  : de 0.24 a 0.46     trou du bas : de -0.46 a -0.24
  //   trous de vis  : a +/- 0.83, rayon 0.04
  // Le texte se dessine 0.10 AU DESSUS de la valeur posee ici, et la gravure
  // courbee ajoute son cadre sur 0.09 de part et d'autre du texte.
  // Monte la valeur pour remonter la gravure, baisse la pour la descendre.
  posYPairTopStraight: 0.52, posYPairTopCurve: 0.52,
  posYPairBotStraight: -0.18, posYPairBotCurve: -0.18,
  engraveFont:'Helvetica, Arial, sans-serif', engraveColor:'#DFD7AC',
  engraveFontSize:0.07,
  engraveLineY:0.43,
  arcCenterY:0.65, arcOuterR:0.28, arcInnerR:0.16,
  arcSpan:1.9, arcLineWidth:6,
  // Gravure courbee : rayon du texte, et ecart entre le texte et la ligne.
  // Rayon plus petit = courbe plus prononcee.
  arcTextRadius:0.22, arcLineGap:0.8,
  arcTextDepth:0.045, engraveTextY:0.49,
  arcTextDepth_s:0.014, engraveTextY_s:0.45,

  // Camera
  camFOV:38, camNear:0.01, camFar:100, camPosZ:3.5,
  bgColorHex:'#eeece8', tonemapping:'ACES',

  // ── PROCEDURAL PLATE ──────────────────────────────────────
  plateW:         1.32,
  plateH:         2.28,
  plateThickness: 0.04,
  plateRadius:    0.03,
  plateRadiusSeg: 8,

  // Back inset bump
  backInsetW:         1.222,
  backInsetH:         2.16,
  backInsetDepth:     0.005,
  backInsetOffsetY:   0.0,

  // Holes — corner radius
  holeRadius:         0.04,
  holeRadiusSeg:      6,

  // Holes
  holeOffsetY:        0.0,
  holeToggleW:        0.21,
  holeToggleH:        0.47,
  holeToggleRetroR:   0.012,
  holeDoubleToggleW:  0.22,
  holeDoubleGap:      0.7,
  holeRockerW:        0.65,
  holeRockerH:        1.29,
  holeDimmerR:        0.012,
  holeDimmerSeg:      32,

  // ── DEVICE OBJECTS (GLB) ──────────────────────────────────
  devScale:      0.92,
  devOffsetX:    0.02,
  devOffsetY:    0.0,
  devOffsetZ:    0.98,

  // Switch controls
  ctrlOffsetX:   0.0,
  ctrlOffsetY:   0.0,
  ctrlOffsetZ:   0.03,

  // Grounding terminal — dedicated fine-position offset (on top of ctrlOffset)
  groundOffsetX: 0.0,
  groundOffsetY: 0.0,
  groundOffsetZ: -0.104,

  // Retro pole (toggle lever) — dedicated fine-position offset (on top of ctrlOffset)
  poleOffsetX:   0.0,
  poleOffsetY:   0.0,
  poleOffsetZ:   -0.118,

  // Outlet / plate inserts
  insertOffsetX: 0.0,
  insertOffsetY: 0.0,
  insertOffsetZ: 0.0,

  // ── GROUNDING TERMINAL — dedicated noise normal (noisenormal.png) ────────
  // Used for groundingterminal's relief in BOTH the brass and stainless
  // controls finishes (a softer, less busy bump than the shared radial-ring
  // normal the rest of the controls use).
  groundNoiseUVScale:   6.45,   // UV tiling of noisenormal.png
  groundNormalStrength: 1.06,   // normalScale magnitude

  // ── SCREWS ────────────────────────────────────────────────
  screwOffsetX:  0.01,
  screwOffsetY:  -1.16,
  screw1OffsetY: -0.04,
  screw2OffsetY: 0.21,
  screwHoleR:    0.04,
  screwHoleSeg:  16,
  holeScrewX:    0.0,
  holeScrew1Y:   0.0,
  holeScrew2Y:   0.0,

  // ── GANG SPACING ──────────────────────────────────────────
  slotWidthOverride: 1,

  // ── DOUBLE DEVICE SPLIT ───────────────────────────────────
  splitOffset: 1.42,
};

let universalCtrlColor = null;

// ─────────────────────────────────────────────
// LIGHTS
// ─────────────────────────────────────────────
let ambientLight, keyLight, fillLight, backLight;

function onLightSlider(key, val, labelId) {
  const v = parseFloat(val);
  TW[key] = v;
  const el = document.getElementById(labelId);
  if (el) el.textContent = v.toFixed(2);
  updateLights();
}
function updateLights() {
  if (!ambientLight) return;
  const on = TW.lightOn;
  ambientLight.intensity = on ? TW.ambient   : 0;
  keyLight.intensity     = on ? TW.keyLight  : 0;
  fillLight.intensity    = on ? TW.fillLight : 0;
  backLight.intensity    = on ? TW.backLight : 0;
  if (on) keyLight.position.set(TW.lightX, TW.lightY, TW.lightZ);
  if (renderer) renderer.toneMappingExposure = TW.exposure;
  applyHDRRotation();
  updateEnvIntensity();
}
function updateEnvIntensity() {
  if (!scene) return;
  scene.traverse(obj => {
    if (obj.isMesh && obj.material) {
      const mats = Array.isArray(obj.material) ? obj.material : [obj.material];
      mats.forEach(m => {
        if (m.isMeshStandardMaterial) {
          const isCtrl = CONTROLS_TARGETS.some(t => obj.name.startsWith(t)) ||
                         screwClones.some(c => c === obj || (obj.parent && c === obj.parent));
          m.envMapIntensity = (isCtrl ? TW.ctrlEnv : TW.plateEnv) * TW.hdrIntensity;
          m.needsUpdate = true;
        }
      });
    }
  });
}
function applyHDRRotation() {
  if (!window._hdrRawTex || !window._pmremGen || !scene) return;
  window._hdrRawTex.offset.x = TW.hdrRot / (2 * Math.PI);
  window._hdrRawTex.needsUpdate = true;
  const envMap = window._pmremGen.fromEquirectangular(window._hdrRawTex).texture;
  scene.environment = envMap;
  if (scene.background instanceof THREE.Texture) scene.background = envMap;
}

// ─────────────────────────────────────────────
// CONFIG DATA
// ─────────────────────────────────────────────
// ============================================================
// PHOTOS DE RENDU PAR FINITION (version sans 3D)
// Colle ici l'URL CDN de ta photo finale pour chaque finition.
// Laisse '' pour garder la vignette par defaut en attendant.
// ============================================================
const PLATE_PREVIEW_IMAGES = {
  antiquebrass: '',
  unlacquered:  '',
  satinbrass:   '',
  hammered:     '',
  agedbronze:   '',
  stainless:    '',
  matte_black:  '',
  matte_white:  '',
};

// ============================================================
// EXEMPLES DE GRAVURE (photos)
// Colle ici l'URL CDN de tes deux photos d'exemple.
// Laisse '' pour n'afficher que le nom du style en attendant.
// ============================================================
const ENGRAVE_EXAMPLE_IMAGES = {
  straight: 'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/SCR-20260729-dpru.png?v=1785287478',
  curved:   'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/SCR-20260729-dpqn.png?v=1785287479',
};

const PLATE_FINISHES = [
  {id:'antiquebrass', label:'Antique Brass',             swatch:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/magnific_return-exactly-the-bottom_Vdz5umGMMU.jpg?v=1783602615'},
  {id:'unlacquered',  label:'Unlacquered Antique Brass', swatch:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/magnific_return-exactly-the-bottom_l7kczwmgv9.jpg?v=1783602615'},
  {id:'satinbrass',   label:'Satin Brass',               swatch:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/magnific_closeup-macro-product-pho_xgvt6dDjfW.jpg?v=1781571562'},
  {id:'hammered',     label:'Hammered Antique Brass',    swatch:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/magnific_product-is-white-macro-pr_3Gs5qn5REY_1_991cb878-d1a1-43f0-adcb-9077abeb9f5a.png?v=1781573943'},
  {id:'agedbronze',   label:'Aged Bronze',               swatch:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/magnific_warm-dark-golden-tones-wi_aQTWk0zfSh.png?v=1781571777'},
  {id:'stainless',    label:'Stainless Steel',           swatch:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/magnific_product-is-stainless-grey_YVOUO4kWeC.jpg?v=1781573742'},
  {id:'matte_black',  label:'Matte Black',               swatch:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/magnific_product-is-black-with-ste_SOQCWq1Ub8_00f6db1e-8cdb-4173-b2ac-e2f34266daf9.jpg?v=1781571652'},
  {id:'matte_white',  label:'Matte White',               swatch:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/magnific_product-is-white-with-bra_vu0YJsta47.jpg?v=1781571502'},
];

const CONTROLS_FINISHES = [
  {id:'brass',      label:'Brass',           swatch:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/controls_brass.png?v=1780921033'},
  {id:'agedbronze', label:'Aged Bronze',     swatch:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/plate_agedbronze.png?v=1780921033'},
  {id:'stainless',  label:'Stainless Steel', swatch:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/controls_stainless.png?v=1780921033'},
  {id:'fullblack',  label:'Full Black',      swatch:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/controls_fullblack.png?v=1780921032'},
  {id:'white',      label:'White',           swatch:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/controls_white.png?v=1780921033'},
];

const CONTROLS_TARGETS      = ['Screw','Screw2','ToggleKnob1','groundingterminal','knurledpin','MultipleKnob','MultipleKnob2'];
const TOGGLE_FRAME_TARGETS  = ['toggleframe'];
const OUTLET_COLOR_TARGETS  = ['regularinneroutlet','usbacinneroutlet','innerdoubleusb','GFCIouter'];
const FIXED_OBJECTS         = ['GFCI','usbacouteroutlet','regularouteroutlet','outerdoubleusb'];

const ALL_DEVICE_OBJECTS = [
  'Blank','Dimmer','DoubleToggle','Toggle','Rocker',
  '120vDimmerSingle','3Way120vDimmer','lowvol','steplessrotary',
  'MultipleKnob','MultipleKnob2','dimmersupport',
  'toggleframe','ToggleKnob1','singlepole','toggle4way',
  'groundingterminal','retropole','knurledpin',
  'regularinneroutlet','regularouteroutlet',
  'usbacinneroutlet','usbacouteroutlet',
  'innerdoubleusb','outerdoubleusb',
  'GFCI','GFCIouter',
];

const NO_QMARK_DEVICES = new Set(['toggle_opening','toggle_knurled','toggle_knurled_4way','toggle_knurled_single','blank']);

const SECTION_INFO = {
  'Dimmers': 'The single pole dimmer turns the light on and off with a click as you rotate it. The three way version switches on and off through a push button instead.',
  'Toggle Switch': 'Simple on and off, with no dimming.',
};

const DEVICE_INFO = {
  dimmer_120v:'A TRIAC wall dimmer for standard 120V lighting. Press the knob to switch the light on or off, then turn it to set the brightness. It runs from one location. Your LED bulbs or drivers need to be TRIAC rated so the light stays smooth and quiet.',
  dimmer_3way:'A TRIAC dimmer built for two control points. Pair it with a regular three way on off switch at the other location. Press to switch on or off, turn to dim. LEDs should be TRIAC rated to stay flicker free. It also runs on its own from a single location.',
  dimmer_010v:'Made to drive fixtures and LED drivers that accept a 0 to 10V signal. It sends a low voltage control signal to set brightness rather than powering the fixture directly. A common pick for architectural and commercial lighting.',
  dimmer_strip:'Built for low voltage LED strips on 12 to 24V DC. It sets brightness by regulating the DC output through PWM. It is not meant for standard 120V household circuits.',
  fan_speed:'A manual speed control for standard 120V paddle ceiling fans. It will not work with smart fans, remote driven fans, or fans that carry their own electronic module.',
  toggle_retro:'Flexible wiring that covers both single pole and three way installations.',
  toggle_double_retro:'Two retro toggles set one above the other in a single Decora style opening. Each one drives its own circuit. Wire it single pole or three way as needed.',
  toggle_double_knurled:'Two knurled toggles set one above the other in a single Decora style opening. Each one drives its own circuit. Wire it single pole or three way as needed.',
  toggle_plus_dimmer:'Runs two separate lights from one plate. The toggle handles on and off, single pole or three way across two spots. The dimmer handles on, off and brightness from one spot.',
  knurled_plus_dimmer:'Runs two separate lights from one plate. The toggle handles on and off, single pole or three way across two spots. The dimmer handles on, off and brightness from one spot.',
  outlet_rocker:'A universal rectangular cutout that fits rocker switches, GFCI receptacles and most other Decora style devices.',
  outlet_regular:'A standard duplex receptacle for everyday wall use.',
  outlet_usbc:'A receptacle with USB A and USB C ports built in, so you can charge straight from the wall.',
  outlet_double_usbc:'A receptacle with two USB C ports for quicker charging of your devices.',
  outlet_gfci:'A ground fault receptacle made for wet or damp rooms such as kitchens and bathrooms.',
};
const DEVICES = {
  blank:                {label:'Blank Plate',                       thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/16.png?v=1782347873',                show:['Blank'],                                                                              engravePos:'single', price:0},
  dimmer_120v:          {label:'Single Pole 120V Dimmer',           thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/31.png?v=1782347873',          show:['Dimmer','MultipleKnob','120vDimmerSingle'],                                         engravePos:'single', price:93},
  dimmer_3way:          {label:'3–Way 120V Dimmer',                 thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/31.png?v=1782347873',          show:['Dimmer','MultipleKnob','3Way120vDimmer'],                                           engravePos:'single', price:93},
  dimmer_010v:          {label:'0–10V LED Dimmer (Low-Voltage)',    thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/31.png?v=1782347873',          show:['Dimmer','MultipleKnob','lowvol'],                                                   engravePos:'single', price:93},
  dimmer_strip:         {label:'12–24V LED Strip Dimmer',           thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/31.png?v=1782347873',          show:['Dimmer','MultipleKnob','lowvol'],                                                   engravePos:'single', price:63},
  fan_speed:            {label:'Fan Speed Control (120V, Stepless Rotary)', thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/31.png?v=1782347873',          show:['Dimmer','MultipleKnob','steplessrotary'],                                           engravePos:'single', price:93},
  toggle_knurled_single:{label:'Knurled Toggle Single Pole / 3way', thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/27.png?v=1782347874',show:['ToggleKnob1','toggleframe','singlepole'],                                  engravePos:'single', price:27, hasToggleColor:true},
  toggle_knurled_4way:  {label:'Knurled Toggle 4 way',             thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/27.png?v=1782347874',show:['ToggleKnob1','toggleframe','toggle4way'],                      engravePos:'single', price:35, hasToggleColor:true},
  toggle_retro:         {label:'Retro Toggle Single Pole / 3way', displayLabel:'Retro Toggle Single Pole / 3way', thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/26.png?v=1782347874',  show:['Dimmer','groundingterminal','retropole'],                                                    engravePos:'single', price:35},
  toggle_retro_4way:    {label:'Retro Toggle 4 way', thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/26.png?v=1782347874',  show:['groundingterminal','retropole'],                                                    engravePos:'single', price:37},
  toggle_double_retro:  {label:'Double Retro Toggle Single Pole / 3way', displayLabel:'Double Retro Toggle Single Pole / 3way', thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/29.png?v=1782347875',  show:['DoubleToggle'],                                                                     engravePos:'double', doubleClone:['groundingterminal','retropole'], price:47},
  toggle_knurled:       {label:'Knurled Toggle',                   thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/25.png?v=1782347875',       show:['Dimmer','knurledpin','retropole'],                                                  engravePos:'single', price:35},
  toggle_double_knurled:{label:'Double Knurled Toggle',            thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/30.png?v=1782347873',show:['DoubleToggle'],                                                                     engravePos:'double', doubleClone:['knurledpin','retropole'], price:47},
  toggle_plus_dimmer:   {label:'Toggle + Dimmer',                  thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/23.png?v=1782347875',   show:['DoubleToggle'],                                                                     engravePos:'double', splitOffset:{up:['retropole','groundingterminal'],down:['MultipleKnob','dimmersupport']}, price:103},
  knurled_plus_dimmer:  {label:'Knurled Toggle + Dimmer',          thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/24.png?v=1782347874',  show:['DoubleToggle'],                                                                     engravePos:'double', splitOffset:{up:['retropole','knurledpin'],down:['MultipleKnob','dimmersupport']}, price:103},
  toggle_opening:       {label:'Toggle Opening',                   thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/22.png?v=1782347873',       show:['Toggle'],                                                                           engravePos:'single', price:0},
  outlet_rocker:        {label:'Rocker / GFCI opening',            thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/17.png?v=1782347872',        show:['Rocker'],                                                                           engravePos:'single', price:0},
  outlet_regular:       {label:'Regular Outlet',                   thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/18.png?v=1782347873',       show:['Rocker','regularinneroutlet','regularouteroutlet'],                                 engravePos:'single', hasAmperage:true, hasOutletColor:true, price:17},
  outlet_usbc:          {label:'USB-A / USB-C',                    thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/19.png?v=1782347873',          show:['Rocker','usbacinneroutlet','usbacouteroutlet'],                                     engravePos:'single', hasAmperage:true, hasOutletColor:true, price:34},
  outlet_double_usbc:   {label:'Double USB-C Outlet',              thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/20.png?v=1782347873',   show:['Rocker','innerdoubleusb','outerdoubleusb'],                                        engravePos:'single', hasAmperage:true, hasOutletColor:true, price:39},
  outlet_gfci:          {label:'GFCI Outlet',                      thumb:'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/21.png?v=1782347873',          show:['Rocker','GFCI','GFCIouter'],                                                       engravePos:'double', hasAmperage:true, hasOutletColor:true, price:34},
};

// ── RETRO TOGGLE : FINITIONS DE COMMANDES POSSIBLES ─────────────────────────
// Le Retro Toggle n'est fabrique qu'en laiton et en acier. Un appareil en
// contient un des que sa definition utilise 'groundingterminal', la borne de
// terre propre a ce mecanisme : c'est le cas du Retro Toggle seul, du 4 way,
// du Double, et du combo Toggle + Dimmer.
// La liste est DERIVEE de DEVICES, jamais ecrite a la main. Une liste figee ne
// citait que toggle_retro et toggle_double_retro : le combo Toggle + Dimmer et
// le Retro Toggle 4 way, ajoutes plus tard, n'y avaient pas ete reportes, et un
// client a pu commander un Toggle + Dimmer en Aged Bronze (commande ST2311Z).
// Deriver la liste evite que cela se reproduise au prochain appareil ajoute.
const RETRO_MARKER_OBJECT = 'groundingterminal';
const RETRO_ALLOWED_FINISHES = new Set(['brass', 'stainless']);
function deviceHasRetroToggle(devId) {
  const d = DEVICES[devId];
  if (!d) return false;
  const lists = [d.show, d.doubleClone, d.splitOffset && d.splitOffset.up, d.splitOffset && d.splitOffset.down];
  return lists.some(l => Array.isArray(l) && l.indexOf(RETRO_MARKER_OBJECT) !== -1);
}
function plateHasRetroToggle() {
  return state.slots.some(s => deviceHasRetroToggle(s.device));
}

// ── REGLES DE COMPATIBILITE ─────────────────────────────────────────────────
// Regles que le SAV corrigeait a la main sur les commandes :
// 1. Deux variateurs ne se superposent jamais dans un gang. La seule
//    combinaison superposee est le combo Toggle + Dimmer, un seul par plaque.
// 2. La Double USB C n'est fabriquee qu'en 15A (en 20A : la USB A / USB C).
// 3. Conseil seulement : regrouper toggles et variateurs plutot qu'alterner,
//    la plaque se fabrique plus vite. Rien n'est bloque.
const COMBO_DEVICES = new Set(['toggle_plus_dimmer', 'knurled_plus_dimmer']);
const AMP_15A_ONLY = new Set(['outlet_double_usbc']);
const MSG_COMBO = 'Only one Toggle + Dimmer combo fits on a plate. Two dimmers are never stacked in one opening, so use a separate dimmer position instead.';
const MSG_USBC_15A = 'Double USB C outlets are only made in 15A. On a 20A circuit, choose the USB A / USB C outlet.';
function comboUsedElsewhere(slotIndex) {
  return state.slots.some((s, i) => i !== slotIndex && i < state.gangCount && COMBO_DEVICES.has(s.device));
}
function ampAllowed(devId, amp) {
  return !(amp === '20A' && AMP_15A_ONLY.has(devId));
}
function ruleKind(devId) {
  if (COMBO_DEVICES.has(devId) || devId === 'toggle_opening') return null;
  const cat = CATEGORIES.find(c => c.devices.includes(devId));
  return cat && (cat.id === 'toggle' || cat.id === 'dimmer') ? cat.id : null;
}
// Vrai si toggles et variateurs alternent (toggle, variateur, toggle...).
function plateAlternatesKinds() {
  const kinds = state.slots.slice(0, state.gangCount).map(s => ruleKind(s.device)).filter(Boolean);
  let runs = 0;
  kinds.forEach((k, i) => { if (i === 0 || k !== kinds[i - 1]) runs++; });
  return runs > new Set(kinds).size;
}
// Remet la plaque dans les regles et affiche les notes sous les positions.
function enforcePlateRules() {
  state.slots.forEach(s => { if (!ampAllowed(s.device, s.amperage)) s.amperage = '15A'; });
  const notes = [];
  if (state.slots.slice(0, state.gangCount).filter(s => COMBO_DEVICES.has(s.device)).length > 1) notes.push(MSG_COMBO);
  if (plateAlternatesKinds()) notes.push('Tip: grouping your toggles together and your dimmers together (for example toggle, toggle, dimmer) instead of alternating them makes your plate faster to produce.');
  const holder = document.getElementById('positionDrawers'); if (!holder) return notes;
  let note = document.getElementById('plateRulesNote');
  if (!note) {
    note = document.createElement('div');
    note.id = 'plateRulesNote';
    note.className = 'finish-note';
    holder.parentNode.insertBefore(note, holder.nextSibling);
  }
  note.textContent = notes.join(' ');
  note.style.display = notes.length ? 'block' : 'none';
  return notes;
}

// Catégories pour la nouvelle sélection horizontale. L'ordre des appareils est
// conservé tel quel. Les libellés restent ceux de DEVICES (dépendance Hulk).
const CATEGORIES = [
  {id:'toggle', label:'Toggle', info:SECTION_INFO['Toggle Switch'], devices:['toggle_retro','toggle_retro_4way','toggle_double_retro','toggle_knurled_single','toggle_knurled_4way','toggle_plus_dimmer','toggle_opening']},
  {id:'dimmer', label:'Dimmer', info:SECTION_INFO['Dimmers'],       devices:['dimmer_120v','dimmer_3way','dimmer_010v','dimmer_strip','fan_speed']},
  {id:'outlet', label:'Outlet', info:null,                          devices:['outlet_gfci','outlet_double_usbc','outlet_usbc','outlet_regular','outlet_rocker']},
  {id:'blank',  label:'Blank',  info:null,                          devices:['blank']},
];
function deviceCategory(devId) {
  for (const c of CATEGORIES) if (c.devices.includes(devId)) return c.id;
  return 'toggle';
}

function getSlotWidth() {
  return (TW.slotWidthOverride > 0) ? TW.slotWidthOverride : TW.plateW;
}

const NO_SHADOW_OBJECTS = new Set([
  'MultipleKnob','MultipleKnob2','ToggleKnob1','groundingterminal','knurledpin',
  'toggleframe','lowvol','steplessrotary','singlepole','toggle4way','retropole',
  'dimmersupport','120vDimmerSingle','3Way120vDimmer',
]);

// engraveText  : gravure unique, ou gravure de la commande du HAUT sur un
//                appareil a deux commandes.
// engraveText2 : gravure de la commande du BAS, uniquement sur ces appareils.
const DEFAULT_SLOT = () => ({device:'dimmer_120v', amperage:'15A', outletColor:'black', toggleColor:'black', engraveText:'', engraveText2:'', engraveStyle:'straight'});
const GANG_SLOT    = () => ({device:'outlet_rocker', amperage:'15A', outletColor:'black', toggleColor:'black', engraveText:'', engraveText2:'', engraveStyle:'straight'});

const VARIANT_BY_GANG = {
  1: 58251583127936, // Gang 1
  2: 58251583160704, // Gang 2
  3: 58251583193472, // Gang 3
  4: 58251583226240, // Gang 4
  5: 58251583259008, // Gang 5
};

// Prix de base par taille de plaque — DOIT correspondre EXACTEMENT à l'option "Plate Size" dans Hulk
const PLATE_PRICE_BY_GANG = { 1: 57, 2: 72, 3: 92, 4: 129, 5: 165 };

// Vignettes : Shopify redimensionne les images a la volee (parametre width),
// pour ne pas telecharger des photos de 100 a 300 Ko affichees en 20 a 200 px.
// La photo pleine taille reste disponible (photo) pour la visionneuse.
function cdnWidth(url, w) {
  if (!url || url.indexOf('cdn.shopify.com') === -1 || /[?&]width=/.test(url)) return url;
  return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
}
PLATE_FINISHES.forEach(f => { f.photo = f.swatch; f.swatch = cdnWidth(f.swatch, 200); });
CONTROLS_FINISHES.forEach(f => { f.swatch = cdnWidth(f.swatch, 200); });
Object.keys(DEVICES).forEach(k => { const d = DEVICES[k]; if (d && d.thumb) d.thumb = cdnWidth(d.thumb, 240); });
Object.keys(ENGRAVE_EXAMPLE_IMAGES).forEach(k => { ENGRAVE_EXAMPLE_IMAGES[k] = cdnWidth(ENGRAVE_EXAMPLE_IMAGES[k], 420); });


const state = {plateFinish:'satinbrass', controlsFinish:'brass', gangCount:1, activePos:0, viewCat:null, slots:[DEFAULT_SLOT()]};

// ─────────────────────────────────────────────
// THREE GLOBALS
// ─────────────────────────────────────────────
let scene, camera, renderer, orbitControls, model;
let objectMap = {}, originalPositions = {}, fixedMaterialsCache = {};
let slotClones = {}, screwClones = [], shadowDecals = [], engraveDecals = {};
let threeReady = false;
let isAnimating = false;
let plateMgr = null;

// Vue de depart validee : plaque tournee vers la droite a 32 degres et
// camera legerement basse, a l'horizontale. Inverse le signe de x pour
// tourner de l'autre cote. Plus d'angle : x = -5*sin(angle), z = 5*cos(angle).
// y plus negatif = camera plus basse.
const CAM_INITIAL      = { x:-2.65, y:0, z:4.24 };
const CAM_ZOOM_PER_GANG = 1.4;

// Sur mobile la vue etait trop lointaine, et le recul par gang trop marque.
// 0.7 = 30 pour cent plus proche. Baisse pour rapprocher encore, monte vers 1
// pour revenir au cadrage du PC. Le recul par gang suit le meme facteur.
const CAM_MOBILE_ZOOM = 0.7;

// Inclinaison de la plaque autour de l'axe horizontal, en radians.
// Positif = le haut bascule vers l'arriere, la plaque penche vers le bas.
// Negatif = l'inverse. 0.05 vaut environ 3 degres.
const MODEL_TILT_X = 0;
function camZoomFactor() {
  return (window.innerWidth <= 860) ? CAM_MOBILE_ZOOM : 1;
}
// Correction par taille : 1.1 recule de 10 pour cent, donc dezoome un peu.
// La 1 Gang etait trop rapprochee. Ajoute d'autres tailles ici si besoin.
const CAM_GANG_ADJUST = { 1: 1.1 };
// Position de camera pour un nombre de gangs donne, angle de vue preserve.
function camViewFor(gangCount) {
  const f = camZoomFactor();
  const g = Math.max(1, gangCount || 1);
  const a = CAM_GANG_ADJUST[g] || 1;
  return {
    x: CAM_INITIAL.x * f * a,
    y: CAM_INITIAL.y * f * a,
    z: (CAM_INITIAL.z * f + (g - 1) * CAM_ZOOM_PER_GANG * f) * a
  };
}

// ═══════════════════════════════════════════════════════════════════════════════
// PROCEDURAL PLATE GEOMETRY
// ═══════════════════════════════════════════════════════════════════════════════

function makeRoundedRectShape(w, h, r, segs) {
  r = Math.min(r, w / 2 - 0.001, h / 2 - 0.001);
  const hw = w / 2, hh = h / 2;
  const shape = new THREE.Shape();
  shape.moveTo(-hw + r, -hh);
  shape.lineTo( hw - r, -hh);
  shape.absarc( hw - r, -hh + r, r, -Math.PI / 2, 0, false);
  shape.lineTo( hw,      hh - r);
  shape.absarc( hw - r,  hh - r, r, 0, Math.PI / 2, false);
  shape.lineTo(-hw + r,  hh);
  shape.absarc(-hw + r,  hh - r, r, Math.PI / 2, Math.PI, false);
  shape.lineTo(-hw,     -hh + r);
  shape.absarc(-hw + r, -hh + r, r, Math.PI, Math.PI * 1.5, false);
  return shape;
}

function addRoundedRectHole(shape, cx, cy, hw, hh, r, segs) {
  r = Math.min(r, hw - 0.001, hh - 0.001);
  segs = segs || 6;
  const hole = new THREE.Path();
  hole.moveTo(cx - hw, cy - hh + r);
  hole.absarc(cx - hw + r, cy - hh + r, r, Math.PI,       Math.PI * 1.5, false);
  hole.lineTo(cx + hw - r, cy - hh);
  hole.absarc(cx + hw - r, cy - hh + r, r, Math.PI * 1.5, 0,             false);
  hole.lineTo(cx + hw,     cy + hh - r);
  hole.absarc(cx + hw - r, cy + hh - r, r, 0,             Math.PI / 2,   false);
  hole.lineTo(cx - hw + r, cy + hh);
  hole.absarc(cx - hw + r, cy + hh - r, r, Math.PI / 2,   Math.PI,       false);
  hole.closePath();
  shape.holes.push(hole);
}

function addCircleHole(shape, cx, cy, r, segs) {
  segs = segs || 32;
  const hole = new THREE.Path();
  hole.absarc(cx, cy, r, 0, Math.PI * 2, true);
  hole.closePath();
  shape.holes.push(hole);
}

function getHolesForDevice(deviceId, tw) {
  const oy  = tw.holeOffsetY || 0;
  const hr  = tw.holeRadius    || 0.06;
  const hrs = tw.holeRadiusSeg || 6;
  switch (deviceId) {
    case 'blank':
      return [];

    case 'toggle_opening':
      return [{type:'rounded', cx:0, cy:oy, hw:tw.holeToggleW/2, hh:tw.holeToggleH/2, r:hr, segs:hrs}];

    case 'toggle_retro':
      return [{type:'circle', cx:0, cy:oy, r:tw.holeToggleRetroR||0.012, segs:tw.holeDimmerSeg||32}];

    case 'knurled_toggle_sp':
    case 'knurled_toggle_4way':
    case 'toggle_knurled_single':
    case 'toggle_knurled_4way':
      return [{type:'rounded', cx:0, cy:oy, hw:tw.holeToggleW/2, hh:tw.holeToggleH/2, r:hr, segs:hrs}];

    case 'toggle_double_retro':
    case 'toggle_plus_dimmer':
      return [
        {type:'circle', cx:0, cy:oy + tw.holeDoubleGap/2, r:tw.holeDoubleToggleW/2, segs:tw.holeDimmerSeg||32},
        {type:'circle', cx:0, cy:oy - tw.holeDoubleGap/2, r:tw.holeDoubleToggleW/2, segs:tw.holeDimmerSeg||32},
      ];

    case 'outlet_rocker':
    case 'outlet_regular':
    case 'outlet_usbc':
    case 'outlet_double_usbc':
    case 'outlet_gfci':
      return [{type:'rounded', cx:0, cy:oy, hw:tw.holeRockerW/2, hh:tw.holeRockerH/2, r:hr, segs:hrs}];

    case 'dimmer_120v':
    case 'dimmer_3way':
    case 'dimmer_010v':
    case 'dimmer_strip':
    case 'fan_speed':
      return [{type:'circle', cx:0, cy:oy, r:tw.holeDimmerR||0.012, segs:tw.holeDimmerSeg||32}];

    default:
      return [];
  }
}

function mergeGeometries(geos) {
  let totalVerts = 0, totalIndices = 0;
  geos.forEach(g => {
    g.computeVertexNormals();
    totalVerts   += g.attributes.position.count;
    totalIndices += g.index ? g.index.count : g.attributes.position.count;
  });

  const positions = new Float32Array(totalVerts * 3);
  const normals   = new Float32Array(totalVerts * 3);
  const uvs       = new Float32Array(totalVerts * 2);
  const indices   = new Uint32Array(totalIndices);
  let vOff = 0, iOff = 0;

  geos.forEach(g => {
    const pos = g.attributes.position.array;
    const nor = g.attributes.normal ? g.attributes.normal.array : null;
    const uv  = g.attributes.uv     ? g.attributes.uv.array    : null;
    const idx = g.index             ? g.index.array             : null;
    const vc  = g.attributes.position.count;

    positions.set(pos, vOff * 3);
    if (nor) normals.set(nor, vOff * 3);
    if (uv)  uvs.set(uv,  vOff * 2);

    if (idx) {
      for (let i = 0; i < idx.length; i++) indices[iOff + i] = idx[i] + vOff;
      iOff += idx.length;
    } else {
      for (let i = 0; i < vc; i++) indices[iOff + i] = i + vOff;
      iOff += vc;
    }
    vOff += vc;
  });

  const merged = new THREE.BufferGeometry();
  merged.setAttribute('position', new THREE.BufferAttribute(positions, 3));
  merged.setAttribute('normal',   new THREE.BufferAttribute(normals,   3));
  merged.setAttribute('uv',       new THREE.BufferAttribute(uvs,       2));
  merged.setIndex(new THREE.BufferAttribute(indices, 1));
  return merged;
}

function buildBackInset(totalW, tw, gangCount, slots, slotWidth, offsetX) {
  offsetX = offsetX || 0;
  const iW    = tw.backInsetW + (totalW - tw.plateW);
  const iH    = tw.backInsetH;
  const depth = tw.backInsetDepth;
  const offY  = tw.backInsetOffsetY || 0;
  const thick = tw.plateThickness;

  const ringAZ = -thick / 2 - 0.003;
  const ringBZ = ringAZ - depth;

  const hw = iW / 2, hh = iH / 2;
  const cy = offY;

  const PA = [], NA = [], UA = [], IA = [];
  let vBase = 0;

  function pushQuad(p0, p1, p2, p3, nx, ny, nz, u0,v0, u1,v1, u2,v2, u3,v3) {
    PA.push(...p0, ...p1, ...p2, ...p3);
    for (let i = 0; i < 4; i++) NA.push(nx, ny, nz);
    UA.push(u0,v0, u1,v1, u2,v2, u3,v3);
    IA.push(vBase,vBase+1,vBase+2, vBase,vBase+2,vBase+3);
    vBase += 4;
  }

  pushQuad(
    [offsetX-hw, cy-hh, ringAZ], [offsetX+hw, cy-hh, ringAZ],
    [offsetX+hw, cy-hh, ringBZ], [offsetX-hw, cy-hh, ringBZ],
    0,-1,0,  0,0, 1,0, 1,1, 0,1
  );
  pushQuad(
    [offsetX+hw, cy-hh, ringAZ], [offsetX+hw, cy+hh, ringAZ],
    [offsetX+hw, cy+hh, ringBZ], [offsetX+hw, cy-hh, ringBZ],
    1,0,0,  0,0, 1,0, 1,1, 0,1
  );
  pushQuad(
    [offsetX+hw, cy+hh, ringAZ],  [offsetX-hw, cy+hh, ringAZ],
    [offsetX-hw, cy+hh, ringBZ],  [offsetX+hw, cy+hh, ringBZ],
    0,1,0,  0,0, 1,0, 1,1, 0,1
  );
  pushQuad(
    [offsetX-hw, cy+hh, ringAZ], [offsetX-hw, cy-hh, ringAZ],
    [offsetX-hw, cy-hh, ringBZ], [offsetX-hw, cy+hh, ringBZ],
    -1,0,0,  0,0, 1,0, 1,1, 0,1
  );

  const backCapShape = new THREE.Shape();
  backCapShape.moveTo(offsetX-hw, cy - hh);
  backCapShape.lineTo(offsetX+hw, cy - hh);
  backCapShape.lineTo(offsetX+hw, cy + hh);
  backCapShape.lineTo(offsetX-hw, cy + hh);
  backCapShape.closePath();

  const holeTunnels = [];

  for (let i = 0; i < gangCount; i++) {
    const slotCX = offsetX + (-totalW / 2 + tw.plateW / 2 + i * slotWidth);
    getHolesForDevice(slots[i].device, tw).forEach(h => {
      if (h.type === 'circle') {
        const segs = h.segs || 32;
        const pts = [];
        for (let s = 0; s < segs; s++) {
          const a = (s / segs) * Math.PI * 2;
          pts.push({ x: slotCX + h.cx + Math.cos(a) * h.r,
                     y: h.cy             + Math.sin(a) * h.r });
        }
        const holePath = new THREE.Path();
        holePath.absarc(slotCX + h.cx, h.cy, h.r, 0, Math.PI * 2, true);
        backCapShape.holes.push(holePath);
        holeTunnels.push({ points: pts });
      } else {
        const r2   = Math.min(h.r, h.hw - 0.001, h.hh - 0.001);
        const segs = h.segs || 6;
        const cx2  = slotCX + h.cx, cy2 = h.cy;
        const hw2  = h.hw, hh2 = h.hh;

        const tempPath = new THREE.Path();
        tempPath.moveTo(cx2 - hw2, cy2 - hh2 + r2);
        tempPath.absarc(cx2 - hw2 + r2, cy2 - hh2 + r2, r2, Math.PI, Math.PI*1.5, false);
        tempPath.lineTo(cx2 + hw2 - r2, cy2 - hh2);
        tempPath.absarc(cx2 + hw2 - r2, cy2 - hh2 + r2, r2, Math.PI*1.5, 0, false);
        tempPath.lineTo(cx2 + hw2, cy2 + hh2 - r2);
        tempPath.absarc(cx2 + hw2 - r2, cy2 + hh2 - r2, r2, 0, Math.PI*0.5, false);
        tempPath.lineTo(cx2 - hw2 + r2, cy2 + hh2);
        tempPath.absarc(cx2 - hw2 + r2, cy2 + hh2 - r2, r2, Math.PI*0.5, Math.PI, false);
        tempPath.closePath();

        const rawPts = tempPath.getPoints(segs * 4);
        const pts = rawPts.map(p => ({ x: p.x, y: p.y }));

        const holePath = new THREE.Path();
        holePath.moveTo(cx2 - hw2, cy2 - hh2 + r2);
        holePath.absarc(cx2 - hw2 + r2, cy2 - hh2 + r2, r2, Math.PI, Math.PI*1.5, false);
        holePath.lineTo(cx2 + hw2 - r2, cy2 - hh2);
        holePath.absarc(cx2 + hw2 - r2, cy2 - hh2 + r2, r2, Math.PI*1.5, 0, false);
        holePath.lineTo(cx2 + hw2, cy2 + hh2 - r2);
        holePath.absarc(cx2 + hw2 - r2, cy2 + hh2 - r2, r2, 0, Math.PI*0.5, false);
        holePath.lineTo(cx2 - hw2 + r2, cy2 + hh2);
        holePath.absarc(cx2 - hw2 + r2, cy2 + hh2 - r2, r2, Math.PI*0.5, Math.PI, false);
        holePath.closePath();
        backCapShape.holes.push(holePath);
        holeTunnels.push({ points: pts });
      }
    });
  }

  if (tw.screwHoleR > 0) {
    const holeBaseY = (tw.plateH / 2 - tw.plateRadius - 0.28);
    const hole1Y    =  holeBaseY + (tw.holeScrew1Y || 0);
    const hole2Y    = -holeBaseY + (tw.holeScrew2Y || 0);
    const holeX     = tw.holeScrewX || 0;
    const screwR    = tw.screwHoleR;
    const screwSeg  = tw.screwHoleSeg || 16;
    for (let i = 0; i < gangCount; i++) {
      const slotCX = offsetX + (-totalW / 2 + tw.plateW / 2 + i * slotWidth);
      [hole1Y, hole2Y].forEach(sy => {
        const hp = new THREE.Path();
        hp.absarc(slotCX + holeX, sy, screwR, 0, Math.PI * 2, true);
        backCapShape.holes.push(hp);
        const pts = [];
        for (let s = 0; s < screwSeg; s++) {
          const a = (s / screwSeg) * Math.PI * 2;
          pts.push({ x: slotCX + holeX + Math.cos(a) * screwR, y: sy + Math.sin(a) * screwR });
        }
        holeTunnels.push({ points: pts });
      });
    }
  }

  const capGeo = new THREE.ShapeGeometry(backCapShape, 4);
  capGeo.rotateX(Math.PI);
  capGeo.translate(0, 0, ringBZ);
  capGeo.computeVertexNormals();
  remapSlabUVs(capGeo, totalW, iH, offsetX);

  const tunnelGeos = [];
  holeTunnels.forEach(({ points }) => {
    const n = points.length;
    const tPA = [], tNA = [], tUA = [], tIA = [];
    let tb = 0;
    for (let j = 0; j < n; j++) {
      const a = points[j];
      const b = points[(j + 1) % n];
      const ex = b.x - a.x, ey = b.y - a.y;
      const len = Math.sqrt(ex*ex + ey*ey) || 1;
      const nx = ey / len, ny = -ex / len;

      tPA.push(
        a.x, a.y, ringAZ,
        b.x, b.y, ringAZ,
        b.x, b.y, ringBZ,
        a.x, a.y, ringBZ,
      );
      tNA.push(nx,ny,0, nx,ny,0, nx,ny,0, nx,ny,0);
      tUA.push(j/n,0, (j+1)/n,0, (j+1)/n,1, j/n,1);
      tIA.push(tb,tb+1,tb+2, tb,tb+2,tb+3);
      tb += 4;
    }
    const tg = new THREE.BufferGeometry();
    tg.setAttribute('position', new THREE.BufferAttribute(new Float32Array(tPA), 3));
    tg.setAttribute('normal',   new THREE.BufferAttribute(new Float32Array(tNA), 3));
    tg.setAttribute('uv',       new THREE.BufferAttribute(new Float32Array(tUA), 2));
    tg.setIndex(new THREE.BufferAttribute(new Uint32Array(tIA), 1));
    tunnelGeos.push(tg);
  });

  const wallGeo = new THREE.BufferGeometry();
  wallGeo.setAttribute('position', new THREE.BufferAttribute(new Float32Array(PA), 3));
  wallGeo.setAttribute('normal',   new THREE.BufferAttribute(new Float32Array(NA), 3));
  wallGeo.setAttribute('uv',       new THREE.BufferAttribute(new Float32Array(UA), 2));
  wallGeo.setIndex(new THREE.BufferAttribute(new Uint32Array(IA), 1));

  const allGeos = [wallGeo, capGeo, ...tunnelGeos];
  const merged = mergeGeometries(allGeos);
  allGeos.forEach(g => g.dispose());
  return merged;
}

function remapSlabUVs(geo, totalW, H, offsetX) {
  offsetX = offsetX || 0;
  const pos = geo.attributes.position;
  const uv  = geo.attributes.uv;
  for (let i = 0; i < pos.count; i++) {
    const x = pos.getX(i) - offsetX;
    const y = pos.getY(i);
    uv.setXY(i,
      (x + totalW / 2) / totalW,
      (y + H / 2) / H
    );
  }
  uv.needsUpdate = true;
}

function buildPlateGeometry(gangCount, slots, tw, slotWidth) {
  const totalW  = tw.plateW + (gangCount - 1) * slotWidth;
  const H       = tw.plateH;
  const thick   = tw.plateThickness;
  const r       = tw.plateRadius;
  const rSeg    = tw.plateRadiusSeg || 8;

  const offsetX = totalW / 2 - tw.plateW / 2;

  const shape = makeRoundedRectShape(totalW, H, r, rSeg);

  for (let i = 0; i < gangCount; i++) {
    const slotCX = -totalW / 2 + tw.plateW / 2 + i * slotWidth;
    getHolesForDevice(slots[i].device, tw).forEach(h => {
      if (h.type === 'circle') {
        addCircleHole(shape, slotCX + h.cx, h.cy, h.r, h.segs);
      } else {
        addRoundedRectHole(shape, slotCX + h.cx, h.cy, h.hw, h.hh, h.r, h.segs);
      }
    });
  }

  if (tw.screwHoleR > 0) {
    const holeBaseY   = (H / 2 - r - 0.28);
    const hole1Y      =  holeBaseY + (tw.holeScrew1Y || 0);
    const hole2Y      = -holeBaseY + (tw.holeScrew2Y || 0);
    const holeX       = tw.holeScrewX || 0;
    for (let i = 0; i < gangCount; i++) {
      const slotCX = -totalW / 2 + tw.plateW / 2 + i * slotWidth;
      addCircleHole(shape, slotCX + holeX, hole1Y, tw.screwHoleR, tw.screwHoleSeg || 16);
      addCircleHole(shape, slotCX + holeX, hole2Y, tw.screwHoleR, tw.screwHoleSeg || 16);
    }
  }

  const slabGeo = new THREE.ExtrudeGeometry(shape, {
    depth: thick, bevelEnabled: false, steps: 1, curveSegments: rSeg,
  });
  slabGeo.rotateX(Math.PI);
  slabGeo.translate(0, 0, thick / 2);
  slabGeo.translate(offsetX, 0, 0);

  remapSlabUVs(slabGeo, totalW, H, offsetX);

  const insetGeo = buildBackInset(totalW, tw, gangCount, slots, slotWidth, offsetX);

  const merged = mergeGeometries([slabGeo, insetGeo]);
  slabGeo.dispose();
  insetGeo.dispose();

  return merged;
}

function getScrewPositions(gangCount, tw, slotWidth) {
  const positions = [];
  const screwOffY = (tw.plateH / 2 - tw.plateRadius - 0.28) + (tw.screwOffsetY || 0);
  for (let i = 0; i < gangCount; i++) {
    const cx = i * slotWidth;
    positions.push({x:cx, y: screwOffY, z: tw.plateThickness / 2 + 0.01});
    positions.push({x:cx, y:-screwOffY, z: tw.plateThickness / 2 + 0.01});
  }
  return positions;
}

class PlateMeshManager {
  constructor(scene, matCache, tw, slotWidth) {
    this._scene     = scene;
    this._matCache  = matCache;
    this._tw        = tw;
    this._sw        = slotWidth;
    this._mesh      = null;
    this._finishKey = 'plate_satinbrass';
    this._gangCount = 1;
    this._slots     = [DEFAULT_SLOT()];
  }

  update(gangCount, slots, finishKey) {
    this._gangCount = gangCount;
    this._slots     = slots;
    this._finishKey = finishKey || this._finishKey;
    this._rebuild();
  }

  updateFinish(finishKey) {
    this._finishKey = finishKey;
    if (!this._mesh) return;
    const entry = this._matCache[finishKey];
    if (entry) {
      const mat = entry.mat.clone();
      this._applyMaterialProps(mat, finishKey);
      this._mesh.material.dispose();
      this._mesh.material = mat;
    }
  }

  _rebuild() {
    if (this._mesh) {
      this._scene.remove(this._mesh);
      this._mesh.geometry.dispose();
      if (this._mesh.material) this._mesh.material.dispose();
      this._mesh = null;
    }

    const geo = buildPlateGeometry(this._gangCount, this._slots, this._tw, getSlotWidth());

    const entry = this._matCache[this._finishKey];
    let mat;
    if (entry) {
      mat = entry.mat.clone();
      this._applyMaterialProps(mat, this._finishKey);
    } else {
      mat = new THREE.MeshStandardMaterial({color:'#b87333', metalness:0.8, roughness:0.4});
    }

    this._mesh = new THREE.Mesh(geo, mat);
    this._mesh.name = 'ProceduralPlate';
    this._mesh.receiveShadow = true;
    this._mesh.castShadow    = true;
    this._mesh.position.set(0, 0, 0);
    if (model) this._mesh.rotation.copy(model.rotation);

    this._scene.add(this._mesh);
  }

  _applyMaterialProps(mat, finishKey) {
    const finishId = finishKey.replace('plate_', '');
    const gangCount  = this._gangCount || 1;
    const slotWidth  = getSlotWidth();
    const totalW     = this._tw.plateW + (gangCount - 1) * slotWidth;
    const widthRatio = totalW / this._tw.plateW;
    applyFinishProps(mat, finishId, false, widthRatio);
  }

  _rotateTextures(mat, angle) {
    ['map','normalMap','roughnessMap','metalnessMap','aoMap'].forEach(k => {
      if (mat[k]) {
        mat[k] = mat[k].clone();
        mat[k].rotation = angle;
        mat[k].center.set(0.5, 0.5);
        mat[k].needsUpdate = true;
      }
    });
  }

  getMesh()  { return this._mesh; }
  dispose() {
    if (this._mesh) {
      this._scene.remove(this._mesh);
      this._mesh.geometry.dispose();
      if (this._mesh.material) this._mesh.material.dispose();
      this._mesh = null;
    }
  }
}

// ═══════════════════════════════════════════════════════════════════════════════
// INIT THREE
// ═══════════════════════════════════════════════════════════════════════════════
function initThree() {
  const canvas = document.getElementById('threeCanvas');
  const wrap   = document.getElementById('canvasWrap');
  const w = wrap.clientWidth, h = wrap.clientHeight;

  renderer = new THREE.WebGLRenderer({canvas, antialias:true, alpha:false});
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.outputEncoding      = THREE.sRGBEncoding;
  renderer.toneMapping         = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = TW.exposure;
  renderer.shadowMap.enabled   = true;
  renderer.shadowMap.type      = THREE.PCFSoftShadowMap;
  renderer.setSize(w, h);

  scene = new THREE.Scene();
  scene.background = new THREE.Color(0xeeece8);

  camera = new THREE.PerspectiveCamera(38, w / h, 0.01, 100);
  const v0 = camViewFor(state.gangCount);
  camera.position.set(v0.x, v0.y, v0.z);

  ambientLight = new THREE.AmbientLight(0xffffff, TW.ambient);
  scene.add(ambientLight);

  keyLight = new THREE.PointLight(0xfff8f0, TW.keyLight, 20);
  keyLight.position.set(TW.lightX, TW.lightY, TW.lightZ);
  keyLight.castShadow = false;
  scene.add(keyLight);

  fillLight = new THREE.PointLight(0xf0f4ff, TW.fillLight, 20);
  fillLight.position.set(-1.5, -2, 3);
  fillLight.castShadow = false;
  scene.add(fillLight);

  backLight = new THREE.DirectionalLight(0xffffff, TW.backLight);
  backLight.position.set(0, 0, -2);
  backLight.castShadow = false;
  scene.add(backLight);
  scene.add(backLight.target);

  const frontLight = new THREE.PointLight(0xffffff, 1.2, 80);
  frontLight.position.set(0, 0, 5);
  scene.add(frontLight);

  const topLight = new THREE.DirectionalLight(0xffffff, 11.0);
  topLight.position.set(0, 10, 0);
  topLight.target.position.set(0, 0, 0);
  topLight.castShadow = false;
  scene.add(topLight);
  scene.add(topLight.target);

  orbitControls = new THREE.OrbitControls(camera, renderer.domElement);
  orbitControls.enableDamping = true;
  orbitControls.dampingFactor = 0.08;
  orbitControls.enablePan = true;
  orbitControls.screenSpacePanning = true;
  orbitControls.panSpeed = 0.6;
  orbitControls.minDistance = 2;
  orbitControls.maxDistance = 12;
  // Les aretes verticales de la plaque restent paralleles aux bords de l'ecran
  // uniquement si la camera regarde a l'horizontale, donc a la meme hauteur que
  // la cible. On verrouille l'angle vertical : le client peut tourner autour et
  // zoomer, jamais basculer au dessus ou en dessous.
  orbitControls.maxPolarAngle = Math.PI / 2;
  orbitControls.minPolarAngle = Math.PI / 2;
  // Le deplacement lateral deplacerait aussi la cible en hauteur, ce qui
  // recreerait la deformation. On le limite a l'horizontale.
  orbitControls.screenSpacePanning = false;
  orbitControls.rotateSpeed = 0.5;
  orbitControls.zoomSpeed = 0.5;
  orbitControls.target.set(0, 0, 0);

  orbitControls.addEventListener('change', () => {
    const centerX = ((state.gangCount - 1) * getSlotWidth()) / 2;
    const clamp = 1.5 + (state.gangCount - 1) * 1.2;
    orbitControls.target.x = THREE.MathUtils.clamp(orbitControls.target.x, centerX - clamp, centerX + clamp);
    orbitControls.target.y = 0;
  });

  new ResizeObserver(() => {
    const w2 = wrap.clientWidth, h2 = wrap.clientHeight;
    if (!w2 || !h2) return;
    camera.aspect = w2 / h2;
    camera.updateProjectionMatrix();
    renderer.setSize(w2, h2);
  }).observe(wrap);

  animate();
  threeReady = true;
}

function playIntroAnimation(finalScale) {
  if (!model) return;
  model.scale.setScalar(0);
  renderer.domElement.style.transition = 'none';
  renderer.domElement.style.opacity = '0';
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      renderer.domElement.style.transition = 'opacity 0.8s ease';
      renderer.domElement.style.opacity = '1';
    });
  });
  const duration = 900;
  const start = performance.now();
  function easeOutBack(t) {
    const c1 = 1.70158, c3 = c1 + 1;
    return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
  }
  function tick(now) {
    const t = Math.min((now - start) / duration, 1);
    model.scale.setScalar(finalScale * easeOutBack(t));
    if (t < 1) requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}

const _camTarget   = new THREE.Vector3();
const _orbitTarget = new THREE.Vector3();

function animate() {
  requestAnimationFrame(animate);
  if (isAnimating && camera) {
    if (orbitControls) orbitControls.enabled = false;
    camera.position.lerp(_camTarget, 0.06);
    orbitControls.target.lerp(_orbitTarget, 0.06);
    const camDone    = camera.position.distanceTo(_camTarget) < 0.01;
    const targetDone = orbitControls.target.distanceTo(_orbitTarget) < 0.005;
    if (camDone && targetDone) {
      camera.position.copy(_camTarget);
      orbitControls.target.copy(_orbitTarget);
      isAnimating = false;
      if (orbitControls) orbitControls.enabled = true;
    }
  }
  if (orbitControls) orbitControls.update();
  if (renderer && scene && camera) renderer.render(scene, camera);
}

function smoothCameraTo(x, y, z) {
  const centerX = ((state.gangCount - 1) * getSlotWidth()) / 2;
  _camTarget.set(centerX + x, y, z);
  _orbitTarget.set(centerX, 0, 0);
  isAnimating = true;
}

function recenterOrbitTarget() {
  const centerX = ((state.gangCount - 1) * getSlotWidth()) / 2;
  _orbitTarget.set(centerX, 0, 0);
  _camTarget.copy(camera.position);
  isAnimating = true;
}

// ─────────────────────────────────────────────
// LOAD
// ─────────────────────────────────────────────
function setLoaderProgress(pct, label) {
  document.getElementById('loaderBar').style.width = pct + '%';
  document.getElementById('loaderLabel').textContent = label;
}

async function loadEverything() {
  setLoaderProgress(5, 'Preparing…');
  const app = document.getElementById('app');
  app.style.display = 'block';
  void app.offsetWidth;
  initThree();

  setLoaderProgress(15, 'Loading environment…');
  await new Promise(resolve => {
    const pmrem = new THREE.PMREMGenerator(renderer);
    pmrem.compileEquirectangularShader();
    const applyHDR = hdrTex => {
      window._hdrRawTex = hdrTex;
      window._pmremGen  = new THREE.PMREMGenerator(renderer);
      window._pmremGen.compileEquirectangularShader();
      applyHDRRotation();
      pmrem.dispose();
      resolve();
    };
    const fallback = () =>
      new THREE.RGBELoader().load('https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/1k/city_1k.hdr',
        applyHDR, undefined, () => { pmrem.dispose(); resolve(); });
    new THREE.RGBELoader().load(A('hdr', 'metal_01.hdr'), applyHDR, undefined, fallback);
  });

  setLoaderProgress(35, 'Loading 3D model…');
  await new Promise((resolve, reject) => {
    const draco = new THREE.DRACOLoader();
    draco.setDecoderPath('https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/libs/draco/');
    const loader = new THREE.GLTFLoader();
    loader.setDRACOLoader(draco);
    loader.load(A('glb', 'test2.glb'), gltf => {
      model = gltf.scene;
      scene.add(model);

      model.traverse(obj => {
        if (obj.isMesh || obj.isObject3D) {
          objectMap[obj.name] = obj;
          originalPositions[obj.name] = obj.position.clone();
        }
      });

      extractMaterialsFromPlanes();

      const box    = new THREE.Box3().setFromObject(model);
      const center = box.getCenter(new THREE.Vector3());
      const size   = box.getSize(new THREE.Vector3());
      model.position.sub(center);

      const finalScale = 2.2 / Math.max(size.x, size.y, size.z);
      window._modelBaseScale = finalScale;

      model.rotation.y = 0;
      model.rotation.x = MODEL_TILT_X;
      orbitControls.target.set(0, 0, 0);
      // Suit la vue de reference, sinon ce reglage ecrasait CAM_INITIAL.
      const vInit = camViewFor(state.gangCount);
      camera.position.set(vInit.x, vInit.y, vInit.z);
      orbitControls.update();

      renderer.domElement.style.opacity = '0';
      renderer.domElement.style.transition = 'none';

      FIXED_OBJECTS.forEach(name => {
        const obj = objectMap[name]; if (!obj) return;
        obj.traverse(c => { if (c.isMesh && c.material) fixedMaterialsCache[c.uuid] = c.material.clone(); });
      });

      ALL_DEVICE_OBJECTS.forEach(name => {
        const obj = objectMap[name];
        if (obj) { obj.visible = false; obj.traverse(c => { c.visible = false; }); }
      });

      objectMap = {};
      model.traverse(obj => {
        if (obj.isMesh || obj.isObject3D) {
          objectMap[obj.name] = obj;
          originalPositions[obj.name] = obj.position.clone();
        }
        if (obj.isMesh) {
          obj.receiveShadow = true;
          obj.castShadow = !NO_SHADOW_OBJECTS.has(obj.name) && !NO_SHADOW_OBJECTS.has(obj.parent?.name || '');
        }
      });

      plateMgr = new PlateMeshManager(scene, matCache, TW, getSlotWidth());
      model.updateMatrixWorld(true);
      setLoaderProgress(90, 'Applying materials…');
      resolve();
    },
    xhr => setLoaderProgress(35 + Math.round((xhr.loaded / (xhr.total || 1)) * 55), 'Loading 3D model…'),
    reject);
  });

  setLoaderProgress(92, 'Loading noise normal…');
  await new Promise(resolve => {
    new THREE.TextureLoader().load(A('noiseNormal', 'noisenormal.png'), tex => {
      tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
      noiseNormalTex = tex;
      resolve();
    }, undefined, () => {
      console.warn('[materials] Could not load "noisenormal.png" — groundingterminal will fall back to the shared radial normal map.');
      resolve();
    });
  });

  buildCtrlColorGrid();
  setLoaderProgress(95, 'Finalizing…');

  if (model) {
    model.scale.setScalar(window._modelBaseScale);
    model.updateMatrixWorld(true);
  }

  renderScene();

  setLoaderProgress(100, 'Ready');
  await new Promise(r => setTimeout(r, 400));

  document.getElementById('loader').classList.add('hidden');
  document.getElementById('app').classList.add('visible');

  if (renderer && renderer.domElement) {
    renderer.domElement.style.transition = 'opacity 0.4s ease';
    renderer.domElement.style.opacity = '1';
  }
}
// ─────────────────────────────────────────────
// MATERIAL CACHE
// ─────────────────────────────────────────────
const MAT_PLANE_DEFS = [
  {plane:'brushedBrassPlane',            plateKey:'satinbrass'},
  {plane:'antiqueBrassPlane',            plateKey:'antiquebrass',  rotate:true},
  {plane:'unlacqueredAntiqueBrassPlane', plateKey:'unlacquered',   rotate:true},
  {plane:'hammeredPlane',                plateKey:'hammered'},
  {plane:'agedBronzePlane',              plateKey:'agedbronze',    controlsKey:'agedbronze'},
  {plane:'stainlessSteelPlane',          plateKey:'stainless'},
];

const ALL_MAT_PLANES = [
  'brushedBrassPlane','antiqueBrassPlane','unlacqueredAntiqueBrassPlane',
  'hammeredPlane','agedBronzePlane','stainlessSteelPlane',
  'moduleRadialPlane','moduleWhitePlane','moduleAntiqueBrassPlane','blackPlane',
  'stainlessControlPlane',
];

const matCache = {};
let noiseNormalTex = null;

function extractMaterialsFromPlanes() {
  const getPlaneMat = name => {
    const obj = objectMap[name]; if (!obj) return null;
    let mat = null;
    if (obj.isMesh && obj.material) mat = obj.material;
    if (!mat) obj.traverse(c => { if (c.isMesh && c.material && !mat) mat = c.material; });
    return mat;
  };

  MAT_PLANE_DEFS.forEach(def => {
    const base = getPlaneMat(def.plane);
    if (!base) {
      console.warn(`[materials] Could not find plane object "${def.plane}" in the GLB — ` +
        `matCache entries for it (${[def.plateKey && 'plate_'+def.plateKey, def.controlsKey && 'controls_'+def.controlsKey].filter(Boolean).join(', ')}) ` +
        `were skipped, so anything routed to them will silently fall back to whatever material was applied before. ` +
        `Check the exact object name (case-sensitive) in the GLB.`);
      return;
    }
    if (def.plateKey) {
      const mat = base.clone(); mat.needsUpdate = true;
      matCache[`plate_${def.plateKey}`] = {mat, isRotated:!!def.rotate};
    }
    if (def.controlsKey) {
      const mat = base.clone();
      if (def.colorTint) mat.color.set(def.colorTint);
      mat.needsUpdate = true;
      matCache[`controls_${def.controlsKey}`] = {mat, isRotated:false};
    }
  });

  const radialMat = getPlaneMat('moduleRadialPlane');
  let radialNormal = radialMat ? radialMat.normalMap : null;
  if (radialNormal) {
    radialNormal = radialNormal.clone();
    radialNormal.repeat.set(1, 1);
    radialNormal.offset.set(0, 0);
    radialNormal.rotation = 0;
    radialNormal.center.set(0.5, 0.5);
    radialNormal.wrapS = radialNormal.wrapT = THREE.RepeatWrapping;
    radialNormal.needsUpdate = true;
  }

  const antiqueBrassMat = getPlaneMat('moduleAntiqueBrassPlane');
  let brassCtrlMat;
  if (antiqueBrassMat) {
    brassCtrlMat = antiqueBrassMat.clone();
    brassCtrlMat.normalMap = radialNormal || brassCtrlMat.normalMap || null;
    if (brassCtrlMat.map) {
      brassCtrlMat.map = brassCtrlMat.map.clone();
      brassCtrlMat.map.wrapS = brassCtrlMat.map.wrapT = THREE.RepeatWrapping;
      brassCtrlMat.map.needsUpdate = true;
    }
  } else {
    brassCtrlMat = new THREE.MeshStandardMaterial({
      color: '#b87333',
      normalMap: radialNormal || null,
    });
  }
  brassCtrlMat.needsUpdate = true;
  matCache['controls_brass'] = { mat: brassCtrlMat, isRotated: false };

  const stainlessControlMat = getPlaneMat('stainlessControlPlane');
  let stainlessCtrlMat;
  if (stainlessControlMat) {
    stainlessCtrlMat = stainlessControlMat.clone();
    stainlessCtrlMat.normalMap = radialNormal || stainlessCtrlMat.normalMap || null;
    if (stainlessCtrlMat.map) {
      stainlessCtrlMat.map = stainlessCtrlMat.map.clone();
      stainlessCtrlMat.map.wrapS = stainlessCtrlMat.map.wrapT = THREE.RepeatWrapping;
      stainlessCtrlMat.map.needsUpdate = true;
    }
  } else {
    stainlessCtrlMat = new THREE.MeshStandardMaterial({
      color: '#b0b8c1',
      normalMap: radialNormal || null,
    });
  }
  stainlessCtrlMat.needsUpdate = true;
  matCache['controls_stainless'] = { mat: stainlessCtrlMat, isRotated: false };

  if (matCache['controls_agedbronze']?.mat) {
    const abm = matCache['controls_agedbronze'].mat;
    abm.color.set('#b87333');
    abm.metalness = Math.min((abm.metalness || 0) + 0.25, 1.0);
    abm.roughness = Math.max((abm.roughness || 0.5) - 0.18, 0.05);
    abm.needsUpdate = true;
  }
  if (matCache['plate_hammered']?.mat) {
    const hm = matCache['plate_hammered'].mat;
    hm.metalness = TW.hammeredMetal ?? 0.92; hm.roughness = TW.hammeredRough ?? 0.28; hm.needsUpdate = true;
  }

  const blackPlaneMat = getPlaneMat('blackPlane');
  if (blackPlaneMat) {
    matCache['plate_matte_black'] = {mat: blackPlaneMat.clone(), isRotated:false};
  } else {
    matCache['plate_matte_black'] = {mat: new THREE.MeshStandardMaterial({
      color:'#1a1a1a', roughness:0.82, metalness:0.05, envMapIntensity:0.3,
    }), isRotated:false};
  }
  matCache['plate_matte_white'] = {mat: new THREE.MeshStandardMaterial({
    color: TW.matte_white_color || '#ffffff',
    roughness:0.92, metalness:0.0, envMapIntensity:2.4,
    emissive: new THREE.Color(TW.matte_white_color || '#ffffff'),
    emissiveIntensity: (TW.matte_white_glow !== undefined ? TW.matte_white_glow : 0.22),
  }), isRotated:false};
  matCache['controls_white'] = {mat: new THREE.MeshStandardMaterial({
    color:'#e8e6e0', roughness:0.15, metalness:0.0, envMapIntensity:2.0,
  }), isRotated:false};
  matCache['controls_fullblack'] = {mat: new THREE.MeshStandardMaterial({
    color:'#111111', roughness:0.12, metalness:0.0, envMapIntensity:2.4,
  }), isRotated:false};

  ALL_MAT_PLANES.forEach(name => {
    const obj = objectMap[name]; if (!obj) return;
    obj.visible = false; obj.traverse(c => { c.visible = false; });
    if (obj.parent) obj.parent.remove(obj);
  });

  applyNormalScales();
}

function applyNormalScales() {
  Object.entries(matCache).forEach(([key, {mat}]) => {
    const isCtrl   = key.startsWith('controls_');
    const finishId = key.replace(/^plate_|^controls_/, '');
    const p = getFinishProps(finishId, isCtrl);
    if (mat.normalMap) mat.normalScale.set(p.normal, p.normal);
    if (p.rot !== 0) rotateMatTextures(mat, p.rot);
    mat.needsUpdate = true;
  });
}

function rotateMatTextures(mat, angle) {
  ['map','normalMap','roughnessMap','metalnessMap','aoMap'].forEach(k => {
    if (mat[k]) { mat[k].rotation = angle; mat[k].center.set(.5,.5); mat[k].needsUpdate = true; }
  });
}

// ─────────────────────────────────────────────
// UV HELPER (controls only now)
// ─────────────────────────────────────────────
function getUVScale(objectName, isControls) {
  if (!isControls) {
    if (objectName === 'Dimmer')       return TW.uvDimmer;
    if (objectName === 'DoubleToggle') return TW.uvDoubleToggle;
    if (objectName === 'Toggle')       return TW.uvToggle;
    if (objectName === 'Blank')        return TW.uvBlank;
    if (objectName === 'Rocker')       return TW.uvRocker;
    return 1;
  } else {
    if (objectName === 'Screw' || objectName === 'Screw2')                          return TW.uvScrew;
    if (objectName === 'MultipleKnob')                                              return TW.uvKnob;
    // groundingterminal reuses the same tiling as the other controls
    // (was TW.uvGround = 0.01, which stretched any base texture to a
    // near-flat blur — that's why it looked untextured before)
    if (objectName === 'groundingterminal')                                         return TW.uvGround;
    if (objectName === 'ToggleKnob1')                                                return TW.uvKnob;
    return 1;
  }
}

function applyUVToMat(mat, scale) {
  if (!scale || scale === 1) return mat;
  const m2 = mat.clone();
  ['map','normalMap','roughnessMap','metalnessMap','aoMap'].forEach(k => {
    if (m2[k]) {
      m2[k] = m2[k].clone();
      m2[k].repeat.set(scale, scale);
      m2[k].wrapS = m2[k].wrapT = THREE.RepeatWrapping;
      m2[k].needsUpdate = true;
    }
  });
  return m2;
}

const ZERO_NORMAL_OBJECTS = new Set([]);

function getFinishProps(finishId, isCtrl) {
  const prefix = isCtrl ? `ctrl_${finishId}` : finishId;
  const get = (prop, fallback) => TW[`${prefix}_${prop}`] !== undefined
    ? TW[`${prefix}_${prop}`] : TW[fallback];
  return {
    metal:  get('metal',  isCtrl ? 'ctrlMetal'  : 'plateMetal'),
    rough:  get('rough',  isCtrl ? 'ctrlRough'  : 'plateRough'),
    normal: get('normal', isCtrl ? 'ctrlNormal' : 'plateNormal'),
    uvX:    get('uvX',    'uvPlate') ?? 1,
    uvY:    get('uvY',    'uvPlate') ?? 1,
    rot:    get('rot',    null) ?? 0,
env:   (TW[`${prefix}_env`] !== undefined ? TW[`${prefix}_env`] : (isCtrl ? TW.ctrlEnv : TW.plateEnv)) * TW.hdrIntensity,
  };
}

function applyFinishProps(mat, finishId, isCtrl, gangCountX) {
  const p = getFinishProps(finishId, isCtrl);
  const rawUvX = p.uvX * (gangCountX || 1);
  const uvX = (gangCountX && gangCountX > 1) ? Math.max(1, Math.round(rawUvX)) : rawUvX;
  const uvY = p.uvY;

  if (uvX !== 1 || uvY !== 1) {
    ['map','normalMap','roughnessMap','metalnessMap','aoMap'].forEach(k => {
      if (mat[k]) {
        mat[k] = mat[k].clone();
        mat[k].repeat.set(uvX, uvY);
        mat[k].wrapS = mat[k].wrapT = THREE.RepeatWrapping;
        mat[k].needsUpdate = true;
      }
    });
  }

  if (p.rot !== 0) {
    ['map','normalMap','roughnessMap','metalnessMap','aoMap'].forEach(k => {
      if (mat[k]) {
        mat[k].rotation = p.rot;
        mat[k].center.set(0.5, 0.5);
        mat[k].needsUpdate = true;
      }
    });
  }

  mat.metalness        = p.metal;
  mat.roughness        = p.rough;
  mat.envMapIntensity  = p.env;
  if (mat.normalMap)   mat.normalScale.set(p.normal, p.normal);
  mat.needsUpdate = true;
}

function applyMatToMesh(child, matKey, objectName) {
  if (!child.isMesh) return;
  const entry = matCache[matKey]; if (!entry) return;
  const isCtrl      = matKey.startsWith('controls_');
  const finishId    = matKey.replace(/^plate_|^controls_/, '');
  const uvScale     = getUVScale(objectName, isCtrl);

  let mat = entry.mat.clone();

  if (uvScale !== 1) mat = applyUVToMat(mat, uvScale);

  applyFinishProps(mat, finishId, isCtrl);

  if (objectName === 'Rocker' || objectName === 'Toggle') {
    rotateMatTextures(mat, Math.PI / 2);
  }

  child.material = mat;
}

function applyMatToMeshWithFinishOverride(child, matKey, objectName, finishIdOverride, isCtrl) {
  if (!child.isMesh) return;
  const entry = matCache[matKey]; if (!entry) return;
  const uvScale = getUVScale(objectName, isCtrl);
  let mat = uvScale !== 1 ? applyUVToMat(entry.mat, uvScale) : entry.mat.clone();
  applyFinishProps(mat, finishIdOverride, isCtrl);
  child.material = mat;
}

function applyMatToObjects(names, matKey) {
  names.forEach(name => {
    const obj = objectMap[name]; if (!obj) return;
    if (obj.isMesh) applyMatToMesh(obj, matKey, name);
    obj.traverse(c => { if (c.isMesh) applyMatToMesh(c, matKey, name); });
  });
}

function applyColorToObjects(names, colorHex) {
  names.forEach(name => {
    const obj = objectMap[name]; if (!obj) return;
    obj.traverse(c => {
      if (!c.isMesh) return;
      c.material = c.material.clone();
      c.material.color.set(colorHex === '#111111' ? '#000000' : colorHex);
      c.material.map = null;
      c.material.roughness = (colorHex === '#111111' || colorHex === '#1a1a1a') ? 0.55 : 0.3;
      c.material.metalness = (colorHex === '#111111' || colorHex === '#1a1a1a') ? 0.0  : 0.05;
      c.material.envMapIntensity = (colorHex === '#111111' || colorHex === '#1a1a1a') ? 0.05 : 0.8;
      c.material.needsUpdate = true;
    });
  });
}

function applyCtrlColorOverrides() {
  if (!universalCtrlColor) return;
  const hex = universalCtrlColor;
  const isDark  = parseInt(hex.slice(1), 16) < 0x444444;
  const isLight = parseInt(hex.slice(1), 16) > 0xcccccc;
  const ov = {
    hex,
    roughness: isDark ? 0.65 : isLight ? 0.3 : 0.2,
    metalness: isDark ? 0.05 : isLight ? 0.02 : 0.9,
    envMap:    isDark ? 0.15 : isLight ? 0.4 : TW.ctrlEnv,
  };
  const stampMesh = child => {
    if (!child.isMesh) return;
    const m = child.material.clone();
    m.color.set(ov.hex); m.map = null; m.normalMap = null;
    m.roughnessMap = null; m.metalnessMap = null;
    m.roughness = ov.roughness; m.metalness = ov.metalness;
    m.envMapIntensity = ov.envMap; m.needsUpdate = true;
    child.material = m;
  };
  const stampObj = obj => {
    if (!obj) return;
    if (obj.isMesh) stampMesh(obj);
    obj.traverse(c => { if (c.isMesh) stampMesh(c); });
  };
  CONTROLS_TARGETS.forEach(name => stampObj(objectMap[name]));
  screwClones.forEach(clone => stampObj(clone));
  Object.values(slotClones).forEach(bag => {
    Object.values(bag).forEach(clone => {
      const baseName = clone.name.replace(/_slot\d+$/, '').replace(/_lower$/, '');
      if (CONTROLS_TARGETS.includes(baseName)) stampObj(clone);
    });
  });
}

function restoreFixedMaterials() {
  FIXED_OBJECTS.forEach(name => {
    const obj = objectMap[name]; if (!obj) return;
    obj.traverse(c => {
      if (c.isMesh && fixedMaterialsCache[c.uuid]) {
        c.material = fixedMaterialsCache[c.uuid];
        c.material.needsUpdate = true;
      }
    });
  });
}

// ─────────────────────────────────────────────
// SHOW / HIDE / CLONE
// ─────────────────────────────────────────────
function showObject(name) {
  const obj = objectMap[name]; if (!obj) return;
  obj.visible = true; obj.traverse(c => { c.visible = true; });
  let p = obj.parent; while (p && p !== scene) { p.visible = true; p = p.parent; }
}
function hideObject(name) {
  const obj = objectMap[name]; if (!obj) return;
  obj.visible = false; obj.traverse(c => { c.visible = false; });
}
function clearSlotClones() {
  Object.values(slotClones).forEach(bag => Object.values(bag).forEach(c => { if (c.parent) c.parent.remove(c); }));
  slotClones = {};
}
function clearScrewClones() {
  screwClones.forEach(c => { if (c.parent) c.parent.remove(c); });
  screwClones = [];
}
function clearShadowDecals() {
  shadowDecals.forEach(d => {
    if (d.parent) d.parent.remove(d);
    if (d.geometry) d.geometry.dispose();
    if (d.material) { if (d.material.map) d.material.map.dispose(); d.material.dispose(); }
  });
  shadowDecals = [];
}
function clearEngraveDecals() {
  Object.values(engraveDecals).forEach(d => {
    if (d.parent) d.parent.remove(d);
    if (d.geometry) d.geometry.dispose();
    if (d.material) { if (d.material.map) d.material.map.dispose(); d.material.dispose(); }
  });
  Object.keys(engraveDecals).forEach(k => delete engraveDecals[k]);
}

function hideAllDeviceObjects() {
  clearSlotClones(); clearEngraveDecals(); clearShadowDecals();
  ALL_DEVICE_OBJECTS.forEach(name => {
    hideObject(name);
    const obj = objectMap[name];
    if (obj) {
      if (originalPositions[name]) obj.position.copy(originalPositions[name]);
      obj._extraY = 0;
    }
  });
}

function cloneToSlot(name, slotIndex, extraY = 0) {
  const orig = objectMap[name]; if (!orig) return null;
  const clone = orig.clone(false);
  clone.name = `${name}_slot${slotIndex}`;

  const localSlotStep = (() => {
    if (!model) return new THREE.Vector3(getSlotWidth(), 0, 0);
    const w0 = model.worldToLocal(new THREE.Vector3(0, 0, 0));
    const w1 = model.worldToLocal(new THREE.Vector3(getSlotWidth(), 0, 0));
    return w1.sub(w0);
  })();

  const origPos = originalPositions[name] || new THREE.Vector3();
  clone.position.set(
    origPos.x + localSlotStep.x * slotIndex,
    origPos.y + extraY,
    origPos.z + localSlotStep.z * slotIndex
  );

  clone.visible = true;
  if (orig.isMesh) { clone.geometry = orig.geometry; clone.material = orig.material; }
  orig.children.forEach(child => {
    if (!child.isMesh) return;
    const cc = child.clone(false);
    cc.geometry = child.geometry; cc.material = child.material;
    cc.position.copy(child.position); cc.rotation.copy(child.rotation); cc.scale.copy(child.scale);
    cc.visible = true;
    cc.castShadow = !NO_SHADOW_OBJECTS.has(name) && !NO_SHADOW_OBJECTS.has(child.name);
    cc.receiveShadow = true;
    clone.add(cc);
  });
  orig.parent.add(clone);
  clone._extraY = extraY;
  if (!slotClones[slotIndex]) slotClones[slotIndex] = {};
  slotClones[slotIndex][`${name}_y${extraY}`] = clone;
  return clone;
}

// ─────────────────────────────────────────────
// SHADOW DECALS
// ─────────────────────────────────────────────
function placeShadowDecals() {
  clearShadowDecals();
  if (!TW.shadowOn || !model) return;
  if (!plateMgr || !plateMgr.getMesh()) return;
  const plateBox = new THREE.Box3().setFromObject(plateMgr.getMesh());
  const pSize    = plateBox.getSize(new THREE.Vector3());
  const pCenter  = plateBox.getCenter(new THREE.Vector3());

  const SIZE = 1024;
  const cvs = document.createElement('canvas'); cvs.width = cvs.height = SIZE;
  const ctx = cvs.getContext('2d'); ctx.clearRect(0, 0, SIZE, SIZE);
  [[0.5, TW.shadowDecalOffY],[0.5, TW.shadowDecalOffY2]].forEach(([nx, ny]) => {
    const cx = nx * SIZE, cy = ny * SIZE, sr = TW.shadowSize * SIZE;
    const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, sr);
    g.addColorStop(0, `rgba(0,0,0,${TW.shadowOpacity})`);
    g.addColorStop(.5, `rgba(0,0,0,${TW.shadowOpacity * .4})`);
    g.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = g; ctx.beginPath(); ctx.arc(cx, cy, sr, 0, Math.PI * 2); ctx.fill();
  });
  const tex = new THREE.CanvasTexture(cvs);
  const geo = new THREE.PlaneGeometry(pSize.x, pSize.y);
  const mat = new THREE.MeshBasicMaterial({map:tex, transparent:true, depthWrite:false, alphaTest:.005});
  const d   = new THREE.Mesh(geo, mat);
  d.position.set(pCenter.x, pCenter.y, plateBox.max.z + .002);
  scene.add(d); shadowDecals.push(d);
}

// ─────────────────────────────────────────────
// DEVICE PER SLOT
// ─────────────────────────────────────────────
function applySlotDevice(slotIndex, slotState) {
  const dev = DEVICES[slotState.device]; if (!dev) return;
  const s0  = slotIndex === 0;

  const skipInShowLoop = new Set();
  if (dev.doubleClone) dev.doubleClone.forEach(n => skipInShowLoop.add(n));
  if (dev.splitOffset) {
    (dev.splitOffset.up   || []).forEach(n => skipInShowLoop.add(n));
    (dev.splitOffset.down || []).forEach(n => skipInShowLoop.add(n));
  }

  dev.show.forEach(name => {
    if (skipInShowLoop.has(name)) return;
    if (s0) showObject(name);
    else    cloneToSlot(name, slotIndex);
  });

  if (dev.doubleClone) dev.doubleClone.forEach((name, di) => {
    if (s0) {
      const orig = objectMap[name]; if (!orig) return;
      orig.position.y = originalPositions[name].y + TW.splitOffset;
      orig.visible = true; orig.traverse(c => { c.visible = true; });
      const lower = orig.clone(true);
      lower.name = `${name}_lower${di}`;
      lower.position.set(
        originalPositions[name].x,
        originalPositions[name].y - TW.splitOffset,
        originalPositions[name].z
      );
      lower.visible = true; lower.traverse(c => { c.visible = true; });
      lower._extraY = -TW.splitOffset;
      orig._extraY  =  TW.splitOffset;
      orig.parent.add(lower);
      if (!slotClones[0]) slotClones[0] = {};
      slotClones[0][`${name}_lower${di}`] = lower;
    } else {
      cloneToSlot(name, slotIndex,  TW.splitOffset);
      cloneToSlot(name, slotIndex, -TW.splitOffset);
    }
  });

  if (dev.splitOffset) {
    if (s0) {
      (dev.splitOffset.up   || []).forEach(n => {
        const o = objectMap[n]; if (!o) return;
        o.position.y = originalPositions[n].y + TW.splitOffset;
        o._extraY = TW.splitOffset;
        o.visible = true; o.traverse(c => { c.visible = true; });
      });
      (dev.splitOffset.down || []).forEach(n => {
        const o = objectMap[n]; if (!o) return;
        o.position.y = originalPositions[n].y - TW.splitOffset;
        o._extraY = -TW.splitOffset;
        o.visible = true; o.traverse(c => { c.visible = true; });
      });
    } else {
      (dev.splitOffset.up   || []).forEach(n => cloneToSlot(n, slotIndex,  TW.splitOffset));
      (dev.splitOffset.down || []).forEach(n => cloneToSlot(n, slotIndex, -TW.splitOffset));
    }
  }

  if (dev.hasOutletColor) {
    const hex = slotState.outletColor === 'black' ? '#111111' : '#eeeeee';
    if (s0) {
      applyColorToObjects(OUTLET_COLOR_TARGETS, hex);
    } else {
      const bag = slotClones[slotIndex] || {};
      OUTLET_COLOR_TARGETS.forEach(name => {
        const key   = Object.keys(bag).find(k => k.startsWith(name));
        const clone = key ? bag[key] : null; if (!clone) return;
        clone.traverse(c => {
          if (!c.isMesh) return;
          c.material = c.material.clone();
          c.material.color.set(hex); c.material.map = null;
          c.material.roughness = (hex === '#111111') ? 0.7 : 0.3;
          c.material.metalness = (hex === '#111111') ? 0.1 : 0.05;
          c.material.needsUpdate = true;
        });
      });
    }
  }

}

// ─────────────────────────────────────────────
// MASTER RENDER
// ─────────────────────────────────────────────
function renderScene() {
  if (!model) return;
  hideAllDeviceObjects();
  clearScrewClones();

  if (plateMgr) {
    plateMgr.update(state.gangCount, state.slots, `plate_${state.plateFinish}`);
  }

  const localSlotStep = (() => {
    if (!model) return new THREE.Vector3(getSlotWidth(), 0, 0);
    const w0 = model.worldToLocal(new THREE.Vector3(0, 0, 0));
    const w1 = model.worldToLocal(new THREE.Vector3(getSlotWidth(), 0, 0));
    return new THREE.Vector3().subVectors(w1, w0);
  })();

  const screwBaseY  = (TW.plateH / 2 - TW.plateRadius - 0.28) + (TW.screwOffsetY || 0);
  const screw1Y     =  screwBaseY + (TW.screw1OffsetY || 0);
  const screw2Y     = -screwBaseY + (TW.screw2OffsetY || 0);
  const screwOffXLocal = (() => {
    if (!model || !TW.screwOffsetX) return 0;
    const w0 = model.worldToLocal(new THREE.Vector3(0, 0, 0));
    const wx = model.worldToLocal(new THREE.Vector3(TW.screwOffsetX, 0, 0));
    return wx.x - w0.x;
  })();
  const screwWorldZ = TW.plateThickness / 2 + 0.01;
  const screwLocalZ = (() => {
    if (!model) return screwWorldZ;
    const w0 = model.worldToLocal(new THREE.Vector3(0, 0, 0));
    const wz = model.worldToLocal(new THREE.Vector3(0, 0, screwWorldZ));
    return wz.z - w0.z;
  })();

  const screw0LocalX  = (originalPositions['Screw']  ? originalPositions['Screw'].x  : 0) + screwOffXLocal;
  const screw2Local0X = (originalPositions['Screw2'] ? originalPositions['Screw2'].x : 0) + screwOffXLocal;

  if (objectMap['Screw']) {
    objectMap['Screw'].position.set(screw0LocalX, screw1Y, screwLocalZ);
    showObject('Screw');
  }
  if (objectMap['Screw2']) {
    objectMap['Screw2'].position.set(screw2Local0X, screw2Y, screwLocalZ);
    showObject('Screw2');
  }

  for (let i = 1; i < state.gangCount; i++) {
    [['Screw', screw0LocalX, screw1Y], ['Screw2', screw2Local0X, screw2Y]].forEach(([name, baseX, baseY]) => {
      const orig = objectMap[name]; if (!orig) return;
      const c = orig.clone(true);
      c.name = `${name}_gang${i}`;
      c.position.set(
        baseX + localSlotStep.x * i,
        baseY,
        screwLocalZ
      );
      c.visible = true; c.traverse(ch => { ch.visible = true; });
      orig.parent.add(c);
      screwClones.push(c);
    });
  }

  state.slots.forEach((s, i) => applySlotDevice(i, s));

  applyDeviceTransform();

  applyControlsFinish(state.controlsFinish);
  applyCtrlColorOverrides();
  applyObjColorOverrides();
  restoreFixedMaterials();
  updatePrice();
  refreshEngraveOverlay();
}

// ─────────────────────────────────────────────
// PER-OBJECT TRANSFORM OVERRIDES
// ─────────────────────────────────────────────
const OBJ_OVERRIDES = {
  '3Way120vDimmer':      {scale:1, x:0, y:0, z:0},
  '120vDimmerSingle':    {scale:1, x:0, y:0, z:0},
  'Blank':               {scale:1, x:0, y:0, z:0},
  'Dimmer':              {scale:1, x:0, y:0, z:0},
  'DoubleToggle':        {scale:1, x:0, y:0, z:0},
  'GFCI':                {scale:1, x:0, y:0, z:0},
  'GFCIouter':           {scale:0.91, x:0, y:0.03, z:0},
  'MultipleKnob':        {scale:1, x:0, y:0, z:0},
  'Rocker':              {scale:1, x:0, y:0, z:0},
  'Screw':               {scale:1, x:0, y:-0.02, z:0.035},
  'Screw2':               {scale:1, x:0, y:0.02, z:0.035},
  'Toggle':              {scale:1, x:0, y:0, z:0},
  'ToggleKnob1':         {scale:1, x:0, y:0, z:-0.11},
  'dimmersupport':       {scale:1, x:0, y:0, z:0},
  'groundingterminal':   {scale:1, x:0, y:0, z:-0.036},
  'innerdoubleusb':      {scale:0.9, x:-0.01, y:0.005, z:-0.012},
  'knurledpin':          {scale:1, x:0, y:0, z:0},
  'lowvol':              {scale:1, x:0, y:0, z:0},
  'outerdoubleusb':      {scale:1, x:0, y:0, z:0},
  'regularinneroutlet':  {scale:0.85, x:0.01, y:0.01, z:0.0},
  'regularouteroutlet':  {scale:1, x:0, y:0, z:0},
  'retropole':           {scale:1, x:0, y:0, z:-0.004},
  'singlepole':          {scale:1, x:0, y:0, z:0},
  'steplessrotary':      {scale:1, x:0, y:0, z:-0.01},
  'toggle4way':          {scale:1, x:0, y:0, z:0},
  'toggleframe':         {scale:0.9, x:0, y:0.02, z:-0.076},
  'usbacinneroutlet':    {scale:0.87, x:-0.01, y:0.035, z:-0.01},
  'usbacouteroutlet':    {scale:1, x:0, y:0, z:0},
};
function getObjOverride(name) {
  if (!OBJ_OVERRIDES[name]) OBJ_OVERRIDES[name] = {scale:1, x:0, y:0, z:0};
  return OBJ_OVERRIDES[name];
}
const OBJ_OVERRIDES_BASELINE = JSON.parse(JSON.stringify(OBJ_OVERRIDES));
function resetObjOverrides() {
  Object.keys(OBJ_OVERRIDES).forEach(k => {
    OBJ_OVERRIDES[k] = OBJ_OVERRIDES_BASELINE[k]
      ? { ...OBJ_OVERRIDES_BASELINE[k] }
      : { scale:1, x:0, y:0, z:0 };
  });
}
function hasAnyObjOverride() {
  return Object.values(OBJ_OVERRIDES).some(ov => ov.scale !== 1 || ov.x !== 0 || ov.y !== 0 || ov.z !== 0);
}
const OBJ_OVERRIDE_NAMES = Array.from(new Set([...ALL_DEVICE_OBJECTS, ...CONTROLS_TARGETS]));

// ─────────────────────────────────────────────
// PER-OBJECT COLOR + MATTE OVERRIDE (independent of controls finish)
// ─────────────────────────────────────────────
// ── BRASS-ONLY DEFAULT LOOK ───────────────────────────────────────────────────
// groundingterminal is intentionally left OUT of this table now — its brass
// look (base texture + noise normal) is stamped separately in
// applyObjColorOverrides() below, because it needs to read noiseNormalTex,
// which isn't ready yet when this object literal is first evaluated.
const BRASS_CTRL_LOOK = {
  MultipleKnob:       { matte: 0.3 },
  Screw:              { matte: 0.3 },
  Screw2:             { matte: 0.3 },
};

// Manual per-object overrides from the dev panel (any finish). Empty by
// default — panel toggles populate it. groundingterminal reset to all-null
// so it doesn't fight the brass/stainless default looks below.
const OBJ_COLOR_OVERRIDES = {
  MultipleKnob:       { color: null, matte: 0.32, noNormal: false, brightness: 1.42 },
  Screw:              { color: null, matte: null, noNormal: false, brightness: 1.4  },
  Screw2:             { color: null, matte: null, noNormal: false, brightness: 1.44 },
  groundingterminal:  { color: null, matte: 0.31, noNormal: false, brightness: null },
};
const OBJ_COLOR_OVERRIDES_BASELINE = JSON.parse(JSON.stringify(OBJ_COLOR_OVERRIDES));
const OBJ_COLOR_OVERRIDE_NAMES = ['MultipleKnob', 'Screw', 'Screw2', 'groundingterminal'];
function getObjColorOverride(name) {
  if (!OBJ_COLOR_OVERRIDES[name]) OBJ_COLOR_OVERRIDES[name] = { color: null, matte: null, noNormal: false, brightness: null };
  return OBJ_COLOR_OVERRIDES[name];
}
function resetObjColorOverrides() {
  Object.keys(OBJ_COLOR_OVERRIDES).forEach(k => {
    OBJ_COLOR_OVERRIDES[k] = OBJ_COLOR_OVERRIDES_BASELINE[k]
      ? { ...OBJ_COLOR_OVERRIDES_BASELINE[k] }
      : { color: null, matte: null, noNormal: false, brightness: null };
  });
}

function stampObjLook(name, look) {
  const stamp = mesh => {
    if (!mesh.isMesh) return;
    mesh.material = mesh.material.clone();
    if (look.color != null) {
      mesh.material.color.set(look.color);
      mesh.material.map = null;
      mesh.material.roughnessMap = null;
      mesh.material.metalnessMap = null;
      mesh.material.aoMap = null;
    }
    if (look.matte != null) mesh.material.roughness = look.matte;
    if (look.noNormal) { mesh.material.normalMap = null; if (mesh.material.normalScale) mesh.material.normalScale.set(0, 0); }
    if (look.normalMapTex) {
      let nm = look.normalMapTex;
      const uvScale = look.normalUVScale != null ? look.normalUVScale : 1;
      if (uvScale !== 1) {
        nm = nm.clone();
        nm.repeat.set(uvScale, uvScale);
        nm.wrapS = nm.wrapT = THREE.RepeatWrapping;
        nm.needsUpdate = true;
      }
      mesh.material.normalMap = nm;
      const ns = look.normalScaleVal != null ? look.normalScaleVal : 1;
      if (!mesh.material.normalScale) mesh.material.normalScale = new THREE.Vector2(ns, ns);
      else mesh.material.normalScale.set(ns, ns);
    }
    if (look.brightness != null) {
      mesh.material.color.multiplyScalar(look.brightness);
    }
    mesh.material.needsUpdate = true;
  };

  const obj = objectMap[name];
  if (obj) { if (obj.isMesh) stamp(obj); obj.traverse(stamp); }

  screwClones.forEach(c => {
    if (c.name.split('_gang')[0] !== name) return;
    if (c.isMesh) stamp(c);
    c.traverse(stamp);
  });

  Object.values(slotClones).forEach(bag => Object.values(bag).forEach(clone => {
    const baseName = clone.name.replace(/_slot\d+$/, '').replace(/_lower\d*$/, '');
    if (baseName !== name) return;
    if (clone.isMesh) stamp(clone);
    clone.traverse(stamp);
  }));
}

function applyObjColorOverrides() {
  // 1) Brass default look — ONLY when the brass controls finish is active.
  if (state.controlsFinish === 'brass') {
    Object.entries(BRASS_CTRL_LOOK).forEach(([name, look]) => stampObjLook(name, look));

    // groundingterminal: keep the textured brass base color/material (same
    // as Screw/MultipleKnob/ToggleKnob1), but swap the shared radial-ring
    // normal for the softer noise-based relief instead. Built here (not in
    // BRASS_CTRL_LOOK) so it always reads the CURRENT value of
    // noiseNormalTex, which only becomes non-null after its async load
    // finishes in loadEverything().
    stampObjLook('groundingterminal', {
      matte: 0.3,
      normalMapTex: noiseNormalTex,
      normalUVScale: TW.groundNoiseUVScale,
      normalScaleVal: TW.groundNormalStrength,
    });
  }

  // 1b) Stainless default look for groundingterminal ONLY. Flat silver color
  //     (no stainlessControlPlane base texture — map is nulled by the color
  //     override below), with the same dedicated noisenormal.png normal map
  //     used in the brass path above.
if (state.controlsFinish === 'stainless') {
  stampObjLook('groundingterminal', {
    matte: TW.ctrl_stainless_rough,
    normalMapTex: noiseNormalTex,
    normalUVScale: TW.groundNoiseUVScale,
    normalScaleVal: TW.groundNormalStrength,
  });
}
if (state.controlsFinish === 'agedbronze') {
  stampObjLook('groundingterminal', {
    matte: TW.ctrl_agedbronze_rough,
    normalMapTex: noiseNormalTex,
    normalUVScale: TW.groundNoiseUVScale,
    normalScaleVal: TW.groundNormalStrength,
  });
}
  // 2) Manual dev-panel overrides — stack on top, any finish.
  OBJ_COLOR_OVERRIDE_NAMES.forEach(name => {
    const ov = OBJ_COLOR_OVERRIDES[name];
    if (!ov || (ov.color == null && ov.matte == null && !ov.noNormal && ov.brightness == null)) return;
    stampObjLook(name, ov);
  });
}

// ─────────────────────────────────────────────
// DEVICE TRANSFORM — global scale + offset
// ─────────────────────────────────────────────
const CTRL_DEVICE_OBJECTS = new Set([
  'groundingterminal','retropole',
  'MultipleKnob','dimmersupport',
  '120vDimmerSingle','3Way120vDimmer','lowvol','steplessrotary',
]);
const INSERT_DEVICE_OBJECTS = new Set([
  'Blank','Dimmer','DoubleToggle','Toggle','Rocker',
  'regularinneroutlet','regularouteroutlet',
  'usbacinneroutlet','usbacouteroutlet',
  'innerdoubleusb','outerdoubleusb',
  'GFCI','GFCIouter',
]);

function getDeviceOffset(baseName) {
  const gox = TW.devOffsetX, goy = TW.devOffsetY, goz = TW.devOffsetZ;
  if (baseName === 'groundingterminal') {
    return {
      x: gox + TW.ctrlOffsetX + TW.groundOffsetX,
      y: goy + TW.ctrlOffsetY + TW.groundOffsetY,
      z: goz + TW.ctrlOffsetZ + TW.groundOffsetZ,
    };
  }
  if (baseName === 'retropole') {
    return {
      x: gox + TW.ctrlOffsetX + TW.poleOffsetX,
      y: goy + TW.ctrlOffsetY + TW.poleOffsetY,
      z: goz + TW.ctrlOffsetZ + TW.poleOffsetZ,
    };
  }
  if (CTRL_DEVICE_OBJECTS.has(baseName)) {
    return { x: gox + TW.ctrlOffsetX, y: goy + TW.ctrlOffsetY, z: goz + TW.ctrlOffsetZ };
  }
  if (INSERT_DEVICE_OBJECTS.has(baseName)) {
    return { x: gox + TW.insertOffsetX, y: goy + TW.insertOffsetY, z: goz + TW.insertOffsetZ };
  }
  return { x: gox, y: goy, z: goz };
}

function applyDeviceTransform() {
  const s = TW.devScale;

  function toLocal(wx, wy, wz) {
    if (!model) return { x: wx, y: wy, z: wz };
    const w0 = model.worldToLocal(new THREE.Vector3(0, 0, 0));
    const w1 = model.worldToLocal(new THREE.Vector3(wx, wy, wz));
    return { x: w1.x - w0.x, y: w1.y - w0.y, z: w1.z - w0.z };
  }

  ALL_DEVICE_OBJECTS.forEach(name => {
    const obj = objectMap[name];
    if (!obj || !obj.visible) return;
    const ov = getObjOverride(name);
    obj.scale.setScalar(s * ov.scale);
    if (originalPositions[name]) {
      const woff = getDeviceOffset(name);
      const loffBase = toLocal(woff.x, woff.y, woff.z);
      const loffOv   = toLocal(ov.x, ov.y, ov.z);
      const extraY = obj._extraY || 0;
      obj.position.set(
        originalPositions[name].x + loffBase.x + loffOv.x,
        originalPositions[name].y + extraY + loffBase.y + loffOv.y,
        originalPositions[name].z + loffBase.z + loffOv.z
      );
    }
  });

  Object.values(slotClones).forEach(bag => {
    Object.values(bag).forEach(clone => {
      const baseName = clone.name
        .replace(/_slot\d+.*$/, '')
        .replace(/_lower\d*$/, '');
      const ov = getObjOverride(baseName);
      clone.scale.setScalar(s * ov.scale);
      const woff = getDeviceOffset(baseName);
      const combinedX = woff.x + ov.x, combinedY = woff.y + ov.y, combinedZ = woff.z + ov.z;
      if (combinedX === 0 && combinedY === 0 && combinedZ === 0) return;
      const loff = toLocal(combinedX, combinedY, combinedZ);
      clone.position.x += loff.x;
      clone.position.y += loff.y;
      clone.position.z += loff.z;
    });
  });

  const loff = toLocal(TW.devOffsetX, TW.devOffsetY, TW.devOffsetZ);
  ['Screw','Screw2'].forEach(name => {
    const obj = objectMap[name]; if (!obj || !obj.visible) return;
    const ov = getObjOverride(name);
    obj.scale.setScalar(s * ov.scale);
    const ovLocal = toLocal(ov.x, ov.y, ov.z);
    obj.position.x += loff.x + ovLocal.x;
    obj.position.y += loff.y + ovLocal.y;
    obj.position.z += loff.z + ovLocal.z;
  });
  screwClones.forEach(c => {
    const baseName = c.name.split('_gang')[0];
    const ov = getObjOverride(baseName);
    c.scale.setScalar(s * ov.scale);
    const ovLocal = toLocal(ov.x, ov.y, ov.z);
    c.position.x += loff.x + ovLocal.x;
    c.position.y += loff.y + ovLocal.y;
    c.position.z += loff.z + ovLocal.z;
  });
}

// ─────────────────────────────────────────────
// FINISH APPLIERS
// ─────────────────────────────────────────────
function isFixedClone(c)    { return FIXED_OBJECTS.some(f => c.name.startsWith(f)); }
function isControlsClone(c) { return CONTROLS_TARGETS.some(t => c.name.startsWith(t)); }

function applyControlsFinish(finishId) {
  const key = `controls_${finishId}`;
  applyMatToObjects(CONTROLS_TARGETS.filter(n => !FIXED_OBJECTS.includes(n)), key);
  screwClones.forEach(clone => clone.traverse(c => {
    if (c.isMesh) applyMatToMesh(c, key, clone.name.split('_gang')[0]);
  }));
  Object.values(slotClones).forEach(bag => Object.values(bag).forEach(clone => {
    if (!isControlsClone(clone)) return;
    const baseName = clone.name.split('_slot')[0].replace(/_lower$/, '');
    clone.traverse(c => { if (c.isMesh) applyMatToMesh(c, key, baseName); });
  }));
}

const FINISH_SURCHARGE = {};

function plateFinishLabel(id){ const f = PLATE_FINISHES.find(x => x.id === id); return f ? f.label : id; }
function ctrlFinishLabel(id){ const f = CONTROLS_FINISHES.find(x => x.id === id); return f ? f.label : id; }
function sumEsc(str){ return String(str == null ? '' : str).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }

// ─────────────────────────────────────────────
// SECTIONS EN ACCORDEON
// Une seule section ouverte a la fois : le panneau reste court et la
// simulation reste a portee de vue, meme quand on travaille la gravure.
// Construit a partir du HTML existant, aucun changement de Liquid.
// ─────────────────────────────────────────────
function toggleAccordionBlock(blk) {
  const panel = blk.closest('.config-panel'); if (!panel) return;
  const willOpen = !blk.classList.contains('open');
  panel.querySelectorAll('.cfg-block').forEach(b => b.classList.remove('open'));
  if (willOpen) blk.classList.add('open');
}

function setupAccordions() {
  const panel = document.querySelector('.config-panel'); if (!panel) return;
  const blocks = Array.from(panel.querySelectorAll('.cfg-block'));
  if (!blocks.length) return;

  blocks.forEach(blk => {
    if (blk.dataset.acc === '1') return;
    const head = blk.querySelector('.cfg-block-head'); if (!head) return;
    blk.dataset.acc = '1';

    if (!blk.querySelector(':scope > .cfg-block-body')) {
      const body  = document.createElement('div'); body.className  = 'cfg-block-body';
      const inner = document.createElement('div'); inner.className = 'cfg-block-inner';
      body.appendChild(inner);
      let node = head.nextSibling;
      while (node) { const next = node.nextSibling; inner.appendChild(node); node = next; }
      blk.appendChild(body);
    }

    // Rappel de la taille choisie dans l'entete, visible section repliee.
    if (blk.querySelector('#plateSizeLabel') && !head.querySelector('.cfg-block-current')) {
      const cur = document.createElement('span');
      cur.className = 'cfg-block-current';
      cur.innerHTML = '<span id="sizeHeadCurrent">1 Gang</span>';
      head.appendChild(cur);
    }

    if (!head.querySelector('.cfg-chevron')) {
      const chev = document.createElement('span');
      chev.className = 'cfg-chevron'; chev.setAttribute('aria-hidden', 'true');
      head.appendChild(chev);
    }

    head.setAttribute('role', 'button');
    head.setAttribute('tabindex', '0');
    head.addEventListener('click', () => toggleAccordionBlock(blk));
    head.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleAccordionBlock(blk); }
    });
  });

  // Au premier affichage, seule la premiere section visible est ouverte.
  if (!panel.querySelector('.cfg-block.open')) {
    const first = blocks.find(b => b.style.display !== 'none');
    if (first) first.classList.add('open');
  }
}

function ensureSummary(){
  if (document.getElementById('cfgSummary')) return;
  const panel = document.querySelector('.config-panel');
  if (!panel) return;
  const box = document.createElement('div');
  box.className = 'cfg-summary';
  box.id = 'cfgSummary';
  box.innerHTML =
    '<div class="cfg-summary-title">Your configuration</div>' +
    '<div class="cfg-summary-rows" id="cfgSummaryRows"></div>' +
    '<div class="cfg-summary-foot"><span class="cfg-summary-foot-label">Total</span>' +
    '<span class="cfg-summary-total" id="cfgSummaryTotal">$0.00</span></div>';
  panel.appendChild(box);
}

function updateSummary(){
  ensureSummary();
  const rows = document.getElementById('cfgSummaryRows');
  if (!rows) return;
  let total = PLATE_PRICE_BY_GANG[state.gangCount] || 0;
  state.slots.forEach(s => { total += (DEVICES[s.device]?.price || 0); });
  total += (FINISH_SURCHARGE[state.plateFinish] || 0) + (FINISH_SURCHARGE[state.controlsFinish] || 0);
  const row = (k, v) => '<div class="cfg-sum-row"><span class="cfg-sum-k">' + k + '</span><span class="cfg-sum-v">' + sumEsc(v) + '</span></div>';
  let html = '';
  html += row('Size', state.gangCount + (state.gangCount > 1 ? ' Gangs' : ' Gang'));
  html += row('Plate finish', plateFinishLabel(state.plateFinish));
  html += row('Controls &amp; screws', ctrlFinishLabel(state.controlsFinish));
  state.slots.forEach((s, i) => {
    const dev = DEVICES[s.device];
    let line = dev ? (dev.displayLabel || dev.label) : 'None';
    if (dev && dev.hasAmperage && dev.hasOutletColor) line += ', ' + (s.amperage || '15A') + ', ' + (s.outletColor === 'white' ? 'White' : 'Black');
    else if (dev && dev.hasToggleColor) line += ', Toggle Frame: ' + (s.toggleColor === 'white' ? 'White' : 'Black');
    const engs = engraveEntries(s);
    if (engs.length) {
      line += ', engraving ' + engs.map(e => (e.where ? e.where + ' ' : '') + '"' + e.text + '"').join(' / ') +
              ' (' + engraveStyleLabel(s) + ')';
    }
    html += row('Position ' + (i + 1), line);
  });
  rows.innerHTML = html;
  const tot = document.getElementById('cfgSummaryTotal');
  if (tot) tot.textContent = '$' + total + '.00';
}

function updatePrice() {
  let total = PLATE_PRICE_BY_GANG[state.gangCount] || 0;
  state.slots.forEach(s => {
    total += (DEVICES[s.device]?.price || 0);
  });
  total += (FINISH_SURCHARGE[state.plateFinish]    || 0);
  total += (FINISH_SURCHARGE[state.controlsFinish] || 0);
  const el = document.getElementById('priceDisplay');
  if (el) el.textContent = '$' + total + '.00';
  enforcePlateRules();
  updateSummary();
}

function buildCtrlColorGrid() { /* no-op */ }

// 1. Expose the function to the global namespace defined in your Liquid file
window.configurator = window.configurator || {};
window.configurator.addToCart = addToCart;

// ─────────────────────────────────────────────
// HULK ADD TO CART
// On NE crée PAS les properties nous-mêmes : on remplit le formulaire HulkApps
// (les <select aria-label="...">) puis on clique le bouton submit natif.
// C'est Hulk qui calcule le prix et crée la commande (Draft Order).
// ─────────────────────────────────────────────
// ─────────────────────────────────────────────
// HULK — options en BOUTONS RADIO
// Les options Hulk de ce site sont des <input type="radio"> groupés par data-oid.
// Le libellé de chaque radio est dans son parent (ex: "1 Gang (+$57.00)").
// On regroupe les radios par groupe, on identifie le groupe par le texte de ses
// radios, puis on clique le bon radio par correspondance de texte.
// ─────────────────────────────────────────────

// Construit { oid: [{el, text}, ...] } pour tous les groupes de radios Hulk
function getHulkRadioGroups() {
  const groups = {};
  document.querySelectorAll('input.hulkapps_option_child[type="radio"]').forEach(r => {
    const oid = r.getAttribute('data-oid');
    if (!oid) return;
    const text = (r.parentElement?.textContent || '').trim();
    (groups[oid] = groups[oid] || []).push({ el: r, text });
  });
  return groups;
}

// Trouve l'oid du groupe dont AU MOINS un radio commence par un des `samples` donnés.
// Sert à repérer "Plate Size", "Position N", etc. sans dépendre d'un aria-label.
function findHulkGroupBySamples(groups, samples) {
  const wants = samples.map(s => s.trim().toLowerCase());
  for (const oid in groups) {
    const texts = groups[oid].map(o => o.text.toLowerCase());
    if (wants.some(w => texts.some(t => t.startsWith(w)))) return oid;
  }
  return null;
}

// Coche le radio d'un groupe dont le texte commence par `text`.
// Normalise un libelle pour comparer le code et Hulk sans se soucier des
// differences de caracteres : tirets longs/courts, virgule corrompue, espaces,
// et le suffixe de prix Hulk du type ' (+$93.00)'.
function normalizeHulk(str) {
  return String(str == null ? '' : str)
    .toLowerCase()
    .replace(/[\u2010\u2011\u2012\u2013\u2014\u2015\u2212]/g, '-')
    .replace(/\u201a/g, ',')
    .replace(/\s*\(\+\$[0-9.,]+\)\s*$/, '')
    .replace(/\s+/g, ' ')
    .trim();
}

// Coche le bon radio : on tente d'abord une correspondance exacte (libelle sans
// le prix), puis a defaut une correspondance par debut de texte. L'exact d'abord
// evite qu'un libelle court comme 'Knurled Toggle' attrape par erreur une option
// plus longue comme 'Knurled Toggle Single Pole / 3way'.
function clickHulkRadio(groupArr, text, label) {
  const want = normalizeHulk(text);
  let hit = groupArr.find(o => normalizeHulk(o.text) === want);
  if (!hit) hit = groupArr.find(o => normalizeHulk(o.text).startsWith(want));
  if (!hit) {
    console.warn('[Hulk] valeur introuvable dans «' + label + '» :', text,
      '\n  options dispo:', groupArr.map(o => o.text));
    return false;
  }
  hit.el.checked = true;
  hit.el.click();
  hit.el.dispatchEvent(new Event('change', { bubbles: true }));
  return true;
}

// Ecrit la configuration choisie en proprietes de ligne lisibles, pour qu'elles
// apparaissent dans la commande cote admin (independamment des reglages Hulk).
// Gravures actives d'une position, avec leur emplacement.
// Sur un appareil a deux commandes, chaque interrupteur a sa gravure. La
// seconde n'est retenue que si l'appareil la porte encore : changer d'appareil
// ne doit jamais trainer un texte fantome jusqu'a la commande.
// Source unique pour le recap a l'ecran ET pour les proprietes de commande,
// afin que les deux ne puissent pas diverger.
function engraveEntries(s) {
  const out = [];
  const isPair = PAIR_ENGRAVE_DEVICES.has(s.device);
  const top = (s.engraveText || '').trim();
  if (top) out.push({ where: isPair ? 'top' : '', text: top });
  if (isPair) {
    const bot = (s.engraveText2 || '').trim();
    if (bot) out.push({ where: 'bottom', text: bot });
  }
  return out;
}
function engraveStyleLabel(s) {
  return s.engraveStyle === 'curved' ? 'Curved' : 'Straight';
}

// Photo carree de la plaque telle que le client l'a construite. On redessine
// la scene juste avant de copier le canvas : sans preserveDrawingBuffer, le
// contenu WebGL n'est lisible que dans la meme tache que le rendu.
function capturePlateBlob(type, size, quality) {
  if (!renderer || !scene || !camera) return Promise.resolve(null);
  // Camera encore en mouvement (clic pendant l'animation, ou onglet en arriere
  // plan qui suspend l'animation) : on la pose directement a sa place finale,
  // sinon la plaque sort du cadre.
  if (isAnimating) {
    camera.position.copy(_camTarget);
    if (orbitControls) { orbitControls.target.copy(_orbitTarget); orbitControls.enabled = true; }
    isAnimating = false;
  }
  if (orbitControls) orbitControls.update();
  const outSize = size || 800;
  const src = renderer.domElement;
  // Emprise de la plaque en fraction du canvas (independante de la resolution) :
  // on projette ses coins a l'ecran. A defaut, toute la vue tient dans le carre.
  let fx0 = 0, fy0 = 0, fx1 = 1, fy1 = 1, found = false;
  const plate = plateMgr && plateMgr.getMesh();
  if (plate) {
    const box = new THREE.Box3().setFromObject(plate);
    if (!box.isEmpty()) {
      let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
      const p = new THREE.Vector3();
      for (const x of [box.min.x, box.max.x]) for (const y of [box.min.y, box.max.y]) for (const z of [box.min.z, box.max.z]) {
        p.set(x, y, z).project(camera);
        const sx = (p.x + 1) / 2, sy = (1 - p.y) / 2;
        x0 = Math.min(x0, sx); x1 = Math.max(x1, sx); y0 = Math.min(y0, sy); y1 = Math.max(y1, sy);
      }
      if (x1 > x0 && y1 > y0) { fx0 = x0; fy0 = y0; fx1 = x1; fy1 = y1; found = true; }
    }
  }
  // Haute definition : au lieu d'agrandir l'image de l'ecran (flou), on refait
  // un rendu avec plus de pixels pour que la plaque fasse au moins outSize px,
  // puis on remet la resolution d'origine.
  const pr0 = renderer.getPixelRatio();
  let boosted = false;
  if (found) {
    const sideNow = Math.max((fx1 - fx0) * src.width, (fy1 - fy0) * src.height) * 1.03;
    const cssW = src.width / pr0, cssH = src.height / pr0;
    const maxTex = Math.min(8192, (renderer.capabilities && renderer.capabilities.maxTextureSize) || 4096);
    const prMax = maxTex / Math.max(cssW, cssH);
    const pr = Math.min(pr0 * outSize / sideNow, prMax, 6);
    if (pr > pr0 * 1.05) { renderer.setPixelRatio(pr); boosted = true; }
  }
  renderer.render(scene, camera);
  const W = src.width, H = src.height;
  let cx = W / 2, cy = H / 2, side = Math.max(W, H);
  if (found) {
    cx = (fx0 + fx1) / 2 * W; cy = (fy0 + fy1) / 2 * H;
    side = Math.max((fx1 - fx0) * W, (fy1 - fy0) * H) * 1.03;
  }
  const out = document.createElement('canvas');
  out.width = out.height = outSize;
  const ctx = out.getContext('2d');
  ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
  ctx.fillStyle = '#eeece8';
  ctx.fillRect(0, 0, out.width, out.height);
  const scale = out.width / side;
  ctx.drawImage(src, (out.width / 2) - cx * scale, (out.height / 2) - cy * scale, W * scale, H * scale);
  if (boosted) { renderer.setPixelRatio(pr0); renderer.render(scene, camera); }
  return new Promise(resolve => out.toBlob(resolve, type, quality || 0.85));
}

// Envoie la capture au Worker et renvoie son lien, ou '' en cas de pepin :
// l'ajout au panier ne doit jamais dependre de la capture.
async function uploadPlatePreview() {
  if (!SC_PREVIEW_ENDPOINT) return '';
  try {
    let blob = await capturePlateBlob('image/webp');
    // Safari ne sait pas encoder le WebP et rend du PNG, refuse par le Worker
    if (blob && blob.type !== 'image/webp') blob = await capturePlateBlob('image/jpeg');
    if (!blob) return '';
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), 10000);
    const res = await fetch(SC_PREVIEW_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': blob.type },
      body: blob,
      signal: ctrl.signal,
    });
    clearTimeout(timer);
    const json = await res.json();
    if (json && json.success && /^https:\/\/cdn\.shopify\.com\//.test(json.url)) return json.url;
    console.warn('[Configurateur] capture refusee', json);
  } catch (e) {
    console.warn('[Configurateur] capture impossible', e);
  }
  return '';
}

function injectOrderProperties(form, previewUrl) {
  if (!form) return;
  form.querySelectorAll('input[data-cfg-prop]').forEach(n => n.remove());
  const parts = [];
  parts.push('Size: ' + state.gangCount + (state.gangCount > 1 ? ' Gangs' : ' Gang'));
  parts.push('Plate finish: ' + plateFinishLabel(state.plateFinish));
  parts.push('Controls finish: ' + ctrlFinishLabel(state.controlsFinish));
  state.slots.forEach((s, i) => {
    const dev = DEVICES[s.device];
    let v = dev ? dev.label : 'None';
    if (dev && dev.hasAmperage && dev.hasOutletColor) v += ' ' + (s.amperage || '15A') + ' ' + (s.outletColor === 'white' ? 'White' : 'Black');
    else if (dev && dev.hasToggleColor) v += ' ' + (s.toggleColor === 'white' ? 'White' : 'Black');
    const engs = engraveEntries(s);
    if (engs.length) {
      v += ' [Engraving ' + engs.map(e => (e.where ? e.where + ' ' : '') + '"' + e.text + '"').join(' / ') +
           ', ' + engraveStyleLabel(s) + ']';
    }
    parts.push('P' + (i + 1) + ': ' + v);
  });
  const inp = document.createElement('input');
  inp.type = 'hidden';
  // Le tiret bas devant le nom masque la propriete dans le panier, au checkout
  // et dans les emails de confirmation, tout en la conservant visible dans
  // l'admin Shopify pour la preparation des commandes.
  inp.name = 'properties[_Your configuration]';
  inp.value = parts.join('  |  ');
  inp.setAttribute('data-cfg-prop', '1');
  form.appendChild(inp);

  // Capture : propriete masquee lue par snippets/cart-products.liquid pour
  // remplacer la photo de base, et lien cliquable dans la commande de l'admin.
  if (previewUrl) {
    const pv = document.createElement('input');
    pv.type = 'hidden';
    pv.name = 'properties[_preview]';
    pv.value = previewUrl;
    pv.setAttribute('data-cfg-prop', '1');
    form.appendChild(pv);
  }

  // Gravure : ligne VISIBLE du client dans le panier, le checkout et l'email.
  // Nom volontairement distinct de ceux de Hulk (Plate Size, Plate Finish,
  // Position 1...) pour ne jamais ecraser ses proprietes tarifees.
  // Ajoutee seulement si au moins une position est gravee.
  const eng = [];
  state.slots.forEach((s, i) => {
    engraveEntries(s).forEach(e => {
      eng.push('P' + (i + 1) + (e.where ? ' (' + e.where + ')' : '') + ': ' + e.text +
               ' (' + engraveStyleLabel(s) + ')');
    });
  });
  if (eng.length) {
    const e = document.createElement('input');
    e.type = 'hidden';
    e.name = 'properties[Engraving]';
    e.value = eng.join('  |  ');
    e.setAttribute('data-cfg-prop', '1');
    form.appendChild(e);
  }
}

async function addToCart() {
  // Verrou : un seul ajout a la fois. Le second bouton du recap declenchait
  // des ajouts paralleles qui s'entremelaient (bouton fige, erreurs tardives).
  if (addToCart._busy) return;
  addToCart._busy = true;
  const btn = document.getElementById('btnAddToCart');
  const btn2 = document.getElementById('btnAddToCart2');
  const setButtons = (disabled, label, loading) => {
    [btn, btn2].forEach(b => {
      if (!b) return;
      b.disabled = disabled;
      b.classList.toggle('cfg-loading', !!loading);
      const sp = b.querySelector('span'); if (sp) sp.textContent = label;
    });
  };
  installLoadingStyle();
  setButtons(true, 'Validating configuration', true);
  // Aucun message visible : en cas de pepin on remet juste le bouton en etat
  // et on trace en console pour le diagnostic.
  const fail = msg => {
    console.warn('[Configurateur]', msg);
    setButtons(false, 'Add to Cart');
    addToCart._busy = false;
  };

  // Garde-fou final sur la finition des commandes. L'interface grise deja les
  // finitions impossibles avec un Retro Toggle, mais une commande partie avec
  // une finition infabricable bloque la production et oblige a rappeler le
  // client (cas ST2311Z, Toggle + Dimmer commande en Aged Bronze). On corrige
  // ici, au dernier moment, quel que soit le chemin emprunte dans l'interface.
  if (plateHasRetroToggle() && !RETRO_ALLOWED_FINISHES.has(state.controlsFinish)) {
    console.warn('[Configurateur] finition', state.controlsFinish,
      'impossible avec un Retro Toggle, ramenee a brass avant envoi');
    state.controlsFinish = 'brass';
    refreshControlsFinishGrid();
    updatePrice();
  }

  // Garde-fou final sur les regles de compatibilite (ampérage corrige en
  // silence ; deux combos superposes : on bloque, la note explique pourquoi).
  if (enforcePlateRules().indexOf(MSG_COMBO) !== -1) {
    const n = document.getElementById('plateRulesNote');
    if (n) n.scrollIntoView({behavior:'smooth', block:'center'});
    return fail('deux combos Toggle + Dimmer sur la plaque');
  }

  // Capture lancee tout de suite, en parallele des clics Hulk ci dessous
  const previewPromise = uploadPlatePreview();

  const groups = getHulkRadioGroups();

  // Liste des oid dans l'ordre d'apparition dans le DOM (pour distinguer Position 1..5)
  const orderedOids = [];
  document.querySelectorAll('input.hulkapps_option_child[type="radio"]').forEach(r => {
    const oid = r.getAttribute('data-oid');
    if (oid && !orderedOids.includes(oid)) orderedOids.push(oid);
  });

  // Identifie le groupe "Plate Size" par ses libellés "1 Gang"... "5 Gang"
  const plateSizeOid = findHulkGroupBySamples(groups, ['1 gang', '2 gang', '3 gang']);

  // Identifie les groupes "Position" : ceux qui contiennent les devices (ex "Single Pole 120V Dimmer", "Blank Plate")
  const positionOids = orderedOids.filter(oid => {
    const texts = groups[oid].map(o => o.text.toLowerCase());
    return texts.some(t => t.startsWith('blank plate') || t.startsWith('single pole 120v') || t.startsWith('3-way 120v'));
  });

  // Finitions (optionnel — ne bloque pas si non géré en radio sur ce site)
  // Detection par finitions EXCLUSIVES a chaque groupe. "Aged Bronze" et
  // "Stainless Steel" existent dans les deux groupes, donc on ne les utilise PAS
  // pour identifier le groupe, sinon on risque de tomber sur le mauvais.
  // Libelles Hulk EXACTS releves sur la page. Nos noms d'affichage different
  // des siens : Matte White s'appelle White chez Hulk et Matte Black s'appelle
  // Black. C'est ce qui faisait echouer le clic en silence et disparaitre le
  // champ Plate Finish des commandes en finitions peintes.
  const HULK_PLATE_FINISH = {
    antiquebrass: 'Antique Brass (Hand Brushed)',
    unlacquered:  'Unlacquered Antique Brass (Hand-Brushed)',
    satinbrass:   'Satin Brass',
    hammered:     'Hammered Antique Brass',
    agedbronze:   'Aged Bronze (Hand-Brushed)',
    stainless:    'Stainless Steel',
    matte_black:  'Black',
    matte_white:  'White',
  };
  const HULK_CTRL_FINISH = {
    brass:      'Brass',
    agedbronze: 'Aged Bronze',
    stainless:  'Stainless Steel',
    fullblack:  'Full Black',
    white:      'White',
  };
  // Reperage par valeurs EXCLUSIVES a chaque groupe. White, Black, Stainless
  // Steel et Aged Bronze existent dans les DEUX groupes, on ne s'en sert donc
  // jamais pour identifier un groupe.
  const plateFinishOid = findHulkGroupBySamples(groups,
    ['satin brass', 'hammered antique brass', 'unlacquered antique brass']);
  let ctrlFinishOid = findHulkGroupBySamples(groups, ['full black']);
  // Securite : les boutons radio d'un meme groupe sont exclusifs. Si les deux
  // reperages tombent sur le meme groupe, le clic sur la finition des commandes
  // ecraserait celle de la plaque. On annule alors le second.
  if (ctrlFinishOid && ctrlFinishOid === plateFinishOid) {
    console.warn('[Hulk] groupes plaque et commandes confondus, second clic annule');
    ctrlFinishOid = null;
  }

  // Equivalents au MEME prix uniquement, utilises si une option manque dans
  // Hulk. Vide aujourd'hui : Retro Toggle 4 way est a 37 et Retro Toggle a 35,
  // un repli fausserait la facturation.
  // Replis entre options de MEME prix uniquement. Ici, tant que l'option Hulk
  // s'appelle encore "Retro Toggle", on la coche; une fois renommee en nom
  // complet, la correspondance exacte prend le relais. Les deux sont a 35.
  const HULK_DEVICE_FALLBACK = {
    'Retro Toggle Single Pole / 3way':        'Retro Toggle',
    'Double Retro Toggle Single Pole / 3way': 'Double Retro Toggle',
  };

  let ok = true;

  // ── Plate Size ──
  if (plateSizeOid) ok = clickHulkRadio(groups[plateSizeOid], state.gangCount + ' Gang', 'Plate Size') && ok;
  else { console.warn('[Hulk] groupe Plate Size introuvable'); ok = false; }

  // ── Finitions (non bloquant) ──
  // Un echec de clic sur une finition etait totalement silencieux : le champ
  // disparaissait alors de la commande (cas constate sur Matte White et Matte
  // Black). On essaie plusieurs orthographes, et on trace clairement l'echec
  // avec la liste exacte des options Hulk disponibles.
  const clickFinishGroup = (oid, wanted, groupName) => {
    if (!oid) { console.warn('[Hulk] groupe ' + groupName + ' introuvable sur la page'); return false; }
    if (!wanted) { console.warn('[Hulk] libelle de finition vide pour ' + groupName); return false; }
    if (clickHulkRadio(groups[oid], wanted, groupName)) return true;
    console.warn('[Hulk] ECHEC ' + groupName + ' : aucune correspondance pour «' + wanted + '»',
      '\n  options Hulk disponibles :', groups[oid].map(o => o.text));
    return false;
  };
  clickFinishGroup(plateFinishOid, HULK_PLATE_FINISH[state.plateFinish], 'Plate Finish');
  clickFinishGroup(ctrlFinishOid, HULK_CTRL_FINISH[state.controlsFinish], 'Controls & Screws Finish');

  // ── Positions actives ──
  state.slots.forEach((s, i) => {
    const oid = positionOids[i];
    if (!oid) { console.warn('[Hulk] groupe Position', i + 1, 'introuvable'); ok = false; return; }
    const wanted = buildHulkDeviceLabel(s);
    let done = clickHulkRadio(groups[oid], wanted, 'Position ' + (i + 1));
    // Filet : tant que l'option n'existe pas encore dans Hulk, on coche
    // l'equivalent au MEME prix pour ne pas bloquer la commande. Le detail
    // exact reste dans les proprietes de commande.
    if (!done && HULK_DEVICE_FALLBACK[wanted]) {
      console.warn('[Hulk] option absente, repli sur', HULK_DEVICE_FALLBACK[wanted]);
      done = clickHulkRadio(groups[oid], HULK_DEVICE_FALLBACK[wanted], 'Position ' + (i + 1) + ' (repli)');
    }
    ok = done && ok;
  });

  // ── Positions NON utilisées : cocher "Blank Plate" (ou 1re valeur à $0) ──
  for (let i = state.gangCount; i < positionOids.length; i++) {
    const oid = positionOids[i];
    if (oid) clickHulkRadio(groups[oid], 'Blank Plate', 'Position ' + (i + 1) + ' (reset)');
  }

  // ── Gravure gratuite : non tarifée dans Hulk, rien à cocher ici. ──
  // (le texte de la gravure apparaît déjà dans les spécifications du produit créé)

  if (!ok) {
    return fail('Some options could not be applied. Please refresh the page and try again.');
  }

  // Laisser Hulk recalculer son total avant de soumettre
  await new Promise(r => setTimeout(r, 600));

  // ── Cliquer le bouton submit Hulk : Hulk crée les properties + le panier ──
  // UNIQUEMENT le bouton Hulk : sans lui, un envoi natif ajouterait le produit
  // a 0$ puisque le prix des options est porte par Hulk. On refuse plutot.
  const submitBtn = document.querySelector('.hulkapps_submit_cart');
  if (!submitBtn) return fail('The options system is still loading. Please wait a few seconds and try again.');
  const cartForm = submitBtn.closest('form') || document.querySelector('form[action*="/cart/add"]');
  injectOrderProperties(cartForm, await previewPromise);

  // ── Garde-fou commande gratuite. Aucune comparaison de montants, donc
  // insensible aux remises, aux delais de Hulk et aux ecarts de tables.
  // On ne signale un echec QUE sur la signature exacte du bug : une nouvelle
  // ligne de NOTRE produit qui reste a 0$ apres plusieurs secondes, sans
  // qu'aucune nouvelle ligne payante ne soit apparue dans le panier.
  // La vraie correction du bug des commandes a 0$ : si le script Hulk n'est
  // pas pret, un clic sur son bouton retombe sur l'envoi natif du formulaire
  // a prix zero. On bloque definitivement la soumission native.
  if (cartForm && !cartForm.dataset.nativeBlocked) {
    cartForm.dataset.nativeBlocked = '1';
    cartForm.addEventListener('submit', ev => ev.preventDefault(), true);
    // Trou connu du web : un appel direct a la METHODE form.submit() n'emet
    // pas l'evenement submit, donc contourne le blocage ci dessus. C'est le
    // chemin emprunte dans le navigateur integre d'Instagram. On le ferme.
    try {
      cartForm.submit = function () { console.warn('[Configurateur] envoi natif bloque'); };
      if (cartForm.requestSubmit) cartForm.requestSubmit = function () { console.warn('[Configurateur] envoi natif bloque'); };
    } catch (e) {}
  }

  const drawer = document.querySelector('.cart-drawer__dialog');
  const drawerWasOpen = !!(drawer && drawer.open); setButtons(true, 'Adding to cart', true);
  submitBtn.click();

  // L'animation tourne jusqu'a l'ouverture du tiroir panier (15 s maximum),
  // puis le bouton revient a son etat normal pour un eventuel 2e ajout.
  if (drawer && !drawerWasOpen) {
    for (let i = 0; i < 150 && !drawer.open; i++) await new Promise(r => setTimeout(r, 100));
  } else {
    await new Promise(r => setTimeout(r, 1500));
  }
  setButtons(false, 'Add to Cart');
  addToCart._busy = false;
}

// Petit cercle qui tourne dans le bouton pendant l'ajout au panier.
function installLoadingStyle() {
  if (document.getElementById('cfgLoadingStyle')) return;
  const st = document.createElement('style');
  st.id = 'cfgLoadingStyle';
  st.textContent =
    '.cfg-loading{cursor:progress}' +
    '.cfg-loading svg{display:none}' +
    '.cfg-loading span::after{content:"";display:inline-block;width:.9em;height:.9em;margin-left:.5em;' +
    'vertical-align:-.12em;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;' +
    'animation:cfgSpin .7s linear infinite}' +
    '@keyframes cfgSpin{to{transform:rotate(360deg)}}';
  document.head.appendChild(st);
}

// Construit le libellé EXACT attendu par Hulk pour un slot donné.
// Hulk encode l'ampérage et la couleur dans le libellé pour les outlets,
// et la couleur du toggle pour les knurled. Ex: "Regular Outlet 15A Black".
function buildHulkDeviceLabel(s) {
  const dev = DEVICES[s.device];
  if (!dev) return '';
  let label = dev.label;
  const color = s.outletColor === 'white' ? 'White' : 'Black';
  const tColor = s.toggleColor === 'white' ? 'White' : 'Black';

  if (dev.hasAmperage && dev.hasOutletColor) {
    // ex: "Regular Outlet 15A Black", "USB-A / USB-C 20A White", "GFCI Outlet 15A Black"
    label = dev.label + ' ' + (s.amperage || '15A') + ' ' + color;
  } else if (dev.hasToggleColor) {
    // ex: "Knurled Toggle Single Pole / 3way Black", "Knurled Toggle 4 way White"
    label = dev.label + ' ' + tColor;
  }
  return label;
}
// ─────────────────────────────────────────────
// FINISH GRIDS
// ─────────────────────────────────────────────
// ─────────────────────────────────────────────
// VISIONNEUSE DES FINITIONS REELLES
// Le rendu 3D simule la matiere. Ces photos montrent le produit reel.
// La bande du bas permet de comparer sans jamais fermer la fenetre.
// ─────────────────────────────────────────────
let _finishViewerOnPick = null;
// Evite que la selection faite depuis la visionneuse ne la rouvre par dessus
// elle meme, ce qui faisait perdre le choix a la fermeture.
let _fvSuppressOpen = false;

// Applique la finition choisie depuis la bande de la visionneuse. Declaree
// globalement : enfermee dans resetConfig, elle n'existait qu'apres un Reset,
// et la selection ne suivait pas a la fermeture de la fenetre.
function applyFinishFromViewer(id) {
  const grid = document.getElementById('plateFinishGrid'); if (!grid) return;
  const btns = Array.from(grid.querySelectorAll('.swatch-btn'));
  const i = PLATE_FINISHES.findIndex(x => x.id === id);
  if (i < 0 || !btns[i]) return;
  _fvSuppressOpen = true;
  btns[i].click();
  _fvSuppressOpen = false;
}
_finishViewerOnPick = applyFinishFromViewer;

function openFinishPhoto(finishId) {
  const f = PLATE_FINISHES.find(x => x.id === finishId); if (!f) return;
  let ov = document.getElementById('finishViewer');
  if (!ov) {
    ov = document.createElement('div');
    ov.id = 'finishViewer';
    ov.innerHTML =
      '<div class="fv-box" role="dialog" aria-modal="true">' +
        '<button class="fv-close" type="button" aria-label="Close">&times;</button>' +
        '<div class="fv-caption">Real product photo</div>' +
        '<img class="fv-img" alt="">' +
        '<div class="fv-name"></div>' +
        '<div class="fv-strip"></div>' +
      '</div>';
    document.body.appendChild(ov);
    const close = () => { ov.classList.remove('open'); };
    ov.onclick = e => { if (e.target === ov) close(); };
    ov.querySelector('.fv-close').onclick = close;
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && ov.classList.contains('open')) close();
    });
  }
  const paint = id => {
    const d = PLATE_FINISHES.find(x => x.id === id); if (!d) return;
    const img = ov.querySelector('.fv-img');
    img.src = d.photo || d.swatch; img.alt = d.label + ' finish, real product photo';
    ov.querySelector('.fv-name').textContent = d.label;
    ov.querySelectorAll('.fv-thumb').forEach(t => t.classList.toggle('active', t.dataset.id === id));
  };
  const strip = ov.querySelector('.fv-strip');
  if (!strip.childElementCount) {
    PLATE_FINISHES.forEach(d => {
      const t = document.createElement('button');
      t.type = 'button'; t.className = 'fv-thumb'; t.dataset.id = d.id;
      t.innerHTML = '<img src="' + d.swatch + '" alt="' + d.label + '"><span>' + d.label + '</span>';
      t.onclick = () => { paint(d.id); if (_finishViewerOnPick) _finishViewerOnPick(d.id); };
      strip.appendChild(t);
    });
  }
  paint(finishId);
  ov.classList.add('open');
}

// Note sous la grille des finitions de commandes. Les options indisponibles
// restent visibles mais grisees, avec la raison ecrite : les faire disparaitre
// en silence faisait partir des commandes avec une finition non choisie.
function setCtrlFinishNote(text) {
  const grid = document.getElementById('controlsFinishGrid'); if (!grid) return;
  let note = document.getElementById('ctrlFinishNote');
  if (!note) {
    note = document.createElement('div');
    note.id = 'ctrlFinishNote';
    note.className = 'finish-note';
    grid.parentNode.insertBefore(note, grid.nextSibling);
  }
  note.textContent = text || '';
  note.style.display = text ? 'block' : 'none';
}

function buildFinishGrid(containerId, finishes, currentId, onChange, withPhoto, unavailableIds) {
  const grid = document.getElementById(containerId); if (!grid) return;
  grid.innerHTML = '';
  finishes.forEach(f => {
    const off = !!(unavailableIds && unavailableIds.has(f.id));
    const btn = document.createElement('button');
    btn.className = 'swatch-btn' + (f.id === currentId ? ' active' : '') + (off ? ' unavailable' : '');
    if (off) { btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); }
    btn.innerHTML = `<img class="swatch-img" src="${f.swatch}" alt="${f.label}" onerror="this.style.background='#ccc'"><span>${f.label}</span>`;
    if (!off) btn.onclick = () => {
      grid.querySelectorAll('.swatch-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      onChange(f.id, f.label, f.swatch);
    };
    // La photo du produit reel s'ouvre via la petite loupe, plus a chaque clic :
    // un client qui compare plusieurs finitions devait fermer la fenetre a
    // chaque fois, ce qui ajoutait une etape inutile.
    if (withPhoto) {
      const zoom = document.createElement('button');
      zoom.type = 'button';
      zoom.className = 'swatch-zoom';
      zoom.setAttribute('aria-label', 'See the real product photo of ' + f.label);
      zoom.innerHTML = '<svg viewBox="0 0 16 16" width="13" height="13" fill="none" ' +
        'stroke="currentColor" stroke-width="1.7" stroke-linecap="round">' +
        '<circle cx="6.8" cy="6.8" r="4.3"/><line x1="10" y1="10" x2="13.8" y2="13.8"/></svg>';
      zoom.onclick = ev => { ev.stopPropagation(); openFinishPhoto(f.id); };
      btn.appendChild(zoom);
    }
    grid.appendChild(btn);
  });
}

// ─────────────────────────────────────────────
// POSITION ACCORDIONS
// ─────────────────────────────────────────────
// Un tiroir par position, autant que de gangs choisis. L'ancien bloc unique
// avec ses onglets est masque, mais reste construit pour ne rien casser.
function buildPositionDrawers() {
  const panel = document.querySelector('.config-panel'); if (!panel) return;
  const tabsEl = document.getElementById('positionTabs');
  const srcBlock = tabsEl ? tabsEl.closest('.cfg-block') : null;
  if (!srcBlock) return;
  srcBlock.style.display = 'none';

  let holder = document.getElementById('positionDrawers');
  if (!holder) {
    holder = document.createElement('div');
    holder.id = 'positionDrawers';
    srcBlock.parentNode.insertBefore(holder, srcBlock.nextSibling);
  }
  const openPos = holder.querySelector('.cfg-block.open');
  const keepOpen = openPos ? openPos.dataset.pos : null;
  holder.innerHTML = '';

  for (let i = 0; i < state.gangCount; i++) {
    const sl  = state.slots[i];
    const dev = DEVICES[sl.device];
    const blk = document.createElement('div');
    blk.className = 'cfg-block pos-drawer';
    blk.dataset.pos = String(i);

    const head = document.createElement('div');
    head.className = 'cfg-block-head';
    head.innerHTML =
      '<img class="cfg-block-thumb" src="' + (dev ? dev.thumb : '') + '" alt="">' +
      '<span class="cfg-block-title">Position ' + (i + 1) + '</span>' +
      '<span class="cfg-block-current pos-drawer-current">' +
        (dev ? (dev.displayLabel || dev.label) : '') + '</span>';
    blk.appendChild(head);

    const body  = document.createElement('div'); body.className  = 'cfg-block-body';
    const inner = document.createElement('div'); inner.className = 'cfg-block-inner';
    const hostDiv = document.createElement('div');
    hostDiv.className = 'position-editor';
    hostDiv.id = 'positionEditor_' + i;
    inner.appendChild(hostDiv); body.appendChild(inner); blk.appendChild(body);
    holder.appendChild(blk);

    buildPositionEditor(i, hostDiv);
    if (keepOpen !== null && String(i) === keepOpen) blk.classList.add('open');
  }
  setupAccordions();
}

// Met a jour un seul tiroir apres un changement d'appareil, sans le refermer.
function refreshPositionUI(i) {
  const drawer = document.querySelector('.pos-drawer[data-pos="' + i + '"]');
  if (!drawer) { buildPositionTabs(); buildPositionEditor(); return; }
  const sl = state.slots[i], dev = DEVICES[sl.device];
  const img = drawer.querySelector('.cfg-block-thumb');
  if (img && dev) img.src = dev.thumb;
  const cur = drawer.querySelector('.pos-drawer-current');
  if (cur) cur.textContent = dev ? (dev.displayLabel || dev.label) : '';
  const hostDiv = drawer.querySelector('#positionEditor_' + i);
  if (hostDiv) buildPositionEditor(i, hostDiv);
}

function buildPositionAccordions() {
  buildPositionTabs();
  buildPositionDrawers();
}

// Onglets de position P1..PN. Chaque onglet montre l'appareil déjà choisi.
function buildPositionTabs() {
  const wrap = document.getElementById('positionTabs');
  if (!wrap) return;
  if (state.activePos >= state.gangCount) state.activePos = state.gangCount - 1;
  if (state.activePos < 0) state.activePos = 0;
  wrap.innerHTML = '';
  for (let i = 0; i < state.gangCount; i++) {
    const dev = DEVICES[state.slots[i].device];
    const tab = document.createElement('button');
    tab.type = 'button';
    tab.className = 'pos-tab' + (i === state.activePos ? ' active' : '');
    tab.innerHTML = `<span class="pos-tab-n">P${i + 1}</span><span class="pos-tab-d">${dev ? (dev.displayLabel || dev.label) : ''}</span>`;
    tab.onclick = () => {
      if (state.activePos === i) return;
      state.activePos = i;
      state.viewCat = null;
      buildPositionTabs();
      buildPositionEditor();
    };
    wrap.appendChild(tab);
  }

  // Sens de lecture : plusieurs clients ne savaient pas ou est P1.
  let hint = document.getElementById('posDirHint');
  if (!hint) {
    hint = document.createElement('div');
    hint.id = 'posDirHint';
    hint.style.cssText = 'font-size:11px;color:var(--grey-text);margin:6px 2px 0;';
    wrap.parentNode.insertBefore(hint, wrap.nextSibling);
  }
  hint.textContent = 'Positions run left to right: P1 is the leftmost on the plate.';
  hint.style.display = state.gangCount > 1 ? 'block' : 'none';
}

// Éditeur de la position active : sélecteur de catégorie + une seule rangée
// horizontale d'appareils (avec images), puis sous-options et gravure.
function buildPositionEditor(posIdx, hostEl) {
  const host = hostEl || document.getElementById('positionEditor');
  if (!host) return;
  const idx = (typeof posIdx === 'number') ? posIdx : state.activePos;
  const s = state.slots[idx];
  if (!s) { host.innerHTML = ''; return; }
  const dev = DEVICES[s.device];
  // Categorie affichee propre a chaque position, sinon les tiroirs
  // se marcheraient dessus.
  if (!s._viewCat) s._viewCat = deviceCategory(s.device);
  const cat = CATEGORIES.find(c => c.id === s._viewCat) || CATEGORIES[0];

  const panelEl = host.closest('.config-panel');
  const prevPanelTop = panelEl ? panelEl.scrollTop : 0;
  const prevWinY = window.scrollY;
  const prevCaroEl = host.querySelector('.device-carousel');
  const prevScrollLeft = prevCaroEl ? prevCaroEl.scrollLeft : 0;
  const prevCaroCat = prevCaroEl ? prevCaroEl.dataset.cat : null;
  host.innerHTML = '';

  const seg = document.createElement('div');
  seg.className = 'cat-seg';
  CATEGORIES.forEach(c => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'cat-seg-btn' + (c.id === state.viewCat ? ' active' : '');
    b.textContent = c.label;
    b.onclick = () => { s._viewCat = c.id; buildPositionEditor(idx, host); };
    seg.appendChild(b);
  });
  host.appendChild(seg);

  if (cat.info) {
    const infoRow = document.createElement('div');
    infoRow.className = 'cat-info';
    infoRow.textContent = cat.info;
    host.appendChild(infoRow);
  }

  const caro = document.createElement('div');
  caro.className = 'device-carousel';
  caro.dataset.cat = cat.id;
  cat.devices.forEach(devId => {
    const d = DEVICES[devId]; if (!d) return;
    const isActive = devId === s.device;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'device-btn' + (isActive ? ' active' : '');
    btn.dataset.devId = devId; btn.dataset.slotIndex = idx;
    if (COMBO_DEVICES.has(devId) && comboUsedElsewhere(idx)) {
      btn.disabled = true; btn.classList.add('unavailable'); btn.title = MSG_COMBO;
      btn.style.opacity = '0.4'; btn.style.cursor = 'not-allowed';
    }
    const imgWrap = document.createElement('div'); imgWrap.className = 'db-img-wrap';
    const img = document.createElement('img'); img.src = d.thumb; img.alt = d.displayLabel || d.label;
    img.onerror = () => { imgWrap.style.background = '#ddd'; };
    imgWrap.appendChild(img); btn.appendChild(imgWrap);
    const info = document.createElement('div'); info.className = 'db-info';
    const labelSpan = document.createElement('span'); labelSpan.className = 'db-label'; labelSpan.textContent = d.displayLabel || d.label;
    info.appendChild(labelSpan);
    btn.appendChild(info);
    const devInfo = DEVICE_INFO[devId] || '';
    if (!NO_QMARK_DEVICES.has(devId) && devInfo.length > 0) {
      const qi = document.createElement('button'); qi.type = 'button'; qi.className = 'q-icon';
      qi.dataset.info = devInfo; qi.textContent = '?';
      qi.onmouseenter = e => showTooltip(e, qi);
      qi.onmouseleave = hideTooltip;
      qi.onclick = e => e.stopPropagation();
      btn.appendChild(qi);
    }
    btn.addEventListener('click', e => {
      if (e.target.classList.contains('q-icon')) return;
      selectSlotDevice(idx, devId);
    });
    caro.appendChild(btn);
  });
  host.appendChild(caro);

  const opts = document.createElement('div');
  opts.className = 'pos-opts';
  if (dev && dev.hasAmperage) {
    const row = document.createElement('div');
    row.innerHTML = `<div class="section-title-row" style="margin-top:12px"><span class="device-section-title">Amperage</span></div>`;
    const amp = document.createElement('div'); amp.className = 'amp-toggle';
    ['15A', '20A'].forEach(a => {
      const p = document.createElement('button'); p.type = 'button';
      p.className = 'amp-btn' + (s.amperage === a ? ' active' : '');
      p.textContent = a;
      if (!ampAllowed(s.device, a)) { p.disabled = true; p.classList.add('unavailable'); p.title = MSG_USBC_15A; }
      p.onclick = () => selectAmperage(idx, a, p);
      amp.appendChild(p);
    });
    row.appendChild(amp);
    if (AMP_15A_ONLY.has(s.device)) {
      const n = document.createElement('div'); n.className = 'finish-note'; n.style.display = 'block'; n.textContent = MSG_USBC_15A;
      row.appendChild(n);
    }
    opts.appendChild(row);
  }
  if (dev && dev.hasOutletColor) {
    const row = document.createElement('div');
    row.innerHTML = `
      <div class="section-title-row" style="margin-top:12px"><span class="device-section-title">Outlet Color</span></div>
      <div class="color-options">
        <button type="button" class="color-btn black-btn ${s.outletColor === 'black' ? 'active' : ''}" onclick="selectOutletColor(${idx},'black',this)">Black</button>
        <button type="button" class="color-btn white-btn ${s.outletColor === 'white' ? 'active' : ''}" onclick="selectOutletColor(${idx},'white',this)">White</button>
      </div>`;
    opts.appendChild(row);
  }
  if (dev && dev.hasToggleColor) {
    const row = document.createElement('div');
    row.innerHTML = `
      <div class="section-title-row" style="margin-top:12px"><span class="device-section-title">Toggle Frame Color</span></div>
      <div class="color-options">
        <button type="button" class="color-btn black-btn ${s.toggleColor === 'black' ? 'active' : ''}" onclick="selectToggleColor(${idx},'black',this)">Black</button>
        <button type="button" class="color-btn white-btn ${s.toggleColor === 'white' ? 'active' : ''}" onclick="selectToggleColor(${idx},'white',this)">White</button>
      </div>`;
    opts.appendChild(row);
  }
  // ── GRAVURE PAR POSITION ──
  // Texte, style droit ou incurve, et deux photos d'exemple. La gravure est
  // offerte et son texte part dans les proprietes de commande.
  const engBox = document.createElement('div');
  engBox.className = 'engrave-section';
  const engStyleBtn = (styleId, styleLabel) => {
    const img = ENGRAVE_EXAMPLE_IMAGES[styleId];
    return '<button type="button" class="engrave-style-btn' + (s.engraveStyle === styleId ? ' active' : '') +
      '" data-style="' + styleId + '">' +
      (img ? '<img src="' + img + '" alt="' + styleLabel + ' engraving example" onerror="this.style.display=\'none\'">' : '') +
      '<span>' + styleLabel + '</span></button>';
  };
  // Un appareil a deux commandes recoit deux gravures, une par interrupteur.
  const isPairEngrave = PAIR_ENGRAVE_DEVICES.has(s.device);
  const engLabel = txt =>
    '<div style="font-size:11px;color:var(--grey-text);margin:10px 0 5px;font-family:var(--font-main)">' + txt + '</div>';
  const engInput = (value, which) =>
    '<div class="engrave-input-wrap">' +
      '<input class="engrave-input" type="text" maxlength="9" placeholder="Engraving text…" ' +
        'data-which="' + which + '" value="' + sumEsc(value) + '">' +
      '<span class="engrave-count">' + (value || '').length + '/9</span>' +
    '</div>';

  engBox.innerHTML =
    '<div class="section-title-row" style="margin-top:14px"><span class="device-section-title">Engraving on Plate</span></div>' +
    (isPairEngrave
      ? '<p class="engrave-note">Optional and free, up to 9 characters each in a simple sans serif font. ' +
        'This device has two separate switches, so you can label them individually. ' +
        'Leave a field empty to engrave only one of them.</p>' +
        engLabel('Above the top switch') + engInput(s.engraveText, 'top') +
        engLabel('Above the bottom switch') + engInput(s.engraveText2, 'bottom')
      : '<p class="engrave-note">Optional and free, up to 9 characters in a simple sans serif font. ' +
        'On outlets the text is engraved above the top screw. On switches and dimmers it sits between the top screw and the control. ' +
        'If you would rather have it below, just leave us a note at checkout.</p>' +
        engInput(s.engraveText, 'top')) +
    '<div class="engrave-style-grid">' + engStyleBtn('straight', 'Straight') + engStyleBtn('curved', 'Curved') + '</div>';
  opts.appendChild(engBox);
  engBox.querySelectorAll('.engrave-input').forEach(engField => {
    const which = engField.dataset.which || 'top';
    engField.oninput = () => updateEngrave(idx, engField.value, which, engField);
    // Securite Hulk : la touche Entree dans un champ texte peut declencher
    // l'envoi natif du formulaire, donc un ajout a 0$. On la neutralise.
    engField.onkeydown = ev => { if (ev.key === 'Enter') { ev.preventDefault(); ev.stopPropagation(); } };
  });
  engBox.querySelectorAll('.engrave-style-btn').forEach(b => {
    b.onclick = () => {
      updateEngraveStyle(idx, b.dataset.style);
      engBox.querySelectorAll('.engrave-style-btn').forEach(x => x.classList.remove('active'));
      b.classList.add('active');
    };
  });

  host.appendChild(opts);

  if (prevCaroCat === cat.id) caro.scrollLeft = prevScrollLeft;
  if (panelEl) panelEl.scrollTop = prevPanelTop;
  window.scrollTo(window.scrollX, prevWinY);
}

function buildSlotBody(slotIndex) {
  const body = document.getElementById(`posBody_${slotIndex}`); if (!body) return;
  body.innerHTML = '';
  const s = state.slots[slotIndex];
  const outletAmpDev = ['outlet_regular','outlet_usbc','outlet_double_usbc','outlet_gfci'];
  const sections = [
    {title:'Toggle Switch', info:SECTION_INFO['Toggle Switch'], devices:['toggle_retro','toggle_retro_4way','toggle_double_retro','toggle_knurled_single','toggle_knurled_4way','toggle_plus_dimmer','toggle_opening']},
    {title:'Dimmers',       info:SECTION_INFO['Dimmers'],       devices:['dimmer_120v','dimmer_3way','dimmer_010v','dimmer_strip','fan_speed']},
    {title:'Outlets',       info:SECTION_INFO['Outlets'],       devices:['outlet_gfci','outlet_double_usbc','outlet_usbc','outlet_regular','outlet_rocker']},
    {title:'Blank Plate',   info:null,                          devices:['blank']},
  ];
  sections.forEach(sec => {
    const secDiv = document.createElement('div'); secDiv.className = 'device-section';
    const titleRow = document.createElement('div'); titleRow.className = 'section-title-row';
    const titleEl  = document.createElement('span'); titleEl.className = 'device-section-title'; titleEl.textContent = sec.title;
    titleRow.appendChild(titleEl);
    if (sec.info) {

      const qi = document.createElement('button'); qi.className = 'q-icon';
        qi.dataset.info = sec.info; qi.textContent = '?';

        qi.onmouseenter = e => showTooltip(e, qi);
        qi.onmouseleave = hideTooltip;
        qi.onclick = e => e.stopPropagation();
        titleRow.appendChild(qi);
      }
    secDiv.appendChild(titleRow);
    const grid = document.createElement('div'); grid.className = 'device-grid';
    sec.devices.forEach(devId => {
      const dev = DEVICES[devId]; if (!dev) return;
      const isAmpDev = outletAmpDev.includes(devId);
      const isActive = devId === s.device;
      const btn = document.createElement('button');
      btn.className = 'device-btn' + (isActive ? ' active' : '');
      btn.dataset.devId = devId; btn.dataset.slotIndex = slotIndex;
      const imgWrap = document.createElement('div'); imgWrap.className = 'db-img-wrap';
      const img = document.createElement('img'); img.src = dev.thumb; img.alt = dev.displayLabel || dev.label;
      img.onerror = () => { imgWrap.style.background = '#ddd'; };
      imgWrap.appendChild(img); btn.appendChild(imgWrap);
      const info = document.createElement('div'); info.className = 'db-info';
      const labelSpan = document.createElement('span'); labelSpan.className = 'db-label'; labelSpan.textContent = dev.displayLabel || dev.label;
      info.appendChild(labelSpan);
      if (isAmpDev) {
        const ampRow = document.createElement('div'); ampRow.className = 'db-amp-row';
        ampRow.id = `inlineAmp_${slotIndex}_${devId}`;
        ['15A','20A'].forEach(amp => {
          const pill = document.createElement('button');
          pill.className = 'db-amp-pill' + (s.amperage === amp && isActive ? '' : ' inactive');
          pill.textContent = amp; pill.dataset.amp = amp;
          if (!ampAllowed(devId, amp)) { pill.disabled = true; pill.title = MSG_USBC_15A; }
          pill.onclick = e => {
            e.stopPropagation();
            if (!ampAllowed(devId, amp)) return;
            if (!isActive) selectSlotDevice(slotIndex, devId);
            selectAmperage(slotIndex, amp, pill);
            ampRow.querySelectorAll('.db-amp-pill').forEach(p => { p.classList.toggle('inactive', p.dataset.amp !== amp); });
          };
          ampRow.appendChild(pill);
        });
        info.appendChild(ampRow);
      }
      btn.appendChild(info);
      const devInfo = DEVICE_INFO[devId] || '';
      const showQ   = !NO_QMARK_DEVICES.has(devId) && devInfo.length > 0;
      if (showQ) {
        const qi = document.createElement('button'); qi.className = 'q-icon';
        qi.dataset.info = devInfo; qi.textContent = '?';
        qi.style.cssText = 'position:absolute;top:4px;right:4px;z-index:2;';
        qi.onmouseenter = e => showTooltip(e, qi);
        qi.onmouseleave = hideTooltip;
        qi.onclick = e => e.stopPropagation(); // évite que le clic sélectionne le produit
        btn.appendChild(qi);
      }
      btn.addEventListener('click', e => {
        if (e.target.classList.contains('q-icon') || e.target.classList.contains('db-amp-pill')) return;
        selectSlotDevice(slotIndex, devId);
      });
      grid.appendChild(btn);
    });
    secDiv.appendChild(grid);
    if (sec.title === 'Outlets') {
      const colorWrap = document.createElement('div'); colorWrap.id = `outletColorWrap_${slotIndex}`;
      colorWrap.style.display = outletAmpDev.includes(s.device) ? 'block' : 'none';
      colorWrap.innerHTML = `
        <div class="section-title-row" style="margin-top:10px"><span class="device-section-title">Outlet Color</span></div>
        <div class="color-options">
          <button class="color-btn black-btn ${s.outletColor==='black'?'active':''}" onclick="selectOutletColor(${slotIndex},'black',this)">Black</button>
          <button class="color-btn white-btn ${s.outletColor==='white'?'active':''}" onclick="selectOutletColor(${slotIndex},'white',this)">White</button>
        </div>`;
      secDiv.appendChild(colorWrap);
    }
    if (sec.title === 'Toggle Switch') {
      const tWrap = document.createElement('div'); tWrap.id = `toggleColorWrap_${slotIndex}`;
      tWrap.style.display = ['toggle_knurled_single','toggle_knurled_4way'].includes(s.device) ? 'block' : 'none';
      tWrap.innerHTML = `
        <div class="section-title-row" style="margin-top:10px"><span class="device-section-title">Toggle Frame Color</span></div>
        <div class="color-options">
          <button class="color-btn black-btn ${s.toggleColor==='black'?'active':''}" onclick="selectToggleColor(${slotIndex},'black',this)">Black</button>
          <button class="color-btn white-btn ${s.toggleColor==='white'?'active':''}" onclick="selectToggleColor(${slotIndex},'white',this)">White</button>
        </div>`;
      secDiv.appendChild(tWrap);
    }
    body.appendChild(secDiv);
  });
  const engDiv = document.createElement('div'); engDiv.className = 'engrave-section';
  engDiv.innerHTML = `
    <div class="section-title-row" style="margin-top:12px"><span class="device-section-title">Engraving on Plate</span></div>
<p style="font-size:11px;color:#999;margin-bottom:8px;font-family:var(--font-main)">Optional engraving.</p>    <div class="engrave-input-wrap">
      <input class="engrave-input" type="text" maxlength="9" placeholder="Engraving Text…" value="${s.engraveText}" oninput="updateEngrave(${slotIndex},this.value)">
      <span class="engrave-count">${s.engraveText.length}/9</span>
    </div>
    <div class="engrave-style">
      <label class="radio-opt ${s.engraveStyle==='straight'?'active-radio':''}">
        <input type="radio" name="engraveStyle_${slotIndex}" value="straight" ${s.engraveStyle==='straight'?'checked':''} onchange="updateEngraveStyle(${slotIndex},'straight',this.closest('.engrave-style'))"> Straight
      </label>
      <label class="radio-opt ${s.engraveStyle==='curved'?'active-radio':''}">
        <input type="radio" name="engraveStyle_${slotIndex}" value="curved" ${s.engraveStyle==='curved'?'checked':''} onchange="updateEngraveStyle(${slotIndex},'curved',this.closest('.engrave-style'))"> Curved
      </label>
    </div>`;
  body.appendChild(engDiv);
}

// ─────────────────────────────────────────────
// TOOLTIP
// ─────────────────────────────────────────────
const tooltipEl = document.getElementById('tooltipPopup');

function showTooltip(e, btn) {
  e.stopPropagation();
  const info = btn.dataset.info; if (!info) return;
  tooltipEl.textContent = info;
  tooltipEl.classList.add('visible');

  const r = btn.getBoundingClientRect();
  let left = r.left + r.width / 2 - 110;
  let top  = r.top - 48;

  left = Math.max(8, Math.min(left, window.innerWidth - 228));
  if (top < 8) top = r.bottom + 8;

  tooltipEl.style.left = left + 'px';
  tooltipEl.style.top = top + 'px';
}

function hideTooltip() {
  tooltipEl.classList.remove('visible');
}

document.addEventListener('click', hideTooltip);

// ─────────────────────────────────────────────
// EVENT HANDLERS
// ─────────────────────────────────────────────
function renderSizeStepper() {
  const head = document.getElementById('sizeHeadCurrent');
  const lbl = document.getElementById('plateSizeLabel');
  if (lbl) lbl.textContent = state.gangCount + ' Gang';
  if (head) head.textContent = state.gangCount + (state.gangCount > 1 ? ' Gangs' : ' Gang');
  const minus = document.getElementById('sizeMinus');
  const plus  = document.getElementById('sizePlus');
  if (minus) minus.disabled = state.gangCount <= 1;
  if (plus)  plus.disabled  = state.gangCount >= 5;
  const hint = document.getElementById('sizeHint');
  if (hint) hint.textContent = state.gangCount >= 5 ? 'For 6 gangs and more, contact us for a custom quote.' : '';
}

function setGang(gangCount) {
  gangCount = Math.max(1, Math.min(5, gangCount));
  state.gangCount = gangCount;
  while (state.slots.length < gangCount) state.slots.push(GANG_SLOT());
  state.slots.length = gangCount;
  if (state.activePos >= gangCount) state.activePos = gangCount - 1;
  state.viewCat = null;
  const v = camViewFor(gangCount);
  smoothCameraTo(v.x, v.y, v.z);
  renderSizeStepper();
  buildPositionAccordions();
  renderScene();
}

function stepGang(delta) {
  setGang(state.gangCount + delta);
}

// Conservé pour compatibilité au cas où un appel externe l'utiliserait.
function selectSize(gangCount) {
  setGang(gangCount);
}

// Dessine la grille des finitions de commandes en appliquant la regle Retro
// Toggle. Chemin UNIQUE : la grille etait construite a trois endroits, et deux
// d'entre eux ignoraient la regle, si bien qu'une reconstruction rendait les
// finitions interdites a nouveau cliquables.
function refreshControlsFinishGrid() {
  const isRetro = plateHasRetroToggle();
  if (isRetro && !RETRO_ALLOWED_FINISHES.has(state.controlsFinish)) {
    state.controlsFinish = 'brass';
    const cl = document.getElementById('controlsFinishLabel'); if (cl) cl.textContent = 'Brass';
    const ct = document.getElementById('controlsFinishThumb');
    if (ct) {
      const b = CONTROLS_FINISHES.find(f => f.id === 'brass');
      if (b) ct.src = b.swatch;
    }
    applyControlsFinish('brass');
  }
  const unavailable = isRetro
    ? new Set(CONTROLS_FINISHES.filter(f => !RETRO_ALLOWED_FINISHES.has(f.id)).map(f => f.id))
    : null;
  buildFinishGrid(
    'controlsFinishGrid',
    CONTROLS_FINISHES,
    state.controlsFinish,
    (id, label, swatch) => {
      state.controlsFinish = id;
      const cl = document.getElementById('controlsFinishLabel'); if (cl) cl.textContent = label;
      const ct = document.getElementById('controlsFinishThumb'); if (ct) ct.src = swatch;
      applyControlsFinish(id);
      renderScene();
    },
    false,
    unavailable
  );
  setCtrlFinishNote(isRetro
    ? 'Retro Toggles are only made in Brass and Stainless Steel. This includes the Retro Toggle on its own, the 4 way, the Double, and the one inside the Toggle + Dimmer combo. The other controls finishes stay unavailable while such a toggle is on the plate, and your selection was set to Brass.'
    : '');
}

function selectSlotDevice(slotIndex, devId) {
  if (COMBO_DEVICES.has(devId) && comboUsedElsewhere(slotIndex)) return;
  state.slots[slotIndex].device = devId;
  if (!ampAllowed(devId, state.slots[slotIndex].amperage)) state.slots[slotIndex].amperage = '15A';
  refreshControlsFinishGrid();
  if (state.activePos !== slotIndex) state.activePos = slotIndex;
  state.slots[slotIndex]._viewCat = deviceCategory(devId);
  refreshPositionUI(slotIndex);
  renderScene();
  recenterOrbitTarget();
}

function selectAmperage(slotIndex, amp, btn) {
  if (!ampAllowed(state.slots[slotIndex].device, amp)) return;
  state.slots[slotIndex].amperage = amp;
  btn.closest('.amp-toggle')?.querySelectorAll('.amp-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  // Sans ceci le recap continuait d'afficher 15A apres un clic sur 20A :
  // la valeur etait bien enregistree mais l'affichage n'etait jamais redessine.
  updatePrice();
}
function selectOutletColor(slotIndex, color, btn) {
  state.slots[slotIndex].outletColor = color;
  btn.closest('.color-options').querySelectorAll('.color-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active'); renderScene();
}
function selectToggleColor(slotIndex, color, btn) {
  state.slots[slotIndex].toggleColor = color;
  btn.closest('.color-options').querySelectorAll('.color-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active'); renderScene();
}

// ─────────────────────────────────────────────
// ENGRAVING
// ─────────────────────────────────────────────
const DOUBLE_TOGGLE_DEVICES = new Set([
  'toggle_plus_dimmer','knurled_plus_dimmer','toggle_double_knurled','toggle_double_retro',
  'outlet_rocker','outlet_regular','outlet_usbc','outlet_double_usbc','outlet_gfci'
]);

// Appareils qui portent DEUX commandes distinctes, l'une au dessus de l'autre.
// Chacune peut recevoir sa propre gravure, puisqu'elles pilotent deux circuits
// differents. Les prises n'en font pas partie : elles n'ont qu'un seul appareil
// derriere une grande ouverture, donc une seule gravure.
// toggle_double_knurled et knurled_plus_dimmer ne sont pas proposes au client
// aujourd'hui ; ils sont listes pour que la double gravure suive si tu les
// remets dans le catalogue.
const PAIR_ENGRAVE_DEVICES = new Set([
  'toggle_double_retro','toggle_plus_dimmer','toggle_double_knurled','knurled_plus_dimmer'
]);

function buildEngraveCanvas(text, style) {
  const W = 1024, H = 1024;
  const cvs = document.createElement('canvas'); cvs.width = W; cvs.height = H;
  const ctx = cvs.getContext('2d'); ctx.clearRect(0, 0, W, H);
  const col      = TW.engraveColor || '#c8a84b';
  const fontName = TW.engraveFont || (basicFontReady && basicFontFace ? 'BasicCanvas' : 'Georgia, serif');
  const cx       = W / 2;
  const fontSize = Math.round(W * TW.engraveFontSize);
  if (style === 'curved') {
    // Texte reellement courbe : chaque lettre est posee sur l'arc ET pivotee
    // pour suivre sa tangente. Une seule fine ligne d'arc sous le texte, pas
    // de cadre en eventail.
    ctx.font = `bold ${fontSize}px ${fontName}`; ctx.fillStyle = col;
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';

    const arcY   = H * TW.arcCenterY;
    // Cadre en eventail : arc exterieur, arc interieur et les deux cotes.
    const outerR = W * TW.arcOuterR, innerR = W * TW.arcInnerR;
    const span   = TW.arcSpan;
    const sA = -Math.PI / 2 - span / 2, eA = -Math.PI / 2 + span / 2;
    ctx.strokeStyle = col; ctx.lineWidth = TW.arcLineWidth;
    ctx.beginPath(); ctx.arc(cx, arcY, outerR, sA, eA); ctx.stroke();
    ctx.beginPath(); ctx.arc(cx, arcY, innerR, sA, eA); ctx.stroke();
    [sA, eA].forEach(ang => {
      ctx.beginPath();
      ctx.moveTo(cx + outerR * Math.cos(ang), arcY + outerR * Math.sin(ang));
      ctx.lineTo(cx + innerR * Math.cos(ang), arcY + innerR * Math.sin(ang));
      ctx.stroke();
    });

    // Texte centre entre les deux arcs, chaque lettre pivotee sur sa tangente.
    const R      = W * (TW.arcTextRadius ?? ((TW.arcOuterR + TW.arcInnerR) / 2));
    const totalW = ctx.measureText(text).width;
    const totalA = R > 0 ? totalW / R : 0;

    let a = -Math.PI / 2 - totalA / 2;
    for (let i = 0; i < text.length; i++) {
      const cw = ctx.measureText(text[i]).width;
      a += (cw / 2) / R;
      ctx.save();
      ctx.translate(cx + R * Math.cos(a), arcY + R * Math.sin(a));
      ctx.rotate(a + Math.PI / 2);
      ctx.fillText(text[i], 0, 0);
      ctx.restore();
      a += (cw / 2) / R;
    }


  } else {
    const ty = H * TW.engraveLineY;
    ctx.font = `bold ${fontSize}px ${fontName}`; ctx.fillStyle = col;
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.fillText(text, cx, ty);
  }
  return cvs;
}

function createEngraveMaterial(tex) {
  return new THREE.ShaderMaterial({
    uniforms: { map: { value: tex } },
    vertexShader: `varying vec2 vUv; void main(){ vUv=uv; gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.0); }`,
    fragmentShader: `uniform sampler2D map; varying vec2 vUv; void main(){ vec4 c=texture2D(map,vUv); if(c.a<0.05) discard; gl_FragColor=vec4(c.rgb,c.a); }`,
    transparent: true, depthWrite: false, side: THREE.DoubleSide,
  });
}

function placeEngraveDecal(slotIndex, slotState) {
  if (!scene) return;
  // Une position peut porter deux gravures : la cle numerique pour celle du
  // haut (ou l'unique), la cle suffixee '_b' pour celle du bas. On nettoie
  // toujours les deux, sinon changer d'appareil laisserait un orphelin.
  [slotIndex, slotIndex + '_b'].forEach(key => {
    const prev = engraveDecals[key];
    if (!prev) return;
    if (prev.parent) prev.parent.remove(prev);
    prev.geometry.dispose();
    if (prev.material.map) prev.material.map.dispose();
    prev.material.dispose();
    delete engraveDecals[key];
  });

  const slotCenterX = slotIndex * getSlotWidth() + TW.decalOffX;
  const isCurved    = slotState.engraveStyle === 'curved';
  const plateFrontZ = TW.plateThickness / 2 + 0.005 + TW.decalOffZ;
  const pSize       = TW.plateW * TW.decalScale;

  const addDecal = (rawText, decalY, key) => {
    const text = (rawText || '').trim(); if (!text) return;
    const cvs = buildEngraveCanvas(text, slotState.engraveStyle);
    const tex = new THREE.CanvasTexture(cvs);
    const geo = new THREE.PlaneGeometry(pSize, pSize);
    const d   = new THREE.Mesh(geo, createEngraveMaterial(tex));
    d.position.set(slotCenterX, decalY, plateFrontZ);
    d.rotation.y = 0;
    scene.add(d);
    engraveDecals[key] = d;
  };

  // Deux commandes : une gravure au dessus de chacune.
  if (PAIR_ENGRAVE_DEVICES.has(slotState.device)) {
    addDecal(slotState.engraveText,  isCurved ? TW.posYPairTopCurve : TW.posYPairTopStraight, slotIndex);
    addDecal(slotState.engraveText2, isCurved ? TW.posYPairBotCurve : TW.posYPairBotStraight, slotIndex + '_b');
    return;
  }

  const isDoubleTgl = DOUBLE_TOGGLE_DEVICES.has(slotState.device);
  const decalY = isDoubleTgl ? (isCurved ? TW.posYDoubleCurve : TW.posYDoubleStraight) : (isCurved ? TW.posYSingleCurve : TW.posYSingleStraight);
  addDecal(slotState.engraveText, decalY, slotIndex);
}

function refreshEngraveOverlay() {
  clearEngraveDecals();
  state.slots.forEach((s, i) => placeEngraveDecal(i, s));
}
// which : 'top' (gravure unique, ou commande du haut) ou 'bottom'.
// fieldEl : le champ saisi, pour mettre a jour SON compteur de caracteres.
// Sans lui on tombait toujours sur le premier compteur de la page, ce qui
// faussait l'affichage des que deux champs cohabitent.
function updateEngrave(slotIndex, val, which, fieldEl) {
  const key = (which === 'bottom') ? 'engraveText2' : 'engraveText';
  state.slots[slotIndex][key] = val.slice(0, 9);
  const len = state.slots[slotIndex][key].length;
  const c = fieldEl
    ? (fieldEl.closest('.engrave-input-wrap') || document).querySelector('.engrave-count')
    : document.querySelector('#positionEditor .engrave-count');
  if (c) c.textContent = len + '/9';
  updatePrice();
  placeEngraveDecal(slotIndex, state.slots[slotIndex]);
}
function updateEngraveStyle(slotIndex, style, container) {
  state.slots[slotIndex].engraveStyle = style;
  if (container) container.querySelectorAll('.radio-opt').forEach(l => l.classList.toggle('active-radio', l.querySelector('input').value === style));
  updatePrice();
  placeEngraveDecal(slotIndex, state.slots[slotIndex]);
}

// ─────────────────────────────────────────────
// ACCORDION
// ─────────────────────────────────────────────
function toggleAccordion(trigger) {
  const body = trigger.nextElementSibling;
  const wasOpen = trigger.classList.contains('open');
  document.querySelectorAll('.accordion-trigger').forEach(t => t.classList.remove('open'));
  document.querySelectorAll('.accordion-body').forEach(b => b.classList.remove('open'));
  if (!wasOpen) { trigger.classList.add('open'); body.classList.add('open'); }
}

// ─────────────────────────────────────────────
// RESET
// ─────────────────────────────────────────────
function resetConfig() {
  state.plateFinish = 'satinbrass'; state.controlsFinish = 'brass';
  state.gangCount = 1; state.activePos = 0; state.viewCat = null; state.slots = [DEFAULT_SLOT()];
  universalCtrlColor = null;
  if (model) { hideAllDeviceObjects(); clearScrewClones(); }
  buildFinishGrid('plateFinishGrid', PLATE_FINISHES, state.plateFinish, (id, label, swatch) => {
    state.plateFinish = id;
    const l = document.getElementById('plateFinishLabel'); if (l) l.textContent = label;
    const t = document.getElementById('plateFinishThumb'); if (t) t.src = swatch;
    const fp = document.getElementById('finishPreview'); if (fp) fp.src = PLATE_PREVIEW_IMAGES[id] || swatch;
    if (plateMgr) plateMgr.updateFinish(`plate_${id}`);
    renderScene();
  }, true);
  refreshControlsFinishGrid();
  const pl = document.getElementById('plateFinishLabel'); if (pl) pl.textContent = 'Satin Brass';
  const pt = document.getElementById('plateFinishThumb'); if (pt) pt.src = 'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/plate_satinbrass.png?v=1780921033';
  const cl = document.getElementById('controlsFinishLabel'); if (cl) cl.textContent = 'Brass';
  const ct = document.getElementById('controlsFinishThumb'); if (ct) ct.src = 'https://cdn.shopify.com/s/files/1/0984/1075/8528/files/controls_brass.png?v=1780921033';
  renderSizeStepper();
  buildPositionAccordions();
  renderScene();
  const vr = camViewFor(state.gangCount);
  smoothCameraTo(vr.x, vr.y, vr.z);
}

// ─────────────────────────────────────────────
// DRAG HINT
// ─────────────────────────────────────────────
function initPhotoMode() {
  const canvasWrap = document.getElementById('canvasWrap');
  if (canvasWrap) {
    const cv = document.getElementById('threeCanvas'); if (cv) cv.style.display = 'none';
    let fp = document.getElementById('finishPreview');
    if (!fp) {
      fp = document.createElement('img');
      fp.id = 'finishPreview';
      fp.alt = 'Selected finish';
      canvasWrap.appendChild(fp);
    }
    const def = PLATE_FINISHES.find(f => f.id === state.plateFinish) || PLATE_FINISHES[0];
    if (def) fp.src = PLATE_PREVIEW_IMAGES[def.id] || def.swatch;
  }
  document.getElementById('loader').classList.add('hidden');
  const appEl = document.getElementById('app');
  appEl.style.display = 'block'; appEl.classList.add('visible');
  renderScene();
}

// Retour depuis le panier : le navigateur restaure parfois une copie figee de
// la page (bfcache) ou le script de prix Hulk se reveille avec un etat perime,
// ce qui fait partir les ajouts suivants a 0$. On force un vrai rechargement.
window.addEventListener('pageshow', e => { if (e.persisted) location.reload(); });

document.addEventListener('DOMContentLoaded', () => {
  buildFinishGrid('plateFinishGrid', PLATE_FINISHES, 'satinbrass', (id, label, swatch) => {
    state.plateFinish = id;
    document.getElementById('plateFinishLabel').textContent = label;
    document.getElementById('plateFinishThumb').src = swatch;
    const fp = document.getElementById('finishPreview'); if (fp) fp.src = PLATE_PREVIEW_IMAGES[id] || swatch;
    if (plateMgr) plateMgr.updateFinish(`plate_${id}`);
    renderScene();
  }, true);
  refreshControlsFinishGrid();
  buildPositionAccordions();
  renderSizeStepper();

  // ── 3D PAR DEFAUT, VERSION PHOTO EN SECOURS ──
  // Le modele 3D est charge directement. Si le fichier est introuvable ou que
  // le chargement echoue, on bascule automatiquement sur la version photo.
  setupAccordions();
  loadEverything().catch(err => {
    console.warn('[3D] Chargement impossible, bascule en version photo.', err);
    initPhotoMode();
  });
});
// ═══════════════════════════════════════════════════════════════════════════
// PROTECTION CONTRE LES COMMANDES A 0 DOLLAR  (v2)
// ═══════════════════════════════════════════════════════════════════════════
// Le produit Custom Configurator vaut 0,00 au catalogue : c'est Hulk qui porte
// le prix des options, et il ne l'applique que si l'ajout passe par lui. Un
// ajout qui emprunte le formulaire natif du theme part donc avec les options
// mais sans prix, et la ligne arrive a 0,00 (commande ST2341Z, 501 dollars
// encaisses a zero). Signature : les proprietes Plate Size, Plate Finish et
// Position N sont la, mais la propriete "Custom Product" manque.
//
// v1 bloquait TOUTE soumission du formulaire du configurateur. Or Hulk soumet
// lui meme ce formulaire pendant son traitement : le blocage se declenchait
// donc sur un ajout parfaitement legitime, affichait un message d'alerte au
// client et retardait la mise a jour du panier, alors que le prix finissait
// par s'appliquer correctement.
// v2 ouvre une fenetre de tolerance des qu'un clic touche le bouton de Hulk,
// y compris le clic programmatique declenche par notre propre ajout. Pendant
// cette fenetre, c'est Hulk qui travaille et on ne s'interpose pas. En dehors,
// on bloque, et on relance NOTRE ajout plutot que d'avertir : le client
// obtient son article au bon prix au lieu d'un message d'erreur. Le message
// ne reste que pour le cas desespere ou rien ne peut etre relance.
(function installZeroPriceGuards() {
  'use strict';

  var CONFIGURATOR_VARIANT_ID = '58336359907712';
  var BLOCKED_MSG = 'We could not add your configuration at the correct price. '
    + 'Please reload the page and try again. If it happens again, contact us on live chat '
    + 'and we will finalize your order for you.';
  var HULK_WINDOW_MS = 20000;
  var lastNotice = 0;
  var hulkFlowUntil = 0;

  function hulkFlowActive() { return Date.now() < hulkFlowUntil; }

  function notifyBlocked() {
    var now = Date.now();
    if (now - lastNotice < 5000) return;
    lastNotice = now;
    try { window.alert(BLOCKED_MSG); } catch (e) {}
  }

  // Relance notre propre ajout, celui qui passe par Hulk et applique le prix.
  function tryOurAddToCart() {
    var fn = null;
    if (window.configurator && typeof window.configurator.addToCart === 'function') {
      fn = window.configurator.addToCart;
    } else if (typeof addToCart === 'function') {
      fn = addToCart;
    }
    if (!fn) return false;
    try { fn(); return true; } catch (e) { return false; }
  }

  function handleBlocked(what) {
    console.warn('[Configurateur] ajout sans prix intercepte (' + what + ')');
    if (tryOurAddToCart()) return;
    notifyBlocked();
  }

  // Le formulaire a proteger est celui du Custom Configurator, et lui seul :
  // produits recommandes, ajout rapide et paiement en plusieurs fois doivent
  // continuer de fonctionner normalement.
  function isConfiguratorCartForm(form) {
    if (!form || !form.action || String(form.action).indexOf('/cart/add') === -1) return false;
    if (/installment/i.test(form.id || '')) return false;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput && String(idInput.value) === CONFIGURATOR_VARIANT_ID) return true;
    var root = document.querySelector('.configurator-root');
    var section = root && root.closest ? root.closest('.shopify-section') : null;
    return !!(section && section.contains(form));
  }

  // 1. Tout clic qui touche le bouton de Hulk ouvre la fenetre de tolerance.
  //    Place avant les autres ecouteurs de clic pour etre vu en premier.
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (t && t.closest && t.closest('.hulkapps_submit_cart')) {
      hulkFlowUntil = Date.now() + HULK_WINDOW_MS;
    }
  }, true);

  // 2. Soumission classique du formulaire.
  document.addEventListener('submit', function (ev) {
    if (!isConfiguratorCartForm(ev.target)) return;
    if (hulkFlowActive()) return;              // Hulk est en train de traiter
    ev.preventDefault();
    ev.stopPropagation();
    handleBlocked('submit');
  }, true);

  // 3. Appel direct aux METHODES submit() et requestSubmit(), qui n'emettent
  //    aucun evenement submit et contournaient donc le point 2. On patche le
  //    prototype une fois pour toutes : un formulaire redessine par le theme
  //    reste couvert, contrairement a un patch pose sur l'element.
  try {
    var nativeSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      if (isConfiguratorCartForm(this) && !hulkFlowActive()) { handleBlocked('submit()'); return; }
      return nativeSubmit.apply(this, arguments);
    };
    if (HTMLFormElement.prototype.requestSubmit) {
      var nativeRequestSubmit = HTMLFormElement.prototype.requestSubmit;
      HTMLFormElement.prototype.requestSubmit = function () {
        if (isConfiguratorCartForm(this) && !hulkFlowActive()) { handleBlocked('requestSubmit()'); return; }
        return nativeRequestSubmit.apply(this, arguments);
      };
    }
  } catch (e) {}

  // 4. Le bouton Add to cart du theme reste visible sur la page. Plutot que de
  //    le laisser partir sans prix, on le branche sur notre propre ajout.
  //    btn.form est utilise avant closest('form') : un bouton peut etre relie
  //    a son formulaire par l'attribut form= sans etre a l'interieur.
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    if (t.closest('.configurator-root')) return;          // nos boutons a nous
    if (t.closest('.hulkapps_submit_cart')) return;       // le bouton de Hulk
    if (hulkFlowActive()) return;                         // ajout deja en cours
    var btn = t.closest('button[name="add"], button[type="submit"], add-to-cart-component');
    if (!btn) return;
    var form = btn.form || (btn.closest ? btn.closest('form') : null);
    if (!isConfiguratorCartForm(form)) return;
    ev.preventDefault();
    ev.stopPropagation();
    handleBlocked('bouton du theme');
  }, true);
})();

// ═══════════════════════════════════════════════════════════════════════════
// SEE IT ON MY WALL
// ═══════════════════════════════════════════════════════════════════════════
// Le client charge une photo de son mur. La capture exacte de sa plaque et la
// photo partent au Worker (route /wall), qui fait faire le rendu par kie.ai
// (Nano Banana Edit). On interroge /wall/status jusqu'au resultat. La photo
// n'est jamais gardee chez nous : kie.ai l'efface au bout de 24 h.
(function installSeeOnWall() {
  'use strict';
  var POLL_MS = 2500, TIMEOUT_MS = 120000;
  var RATIOS = { '1:1': 1, '9:16': 9 / 16, '16:9': 16 / 9, '3:4': 3 / 4, '4:3': 4 / 3, '3:2': 3 / 2, '2:3': 2 / 3, '5:4': 5 / 4, '4:5': 4 / 5 };
  var wallBlob = null, wallRatio = 'auto', busy = false;

  function nearestRatio(w, h) {
    var r = w / h, best = '1:1', d = Infinity;
    Object.keys(RATIOS).forEach(function (k) { var x = Math.abs(Math.log(RATIOS[k] / r)); if (x < d) { d = x; best = k; } });
    return best;
  }

  // Photo du telephone ramenee a 1600 px de cote maximum, en JPEG.
  function shrink(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () {
        var s = Math.min(1, 1600 / Math.max(img.naturalWidth, img.naturalHeight));
        var c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * s); c.height = Math.round(img.naturalHeight * s);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        wallRatio = nearestRatio(c.width, c.height);
        c.toBlob(function (b) { b ? resolve(b) : reject(new Error('encode')); }, 'image/jpeg', 0.86);
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode')); };
      img.src = url;
    });
  }

  // Description visuelle de chaque position, telle que la commande existe
  // vraiment (pas la vue 3D) : l'IA dessine la plaque d'apres ce texte et les
  // vraies photos de la finition.
  function deviceLook(s) {
    var c = ctrlFinishLabel(state.controlsFinish).toLowerCase();
    var col = s.outletColor === 'white' ? 'white' : 'black';
    var ins = s.toggleColor === 'white' ? 'white' : 'black';
    var retro = 'a Retro toggle (a smooth round tipped ' + c + ' lever coming out of a small round ' + c + ' bushing, no insert)';
    var knob = 'a round diamond knurled ' + c + ' dimmer knob';
    var knurl = 'a Knurled toggle (a knurled ' + c + ' lever in a small rectangular ' + ins + ' insert)';
    switch (s.device) {
      case 'dimmer_120v': case 'dimmer_3way': case 'dimmer_010v': case 'dimmer_strip': case 'fan_speed': return knob;
      case 'toggle_retro': case 'toggle_retro_4way': return retro;
      case 'toggle_double_retro': return 'two Retro toggles stacked one above the other';
      case 'toggle_knurled_single': case 'toggle_knurled_4way': case 'toggle_knurled': return knurl;
      case 'toggle_double_knurled': return 'two Knurled toggles stacked one above the other';
      case 'toggle_plus_dimmer': return 'a Retro toggle above and ' + knob + ' below it';
      case 'knurled_plus_dimmer': return 'a Knurled toggle above and ' + knob + ' below it';
      case 'toggle_opening': return 'an empty standard toggle slot opening';
      case 'outlet_rocker': return 'an empty rectangular Decora opening';
      case 'outlet_regular': return 'a ' + col + ' duplex outlet in a rectangular Decora opening';
      case 'outlet_usbc': return 'a ' + col + ' outlet with one USB-A and one USB-C port in a rectangular Decora opening';
      case 'outlet_double_usbc': return 'a ' + col + ' module with two USB-C ports in a rectangular Decora opening';
      case 'outlet_gfci': return 'a ' + col + ' GFCI outlet with TEST and RESET buttons in a rectangular Decora opening';
      default: return 'no control, plain plate';
    }
  }
  function plateLayout() {
    return state.slots.slice(0, state.gangCount).map(function (s, i) {
      return 'gang ' + (i + 1) + ': ' + deviceLook(s);
    }).join('; ');
  }

  // Schema plat de la plaque (aucune matiere) : contour aux dimensions reelles,
  // vis, forme et nom de chaque commande. Il donne la disposition a l'IA ; la
  // matiere vient uniquement des vraies photos de la finition.
  var PLATE_W_IN = { 1: 2.80, 2: 4.56, 3: 6.38, 4: 8.30, 5: 10.20 };
  function shortName(s) {
    var d = s.device;
    if (/^dimmer_|^fan_speed$/.test(d)) return 'DIMMER KNOB';
    if (d === 'toggle_retro' || d === 'toggle_retro_4way') return 'RETRO TOGGLE';
    if (d === 'toggle_double_retro') return '2 RETRO TOGGLES';
    if (/^toggle_knurled/.test(d)) return 'KNURLED TOGGLE';
    if (d === 'toggle_double_knurled') return '2 KNURLED TOGGLES';
    if (d === 'toggle_plus_dimmer' || d === 'knurled_plus_dimmer') return 'TOGGLE + KNOB';
    if (d === 'outlet_gfci') return 'GFCI OUTLET';
    if (d === 'outlet_regular') return 'DUPLEX OUTLET';
    if (d === 'outlet_usbc') return 'USB-A + USB-C';
    if (d === 'outlet_double_usbc') return '2 x USB-C';
    if (d === 'outlet_rocker') return 'DECORA OPENING';
    if (d === 'toggle_opening') return 'TOGGLE SLOT';
    return 'BLANK';
  }
  function plateDiagram() {
    var n = state.gangCount, ppi = 110, Wi = PLATE_W_IN[n] || PLATE_W_IN[1], Hi = 4.70;
    var pad = 70, cw = Math.round(Wi * ppi) + pad * 2, chh = Math.round(Hi * ppi) + pad * 2 + 40;
    var c = document.createElement('canvas'); c.width = cw; c.height = chh;
    var g = c.getContext('2d');
    g.fillStyle = '#ffffff'; g.fillRect(0, 0, cw, chh);
    var x0 = pad, y0 = pad, pw = Wi * ppi, ph = Hi * ppi, cy = y0 + ph / 2;
    g.fillStyle = '#d9d9d9'; g.strokeStyle = '#111'; g.lineWidth = 3;
    g.beginPath(); if (g.roundRect) g.roundRect(x0, y0, pw, ph, 8); else g.rect(x0, y0, pw, ph); g.fill(); g.stroke();
    g.font = '600 20px Arial'; g.fillStyle = '#111'; g.textAlign = 'center';
    g.fillText(Wi.toFixed(2) + ' in', x0 + pw / 2, y0 - 22);
    g.save(); g.translate(x0 - 24, cy); g.rotate(-Math.PI / 2); g.fillText('4.70 in', 0, 0); g.restore();
    function screw(x, y) { g.fillStyle = '#fff'; g.beginPath(); g.arc(x, y, 9, 0, 7); g.fill(); g.stroke(); g.beginPath(); g.moveTo(x - 7, y); g.lineTo(x + 7, y); g.stroke(); }
    function knob(x, y, r) { g.fillStyle = '#fff'; g.beginPath(); g.arc(x, y, r, 0, 7); g.fill(); g.stroke(); g.beginPath(); g.arc(x, y, r * 0.55, 0, 7); g.stroke(); }
    function retro(x, y) { g.fillStyle = '#fff'; g.beginPath(); g.arc(x, y, 15, 0, 7); g.fill(); g.stroke(); g.lineWidth = 7; g.beginPath(); g.moveTo(x, y); g.lineTo(x, y - 34); g.stroke(); g.lineWidth = 3; g.beginPath(); g.arc(x, y - 36, 7, 0, 7); g.fillStyle = '#111'; g.fill(); }
    function knurled(x, y) { g.fillStyle = '#555'; g.fillRect(x - 15, y - 28, 30, 56); g.strokeRect(x - 15, y - 28, 30, 56); g.strokeStyle = '#fff'; g.lineWidth = 7; g.beginPath(); g.moveTo(x, y); g.lineTo(x, y - 40); g.stroke(); g.strokeStyle = '#111'; g.lineWidth = 3; }
    function decora(x, y, inner) {
      var w = 1.30 * ppi, h = 2.60 * ppi; g.fillStyle = inner ? '#fff' : '#bdbdbd'; g.fillRect(x - w / 2, y - h / 2, w, h); g.strokeRect(x - w / 2, y - h / 2, w, h);
      g.fillStyle = '#111';
      if (inner === 'duplex' || inner === 'gfci') {
        [-1, 1].forEach(function (k) { var yy = y + k * h * 0.27; g.fillRect(x - 16, yy - 14, 6, 22); g.fillRect(x + 10, yy - 14, 6, 22); g.beginPath(); g.arc(x, yy + 18, 6, Math.PI, 0); g.fill(); });
        if (inner === 'gfci') { g.strokeRect(x - 28, y - 10, 24, 20); g.strokeRect(x + 4, y - 10, 24, 20); }
      } else if (inner === 'usb') { g.fillRect(x - 16, y - h * 0.3, 6, 22); g.fillRect(x + 10, y - h * 0.3, 6, 22); g.fillRect(x - 18, y + 14, 36, 10); g.fillRect(x - 12, y + 40, 24, 8); }
      else if (inner === 'usbc') { g.fillRect(x - 12, y - 20, 24, 8); g.fillRect(x - 12, y + 14, 24, 8); }
    }
    var pitch = n > 1 ? (pw - 2.80 * ppi) / (n - 1) : 0;
    state.slots.slice(0, n).forEach(function (s, i) {
      var x = x0 + 1.40 * ppi + i * pitch, d = s.device;
      screw(x, y0 + 0.30 * ppi); screw(x, y0 + ph - 0.30 * ppi);
      if (/^dimmer_|^fan_speed$/.test(d)) knob(x, cy, 30);
      else if (d === 'toggle_retro' || d === 'toggle_retro_4way') retro(x, cy + 14);
      else if (d === 'toggle_double_retro') { retro(x, cy - 30); retro(x, cy + 70); }
      else if (/^toggle_knurled/.test(d)) knurled(x, cy + 10);
      else if (d === 'toggle_double_knurled') { knurled(x, cy - 50); knurled(x, cy + 60); }
      else if (d === 'toggle_plus_dimmer') { retro(x, cy - 40); knob(x, cy + 70, 28); }
      else if (d === 'knurled_plus_dimmer') { knurled(x, cy - 50); knob(x, cy + 70, 28); }
      else if (d === 'outlet_gfci') decora(x, cy, 'gfci');
      else if (d === 'outlet_regular') decora(x, cy, 'duplex');
      else if (d === 'outlet_usbc') decora(x, cy, 'usb');
      else if (d === 'outlet_double_usbc') decora(x, cy, 'usbc');
      else if (d === 'outlet_rocker') decora(x, cy, null);
      else if (d === 'toggle_opening') { g.fillStyle = '#bdbdbd'; g.fillRect(x - 6, cy - 26, 12, 52); g.strokeRect(x - 6, cy - 26, 12, 52); }
      g.fillStyle = '#111'; g.font = '700 15px Arial';
      g.fillText(shortName(s), x, y0 + ph + 34);
    });
    return new Promise(function (resolve) { c.toBlob(resolve, 'image/png'); });
  }

  function css() {
    if (document.getElementById('sowStyle')) return;
    var st = document.createElement('style'); st.id = 'sowStyle';
    st.textContent = [
      '.sow-bar{position:absolute;left:14px;bottom:14px;z-index:5;display:flex;flex-wrap:wrap;gap:8px}', '.sow-bar.sow-bar--below{position:static;order:0;grid-column:1/-1;justify-content:center;margin:2px 0 4px}', '.sow-bar--below .sow-btn{box-shadow:none;border:1px solid #d8cfbf;padding:9px 13px;font-size:12.5px}', '.sow-btn{display:inline-flex;align-items:center;gap:8px;padding:10px 14px;border:0;border-radius:999px;background:#fff;color:#2b2620;font:500 13px/1 inherit;box-shadow:0 2px 10px rgba(0,0,0,.15);cursor:pointer}',
      '.sow-btn svg{width:16px;height:16px}',
      '.sow-ov{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(20,18,15,.6)}',
      '.sow-box{position:relative;width:100%;max-width:560px;max-height:calc(100vh - 32px);overflow:auto;background:#faf7f1;color:#2b2620;border-radius:14px;padding:22px}',
      '.sow-x{position:absolute;right:10px;top:8px;border:0;background:none;font-size:26px;line-height:1;cursor:pointer;color:#2b2620}',
      '.sow-h{margin:0 0 6px;font-size:19px;font-weight:600}',
      '.sow-p{margin:0 0 14px;font-size:13.5px;line-height:1.5;color:#4a4339}',
      '.sow-drop{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;min-height:150px;border:1.5px dashed #c9b993;border-radius:10px;background:#fff;cursor:pointer;text-align:center;padding:14px;font-size:13.5px}',
      '.sow-drop img{max-width:100%;max-height:260px;border-radius:6px}',
      '.sow-go{display:block;width:100%;margin-top:14px;padding:13px;border:0;border-radius:8px;background:#2b2620;color:#fff;font:600 14px/1 inherit;cursor:pointer}',
      '.sow-go[disabled]{opacity:.45;cursor:not-allowed}',
      '.sow-msg{margin-top:10px;font-size:13px;color:#8a3b2b}',
      '.sow-ov [hidden]{display:none!important}', '.sow-wait{display:flex;align-items:center;gap:10px;margin-top:14px;font-size:13.5px}',
      '.sow-wait i{width:18px;height:18px;border:2px solid #c9b993;border-top-color:#2b2620;border-radius:50%;animation:sowSpin .8s linear infinite}',
      '@keyframes sowSpin{to{transform:rotate(360deg)}}',
      '.sow-res img{display:block;width:100%;border-radius:8px;margin-top:6px}',
      '.sow-row{display:flex;gap:8px;margin-top:10px}.sow-row a,.sow-row button{flex:1;text-align:center;padding:11px;border-radius:8px;border:1px solid #2b2620;background:#fff;color:#2b2620;font:500 13px/1 inherit;text-decoration:none;cursor:pointer}',
      '.sow-note{margin-top:10px;font-size:11.5px;color:#7a7266;line-height:1.45}'
    ].join('');
    document.head.appendChild(st);
  }

  function open() {
    css();
    var ov = document.createElement('div'); ov.className = 'sow-ov';
    ov.innerHTML =
      '<div class="sow-box" role="dialog" aria-modal="true" aria-label="See it on my wall">' +
        '<button type="button" class="sow-x" aria-label="Close">&times;</button>' +
        '<p class="sow-h">See it on your wall</p>' +
        '<p class="sow-p">Upload a photo of your wall, ideally of the switch or outlet you want to replace, taken straight on in good light. We place the plate you just designed on it.</p>' +
        '<label class="sow-drop"><input type="file" accept="image/*" hidden><span class="sow-pick">Tap to choose or take a photo</span></label>' +
        '<button type="button" class="sow-go" disabled>Place my plate on this wall</button>' +
        '<div class="sow-msg" hidden></div>' +
        '<div class="sow-wait" hidden><i></i><span>Placing your plate on your wall, about 20 seconds...</span></div>' +
        '<div class="sow-res" hidden></div>' +
        '<p class="sow-note">AI preview for inspiration: scale and lighting are approximate. Your actual plate is the one described in your configuration. Your photo is only used to create this preview and is deleted within 24 hours.</p>' +
      '</div>';
    document.body.appendChild(ov);
    var $ = function (s) { return ov.querySelector(s); };
    var close = function () { ov.remove(); };
    $('.sow-x').onclick = close;
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    var msg = function (t) { $('.sow-msg').hidden = !t; $('.sow-msg').textContent = t || ''; };

    $('input').onchange = function () {
      var f = this.files && this.files[0]; if (!f) return;
      msg(''); $('.sow-go').disabled = true;
      shrink(f).then(function (b) {
        wallBlob = b;
        var drop = $('.sow-drop'); drop.querySelectorAll('img').forEach(function (i) { i.remove(); });
        var img = new Image(); img.src = URL.createObjectURL(b); drop.insertBefore(img, $('.sow-pick'));
        $('.sow-pick').textContent = 'Change photo';
        $('.sow-go').disabled = false;
      }).catch(function () { msg('We could not read this photo. Please try a JPEG or PNG photo.'); });
    };

    $('.sow-go').onclick = function () {
      if (busy || !wallBlob) return;
      busy = true; msg(''); $('.sow-go').disabled = true; $('.sow-wait').hidden = false; $('.sow-res').hidden = true;
      var done = function (err) { busy = false; $('.sow-wait').hidden = true; $('.sow-go').disabled = false; if (err) msg(err); };
      plateDiagram().then(function (diagram) {
        var fd = new FormData();
        fd.append('wall', wallBlob, 'wall.jpg');
        if (diagram) fd.append('diagram', diagram, 'layout.png');
        fd.append('finishId', state.plateFinish);
        fd.append('finish', plateFinishLabel(state.plateFinish));
        fd.append('controls', ctrlFinishLabel(state.controlsFinish));
        fd.append('gangs', String(state.gangCount));
        fd.append('layout', plateLayout());
        fd.append('ratio', wallRatio);
        return fetch(SC_PREVIEW_ENDPOINT + '/wall', { method: 'POST', body: fd }).then(function (r) { return r.json(); });
      }).then(function (j) {
        if (!j || !j.success || !j.task) throw new Error('create');
        var t0 = Date.now();
        return new Promise(function (resolve, reject) {
          (function poll() {
            fetch(SC_PREVIEW_ENDPOINT + '/wall/status?task=' + encodeURIComponent(j.task)).then(function (r) { return r.json(); }).then(function (s) {
              if (s && s.state === 'success' && s.url) return resolve(s.url);
              if (s && s.state === 'fail') return reject(new Error('fail'));
              if (Date.now() - t0 > TIMEOUT_MS) return reject(new Error('timeout'));
              setTimeout(poll, POLL_MS);
            }).catch(function () { if (Date.now() - t0 > TIMEOUT_MS) reject(new Error('timeout')); else setTimeout(poll, POLL_MS); });
          })();
        });
      }).then(function (url) {
        var res = $('.sow-res');
        res.innerHTML = '<img alt="Your plate on your wall"><div class="sow-row"><a target="_blank" rel="noopener">Open full size</a><button type="button">Try again</button></div>';
        res.querySelector('img').src = url; res.querySelector('a').href = url;
        res.querySelector('button').onclick = function () { $('.sow-go').click(); };
        res.hidden = false; done('');
        res.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }).catch(function (e) {
        console.warn('[See on wall]', e);
        done('Sorry, the preview could not be created this time. Please try again in a moment, or with another photo.');
      });
    };
  }

  function mount() {
    var wrap = document.getElementById('canvasWrap');
    if (!wrap || document.querySelector('.sow-btn') || !SC_PREVIEW_ENDPOINT) return !!wrap;
    css();
    if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
    var b = document.createElement('button'); b.type = 'button'; b.className = 'sow-btn';
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="10" r="2"/><path d="M21 16l-5-5-8 8"/></svg>See it on my wall';
    b.onclick = function () { if (typeof renderer === 'undefined' || !renderer) return; open(); };
    // Enregistrer l'image de la configuration en JPG (2000 px, rendu haute definition).
    var d = document.createElement('button'); d.type = 'button'; d.className = 'sow-btn sow-save';
    d.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 4v11"/><path d="M7 10l5 5 5-5"/><path d="M5 20h14"/></svg>Save image';
    d.onclick = function () {
      if (typeof renderer === 'undefined' || !renderer || d.disabled) return;
      d.disabled = true;
      capturePlateBlob('image/jpeg', 2000, 0.95).then(function (blob) {
        if (!blob) return;
        var name = ['studio-timeless', state.gangCount + '-gang', plateFinishLabel(state.plateFinish)].join('-')
          .toLowerCase().replace(/\([^)]*\)/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') + '.jpg';
        var url = URL.createObjectURL(blob), a = document.createElement('a');
        a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
      }).catch(function (e) { console.warn('[Save image]', e); }).then(function () { d.disabled = false; });
    };
    var bar = document.createElement('div'); bar.className = 'sow-bar';
    bar.appendChild(b); bar.appendChild(d);
    // Sur mobile, les boutons masquaient la simulation : ils passent sous la
    // vue 3D au lieu d'etre poses dessus.
    var mq = window.matchMedia('(max-width: 900px)');
    function placeBar() {
      if (mq.matches) { bar.classList.add('sow-bar--below'); wrap.parentNode.insertBefore(bar, wrap.nextSibling); }
      else { bar.classList.remove('sow-bar--below'); wrap.appendChild(bar); }
    }
    placeBar();
    if (mq.addEventListener) mq.addEventListener('change', placeBar); else if (mq.addListener) mq.addListener(placeBar);
    return true;
  }
  if (!mount()) document.addEventListener('DOMContentLoaded', mount);
})();

// Lien vers le comparateur de finitions, sous la grille des finitions de plaque.
(function addCompareLink() {
  function put() {
    var grid = document.getElementById('plateFinishGrid');
    if (!grid || document.getElementById('fcLink')) return !!grid;
    var a = document.createElement('a');
    a.id = 'fcLink'; a.href = '/pages/compare-finishes'; a.target = '_blank'; a.rel = 'noopener';
    a.textContent = 'Compare all finishes side by side';
    a.style.cssText = 'display:inline-block;margin-top:10px;font-size:12.5px;color:#2b2620;text-decoration:underline;text-underline-offset:3px';
    grid.parentNode.insertBefore(a, grid.nextSibling);
    return true;
  }
  if (!put()) document.addEventListener('DOMContentLoaded', put);
})();
